import { Link } from "react-router-dom";
import {
  formatFileSize,
  renderNavigator,
  renderNavigatorByName,
  renderNavigatorView,
  renderOrderIdNavigator,
  toLocalDate,
  renderOrderIdNavigatorNumber,
  renderProjectIdNavigator,
  renderViewNavigator,
  renderRevenueNavigator,
  renderTAbNavigator,
  renderSearchNavigator,
  renderRevenueNavigatorWithID,
  renderNavigatorTranID,
  renderBillNavigator,
  renderAppliedNavigator,
  ListrenderNavigatorByName,
  renderNavigatorBySavedReport,
} from "./grid-value-formatters";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Button } from "@mui/material";
import { createSlug } from "./slug-config";
import DownloadIcon from "@mui/icons-material/Download";

function slugNavigator({ value }) {
  return <Link to={`${createSlug(value)}`}>{value}</Link>;
}
function dateFilter(value) {
  return new Date(value.value).toLocaleDateString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}

// global
export const globalSearch = [
  {
    headerName: "View",
    resizable: true,
    field: "documentno",
    cellRenderer: (params) => {
      return (
        <Link
          to={`/transaction-type/${params?.data?.linkingname}/${params?.data?.id}`}
          className={"ag-cell-view-button"}
        >
          {"View"}
        </Link>
      );
    },

    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Internal Id",
    resizable: true,
    field: "id",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Transaction type",
    resizable: true,
    sortable: true,
    field: "transactiontype",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Document Number",
    resizable: true,
    field: "documentnumber",
    minWidth: 140,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Pc project",
    resizable: true,
    field: "pc_project",
    minWidth: 300,
  },
  {
    headerName: "Subsidiary",
    resizable: true,
    field: "subsidiary",
    minWidth: 140,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Customer",
    resizable: true,
    field: "customer",
    minWidth: 240,
  },
  {
    headerName: "Vendor",
    resizable: true,
    field: "vendor",
    minWidth: 240,
  },
  {
    headerName: "Employee",
    resizable: true,
    field: "employee",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];

/*----------------bill credit Table-------------------*/
export const transactionTypeDetailOther = [
  {
    headerName: "View",
    resizable: true,
    field: "documentno",
    cellRenderer: renderNavigator,
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Internal Id",
    resizable: true,
    field: "id",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Date",
    resizable: true,
    sortable: true,
    field: "date",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Document Number",
    resizable: true,
    field: "documentno",
    minWidth: 140,
    sortable: true,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Name",
    resizable: true,
    field: "name",
    minWidth: 300,
  },

  {
    headerName: "Subsidiary",
    resizable: true,
    field: "subsidiary",
    minWidth: 140,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Account",
    resizable: true,
    field: "account",
    minWidth: 240,
  },
  // {
  //   headerName: "PC/PROJECT",
  //   field: "pc_project",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   minWidth: 350,
  // },
  {
    headerName: "PO/Check Number",
    resizable: true,
    field: "po",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Status",
    resizable: true,
    field: "status",
    minWidth: 100,
  },
  {
    headerName: "Memo",
    resizable: true,
    field: "memo",
    minWidth: 300,
  },
  {
    headerName: "Currency",
    resizable: true,
    field: "currency",
    minWidth: 100,
  },
  {
    headerName: "Amount (Foreign Currency)",
    resizable: true,
    field: "amount_foreign",
    minWidth: 200,
  },
  {
    headerName: "Amount",
    resizable: true,
    field: "amount",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Posting",
    resizable: true,
    field: "posting",
    minWidth: 100,
  },
  {
    headerName: "Email Sent",
    resizable: true,
    field: "email_sent",
    minWidth: 100,
  },
  {
    headerName: "Do Not Send Email",
    resizable: true,
    field: "do_not_send_email",
    minWidth: 100,
  },
  {
    headerName: "Expense Report Status",
    resizable: true,
    field: "expense_report_status",
    minWidth: 150,
  },
  {
    headerName: "NSC PO Number",
    resizable: true,
    field: "nsc_po_number",
    minWidth: 150,
  },
  {
    headerName: "Preferred Entity Bank",
    resizable: true,
    field: "preferred_entity_bank",
    minWidth: 150,
  },
  {
    headerName: "Vendor Bank Fees",
    resizable: true,
    field: "vendor_bank_fees",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Bank Fee",
    resizable: true,
    field: "bank_fee",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Created By",
    resizable: true,
    field: "created_by",
    minWidth: 150,
  },
  {
    headerName: "Vendor Bill Approval Status",
    resizable: true,
    field: "vendor_bill_approval_status",
    minWidth: 200,
  },
  {
    headerName: "Entity Bank (Vendor)",
    resizable: true,
    field: "entity_bank_vendor",
    minWidth: 150,
  },
  {
    headerName: "Entity Bank (Employee)",
    resizable: true,
    field: "entity_bank_employee",
    minWidth: 150,
  },
  {
    headerName: "Exclude from Electronic Bank Payments Processing",
    resizable: true,
    field: "exclude_from_ebp_processing",
    minWidth: 300,
  },
  {
    headerName: "Entity Bank (Customer)",
    resizable: true,
    field: "entity_bank_customer",
    minWidth: 150,
  },
  {
    headerName: "Entity Bank (Customer Credit)",
    resizable: true,
    field: "entity_bank_customer_credit",
    minWidth: 200,
  },
  {
    headerName: "Invoice Resend Email",
    resizable: true,
    field: "invoice_resend_email",
    minWidth: 150,
  },
  {
    headerName: "Invoice Additional Attachments",
    resizable: true,
    field: "invoice_additional_attachments",
    minWidth: 200,
  },
];

//itemfullfilment table
export const transactionTypeItemFullfillmenttable = [
  {
    headerName: "View",
    resizable: true,
    field: "documentno",
    cellRenderer: renderNavigator,
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Internal Id",
    resizable: true,
    field: "id",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Date",
    resizable: true,
    sortable: true,
    field: "date",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Document Number",
    resizable: true,
    field: "documentno",
    minWidth: 140,
    sortable: true,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Name",
    resizable: true,
    field: "name",
    minWidth: 300,
  },

  {
    headerName: "Subsidiary",
    resizable: true,
    field: "subsidiary",
    minWidth: 140,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Account",
    resizable: true,
    field: "account",
    minWidth: 240,
  },
  {
    headerName: "PC/PROJECT",
    field: "pc_project",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    minWidth: 350,
  },
  {
    headerName: "PO/Check Number",
    resizable: true,
    field: "po",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Status",
    resizable: true,
    field: "status",
    minWidth: 100,
  },
  {
    headerName: "Memo",
    resizable: true,
    field: "memo",
    minWidth: 300,
  },
  {
    headerName: "Currency",
    resizable: true,
    field: "currency",
    minWidth: 100,
  },
  {
    headerName: "Amount (Foreign Currency)",
    resizable: true,
    field: "amount_foreign",
    minWidth: 200,
  },
  {
    headerName: "Amount",
    resizable: true,
    field: "amount",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Posting",
    resizable: true,
    field: "posting",
    minWidth: 100,
  },
  {
    headerName: "Email Sent",
    resizable: true,
    field: "email_sent",
    minWidth: 100,
  },
  {
    headerName: "Do Not Send Email",
    resizable: true,
    field: "do_not_send_email",
    minWidth: 100,
  },
  {
    headerName: "Expense Report Status",
    resizable: true,
    field: "expense_report_status",
    minWidth: 150,
  },
  {
    headerName: "NSC PO Number",
    resizable: true,
    field: "nsc_po_number",
    minWidth: 150,
  },
  {
    headerName: "Preferred Entity Bank",
    resizable: true,
    field: "preferred_entity_bank",
    minWidth: 150,
  },
  {
    headerName: "Vendor Bank Fees",
    resizable: true,
    field: "vendor_bank_fees",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Bank Fee",
    resizable: true,
    field: "bank_fee",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Created By",
    resizable: true,
    field: "created_by",
    minWidth: 150,
  },
  {
    headerName: "Vendor Bill Approval Status",
    resizable: true,
    field: "vendor_bill_approval_status",
    minWidth: 200,
  },
  {
    headerName: "Entity Bank (Vendor)",
    resizable: true,
    field: "entity_bank_vendor",
    minWidth: 150,
  },
  {
    headerName: "Entity Bank (Employee)",
    resizable: true,
    field: "entity_bank_employee",
    minWidth: 150,
  },
  {
    headerName: "Exclude from Electronic Bank Payments Processing",
    resizable: true,
    field: "exclude_from_ebp_processing",
    minWidth: 300,
  },
  {
    headerName: "Entity Bank (Customer)",
    resizable: true,
    field: "entity_bank_customer",
    minWidth: 150,
  },
  {
    headerName: "Entity Bank (Customer Credit)",
    resizable: true,
    field: "entity_bank_customer_credit",
    minWidth: 200,
  },
  {
    headerName: "Invoice Resend Email",
    resizable: true,
    field: "invoice_resend_email",
    minWidth: 150,
  },
  {
    headerName: "Invoice Additional Attachments",
    resizable: true,
    field: "invoice_additional_attachments",
    minWidth: 200,
  },
];
// credit card table
export const transactionTypeCreditCardTable = [
  {
    headerName: "View",
    resizable: true,
    field: "documentno",
    cellRenderer: renderNavigator,
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Internal Id",
    resizable: true,
    field: "id",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Date",
    resizable: true,
    sortable: true,
    field: "date",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Document Number",
    resizable: true,
    field: "documentno",
    minWidth: 140,
    sortable: true,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Name",
    resizable: true,
    field: "name",
    minWidth: 300,
  },
  {
    headerName: "Pc project",
    resizable: true,
    field: "pc_project",
    minWidth: 350,
  },
  {
    headerName: "Subsidiary",
    resizable: true,
    field: "subsidiary",
    minWidth: 140,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Account",
    resizable: true,
    field: "account",
    minWidth: 240,
  },
  {
    headerName: "PO/Check Number",
    resizable: true,
    field: "po",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Status",
    resizable: true,
    field: "status",
    minWidth: 100,
  },
  {
    headerName: "Memo",
    resizable: true,
    field: "memo",
    minWidth: 300,
  },
  {
    headerName: "Currency",
    resizable: true,
    field: "currency",
    minWidth: 100,
  },
  {
    headerName: "Amount (Foreign Currency)",
    resizable: true,
    field: "amount_foreign",
    minWidth: 200,
  },
  {
    headerName: "Amount",
    resizable: true,
    field: "amount",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Posting",
    resizable: true,
    field: "posting",
    minWidth: 100,
  },
  {
    headerName: "Email Sent",
    resizable: true,
    field: "email_sent",
    minWidth: 100,
  },
  {
    headerName: "Do Not Send Email",
    resizable: true,
    field: "do_not_send_email",
    minWidth: 100,
  },
  {
    headerName: "Expense Report Status",
    resizable: true,
    field: "expense_report_status",
    minWidth: 150,
  },
  {
    headerName: "NSC PO Number",
    resizable: true,
    field: "nsc_po_number",
    minWidth: 150,
  },
  {
    headerName: "Preferred Entity Bank",
    resizable: true,
    field: "preferred_entity_bank",
    minWidth: 150,
  },
  {
    headerName: "Vendor Bank Fees",
    resizable: true,
    field: "vendor_bank_fees",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Bank Fee",
    resizable: true,
    field: "bank_fee",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Created By",
    resizable: true,
    field: "created_by",
    minWidth: 150,
  },
  {
    headerName: "Vendor Bill Approval Status",
    resizable: true,
    field: "vendor_bill_approval_status",
    minWidth: 200,
  },
  {
    headerName: "Entity Bank (Vendor)",
    resizable: true,
    field: "entity_bank_vendor",
    minWidth: 150,
  },
  {
    headerName: "Entity Bank (Employee)",
    resizable: true,
    field: "entity_bank_employee",
    minWidth: 150,
  },
  {
    headerName: "Exclude from Electronic Bank Payments Processing",
    resizable: true,
    field: "exclude_from_ebp_processing",
    minWidth: 300,
  },
  {
    headerName: "Entity Bank (Customer)",
    resizable: true,
    field: "entity_bank_customer",
    minWidth: 150,
  },
  {
    headerName: "Entity Bank (Customer Credit)",
    resizable: true,
    field: "entity_bank_customer_credit",
    minWidth: 200,
  },
  {
    headerName: "Invoice Resend Email",
    resizable: true,
    field: "invoice_resend_email",
    minWidth: 150,
  },
  {
    headerName: "Invoice Additional Attachments",
    resizable: true,
    field: "invoice_additional_attachments",
    minWidth: 200,
  },
];
// cash sale table
export const transactionTypeCashsaleDetails = [
  {
    headerName: "View",
    resizable: true,
    field: "documentno",
    cellRenderer: renderNavigator,
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Internal Id",
    resizable: true,
    field: "id",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Date",
    resizable: true,
    sortable: true,
    field: "date",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Document Number",
    resizable: true,
    field: "documentno",
    minWidth: 140,
    sortable: true,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Name",
    resizable: true,
    field: "name",
    minWidth: 300,
  },
  {
    headerName: "Pc project",
    resizable: true,
    field: "pc_project",
    minWidth: 300,
  },

  {
    headerName: "Account",
    resizable: true,
    field: "account",
    minWidth: 240,
  },
  {
    headerName: "Subsidiary",
    resizable: true,
    field: "subsidiary",
    minWidth: 140,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "PO/Check Number",
    resizable: true,
    field: "po",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Status",
    resizable: true,
    field: "status",
    minWidth: 100,
  },
  {
    headerName: "Memo",
    resizable: true,
    field: "memo",
    minWidth: 300,
  },
  {
    headerName: "Currency",
    resizable: true,
    field: "currency",
    minWidth: 100,
  },
  {
    headerName: "Amount (Foreign Currency)",
    resizable: true,
    field: "amount_foreign",
    minWidth: 200,
  },
  {
    headerName: "Amount",
    resizable: true,
    field: "amount",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Posting",
    resizable: true,
    field: "posting",
    minWidth: 100,
  },
  {
    headerName: "Email Sent",
    resizable: true,
    field: "email_sent",
    minWidth: 100,
  },
  {
    headerName: "Do Not Send Email",
    resizable: true,
    field: "do_not_send_email",
    minWidth: 100,
  },
  {
    headerName: "Expense Report Status",
    resizable: true,
    field: "expense_report_status",
    minWidth: 150,
  },
  {
    headerName: "NSC PO Number",
    resizable: true,
    field: "nsc_po_number",
    minWidth: 150,
  },
  {
    headerName: "Preferred Entity Bank",
    resizable: true,
    field: "preferred_entity_bank",
    minWidth: 150,
  },
  {
    headerName: "Vendor Bank Fees",
    resizable: true,
    field: "vendor_bank_fees",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Bank Fee",
    resizable: true,
    field: "bank_fee",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Created By",
    resizable: true,
    field: "created_by",
    minWidth: 150,
  },
  {
    headerName: "Vendor Bill Approval Status",
    resizable: true,
    field: "vendor_bill_approval_status",
    minWidth: 200,
  },
  {
    headerName: "Entity Bank (Vendor)",
    resizable: true,
    field: "entity_bank_vendor",
    minWidth: 150,
  },
  {
    headerName: "Entity Bank (Employee)",
    resizable: true,
    field: "entity_bank_employee",
    minWidth: 150,
  },
  {
    headerName: "Exclude from Electronic Bank Payments Processing",
    resizable: true,
    field: "exclude_from_ebp_processing",
    minWidth: 300,
  },
  {
    headerName: "Entity Bank (Customer)",
    resizable: true,
    field: "entity_bank_customer",
    minWidth: 150,
  },
  {
    headerName: "Entity Bank (Customer Credit)",
    resizable: true,
    field: "entity_bank_customer_credit",
    minWidth: 200,
  },
  {
    headerName: "Invoice Resend Email",
    resizable: true,
    field: "invoice_resend_email",
    minWidth: 150,
  },
  {
    headerName: "Invoice Additional Attachments",
    resizable: true,
    field: "invoice_additional_attachments",
    minWidth: 200,
  },
];
/*----------------bill payment Table-------------------*/
export const transactionTypeBillPayment = [
  {
    headerName: "View",
    resizable: true,
    field: "documentno",
    cellRenderer: renderNavigator,
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Internal Id",
    resizable: true,
    field: "id",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Date",
    resizable: true,
    sortable: true,
    field: "date",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Document Number",
    resizable: true,
    field: "documentno",
    minWidth: 140,
    headerClass: "justify-right",
    sortable: true,
    cellClass: " text-right",
  },
  {
    headerName: "Transaction Number",
    resizable: true,
    field: "transactionno",
    minWidth: 140,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Name",
    resizable: true,
    field: "name",
    minWidth: 240,
  },
  {
    headerName: "Pc project",
    resizable: true,
    field: "pc_project",
    minWidth: 300,
  },
  {
    headerName: "Subsidiary",
    resizable: true,
    field: "subsidiary",
    minWidth: 140,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Account",
    resizable: true,
    field: "account",
    minWidth: 400,
  },
  {
    headerName: "PO/Check Number",
    resizable: true,
    field: "po",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Status",
    resizable: true,
    field: "status",
    minWidth: 100,
  },
  {
    headerName: "Memo",
    resizable: true,
    field: "memo",
    minWidth: 100,
  },
  {
    headerName: "Currency",
    resizable: true,
    field: "currency",
    minWidth: 100,
  },
  {
    headerName: "Amount (Foreign Currency)",
    resizable: true,
    field: "amount_foreign",
    minWidth: 200,
  },
  {
    headerName: "Amount",
    resizable: true,
    field: "amount",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Posting",
    resizable: true,
    field: "posting",
    minWidth: 100,
  },
  {
    headerName: "Email Sent",
    resizable: true,
    field: "email_sent",
    minWidth: 100,
  },
  {
    headerName: "Do Not Send Email",
    resizable: true,
    field: "do_not_send_email",
    minWidth: 100,
  },
  {
    headerName: "Expense Report Status",
    resizable: true,
    field: "expense_report_status",
    minWidth: 150,
  },
  {
    headerName: "NSC PO Number",
    resizable: true,
    field: "nsc_po_number",
    minWidth: 150,
  },
  {
    headerName: "Preferred Entity Bank",
    resizable: true,
    field: "preferred_entity_bank",
    minWidth: 150,
  },
  {
    headerName: "Vendor Bank Fees",
    resizable: true,
    field: "vendor_bank_fees",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Bank Fee",
    resizable: true,
    field: "bank_fee",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Created By",
    resizable: true,
    field: "created_by",
    minWidth: 150,
  },
  {
    headerName: "Vendor Bill Approval Status",
    resizable: true,
    field: "vendor_bill_approval_status",
    minWidth: 200,
  },
  {
    headerName: "Entity Bank (Vendor)",
    resizable: true,
    field: "entity_bank_vendor",
    minWidth: 150,
  },
  {
    headerName: "Entity Bank (Employee)",
    resizable: true,
    field: "entity_bank_employee",
    minWidth: 150,
  },
  {
    headerName: "Exclude from Electronic Bank Payments Processing",
    resizable: true,
    field: "exclude_from_ebp_processing",
    minWidth: 300,
  },
  {
    headerName: "Entity Bank (Customer)",
    resizable: true,
    field: "entity_bank_customer",
    minWidth: 150,
  },
  {
    headerName: "Entity Bank (Customer Credit)",
    resizable: true,
    field: "entity_bank_customer_credit",
    minWidth: 200,
  },
  {
    headerName: "Invoice Resend Email",
    resizable: true,
    field: "invoice_resend_email",
    minWidth: 150,
  },
  {
    headerName: "Invoice Additional Attachments",
    resizable: true,
    field: "invoice_additional_attachments",
    minWidth: 200,
  },
];
/*----------------Check Table-------------------*/
export const transactionTypeCheck = [
  {
    headerName: "View",
    resizable: true,
    field: "documentno",
    cellRenderer: renderNavigator,
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Internal Id",
    resizable: true,
    field: "id",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Date",
    resizable: true,
    sortable: true,
    field: "date",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Document Number",
    resizable: true,
    field: "documentno",
    minWidth: 140,
    headerClass: "justify-right",
    sortable: true,
    cellClass: " text-right",
  },
  {
    headerName: "Transaction Number",
    resizable: true,
    field: "transactionno",
    minWidth: 140,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Name",
    resizable: true,
    field: "name",
    minWidth: 240,
  },
  {
    headerName: "Pc project",
    resizable: true,
    field: "pc_project",
    minWidth: 300,
  },
  {
    headerName: "Subsidiary",
    resizable: true,
    field: "subsidiary",
    minWidth: 140,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Account",
    resizable: true,
    field: "account",
    minWidth: 350,
  },

  {
    headerName: "Currency",
    resizable: true,
    field: "currency",
    minWidth: 100,
  },
  {
    headerName: "Amount (Foreign Currency)",
    resizable: true,
    field: "amount_foreign",
    minWidth: 200,
  },
  {
    headerName: "Amount",
    resizable: true,
    field: "amount",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Posting",
    resizable: true,
    field: "posting",
    minWidth: 100,
  },
  {
    headerName: "PO/Check Number",
    resizable: true,
    field: "po",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Status",
    resizable: true,
    field: "status",
    minWidth: 100,
  },
  {
    headerName: "Memo",
    resizable: true,
    field: "memo",
    minWidth: 100,
  },
  {
    headerName: "Email Sent",
    resizable: true,
    field: "email_sent",
    minWidth: 100,
  },
  {
    headerName: "Do Not Send Email",
    resizable: true,
    field: "do_not_send_email",
    minWidth: 100,
  },
  {
    headerName: "Expense Report Status",
    resizable: true,
    field: "expense_report_status",
    minWidth: 150,
  },
  {
    headerName: "NSC PO Number",
    resizable: true,
    field: "nsc_po_number",
    minWidth: 150,
  },
  {
    headerName: "Preferred Entity Bank",
    resizable: true,
    field: "preferred_entity_bank",
    minWidth: 150,
  },
  {
    headerName: "Vendor Bank Fees",
    resizable: true,
    field: "vendor_bank_fees",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Bank Fee",
    resizable: true,
    field: "bank_fee",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Created By",
    resizable: true,
    field: "created_by",
    minWidth: 150,
  },
  {
    headerName: "Vendor Bill Approval Status",
    resizable: true,
    field: "vendor_bill_approval_status",
    minWidth: 200,
  },
  {
    headerName: "Entity Bank (Vendor)",
    resizable: true,
    field: "entity_bank_vendor",
    minWidth: 150,
  },
  {
    headerName: "Entity Bank (Employee)",
    resizable: true,
    field: "entity_bank_employee",
    minWidth: 150,
  },
  {
    headerName: "Exclude from Electronic Bank Payments Processing",
    resizable: true,
    field: "exclude_from_ebp_processing",
    minWidth: 300,
  },
  {
    headerName: "Entity Bank (Customer)",
    resizable: true,
    field: "entity_bank_customer",
    minWidth: 150,
  },
  {
    headerName: "Entity Bank (Customer Credit)",
    resizable: true,
    field: "entity_bank_customer_credit",
    minWidth: 200,
  },
  {
    headerName: "Invoice Resend Email",
    resizable: true,
    field: "invoice_resend_email",
    minWidth: 150,
  },
  {
    headerName: "Invoice Additional Attachments",
    resizable: true,
    field: "invoice_additional_attachments",
    minWidth: 200,
  },
];
export const allTransactionTypeDetail = [
  // {
  //   headerName: "View",
  //   resizable: true,
  //   field: "documentno",
  //   cellRenderer: renderNavigatorView,
  //   headerClass: "justify-center",
  //   cellClass: " text-center",
  //   minWidth: 100,
  // },
  {
    headerName: "Internal Id",
    resizable: true,
    field: "id",
    minWidth: 100,
  },
  {
    headerName: "Date",
    resizable: true,
    sortable: true,
    field: "date",
    minWidth: 100,
  },
  // {
  //   headerName: "Print",
  //   resizable: true,
  //   field: "",
  //   minWidth: 100,
  // },
  // {
  //   headerName: "Type",
  //   resizable: true,
  //   field: "",
  //   minWidth: 100,
  // },
  // {
  //   headerName: "Payroll Batch",
  //   resizable: true,
  //   field: "",
  //   minWidth: 140,
  // },
  {
    headerName: "Document Number",
    resizable: true,
    field: "documentno",
    sortable: true,
    minWidth: 140,
  },
  {
    headerName: "Transaction Type",
    resizable: true,
    field: "type",
    minWidth: 140,
  },
  // {
  //   headerName: "Transaction Number",
  //   resizable: true,
  //   field: "",
  //   minWidth: 160,
  //   headerClass: "justify-right",
  //   cellClass: " text-right",
  // },
  {
    headerName: "Name",
    resizable: true,
    field: "name",
    minWidth: 240,
  },
  {
    headerName: "Subsidiary",
    resizable: true,
    field: "subsidiary",
    minWidth: 150,
  },
  {
    headerName: "Account",
    resizable: true,
    field: "account",
    minWidth: 140,
  },
  {
    headerName: "PO/Check Number",
    resizable: true,
    field: "po",
    minWidth: 150,
  },
  {
    headerName: "Status",
    resizable: true,
    field: "status",
    minWidth: 160,
  },
  // {
  //   headerName: "Tracking Numbers",
  //   resizable: true,
  //   field: "",
  //   minWidth: 140,
  // },
  {
    headerName: "Memo",
    resizable: true,
    field: "memo",
    minWidth: 240,
  },
  {
    headerName: "Currency",
    resizable: true,
    field: "currency",
    minWidth: 100,
  },
  {
    headerName: "Amount (Foreign Currency)",
    resizable: true,
    field: "amount_foreign",
    minWidth: 200,
  },
  {
    headerName: "Amount",
    resizable: true,
    field: "amount",
    minWidth: 100,
  },
  // {
  //   headerName: "Transaction Units",
  //   resizable: true,
  //   field: "region",
  //   minWidth: 140,
  // },
  {
    headerName: "Posting",
    resizable: true,
    field: "posting",
    minWidth: 100,
  },
];
export const transactionTypeBillCreditTable = [
  {
    headerName: "View",
    resizable: true,
    field: "documentno",
    cellRenderer: renderNavigator,
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Internal Id",
    resizable: true,
    field: "id",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Date",
    resizable: true,
    sortable: true,
    field: "date",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Document Number",
    resizable: true,
    field: "documentno",
    minWidth: 140,
    headerClass: "justify-right",
    sortable: true,
    cellClass: " text-right",
  },
  {
    headerName: "Transaction Number",
    resizable: true,
    field: "transactionno",
    minWidth: 140,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Name",
    resizable: true,
    field: "name",
    minWidth: 240,
  },
  {
    headerName: "PC/PROJECT",
    resizable: true,
    field: "pc_project",
    minWidth: 250,
  },
  {
    headerName: "Subsidiary",
    resizable: true,
    field: "subsidiary",
    minWidth: 140,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Account",
    resizable: true,
    field: "account",
    minWidth: 400,
  },
  {
    headerName: "PO/Check Number",
    resizable: true,
    field: "po",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Status",
    resizable: true,
    field: "status",
    minWidth: 100,
  },
  {
    headerName: "Memo",
    resizable: true,
    field: "memo",
    minWidth: 100,
  },
  {
    headerName: "Currency",
    resizable: true,
    field: "currency",
    minWidth: 100,
  },
  {
    headerName: "Amount (Foreign Currency)",
    resizable: true,
    field: "amount_foreign",
    minWidth: 200,
  },
  {
    headerName: "Amount",
    resizable: true,
    field: "amount",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Posting",
    resizable: true,
    field: "posting",
    minWidth: 100,
  },
  {
    headerName: "Email Sent",
    resizable: true,
    field: "email_sent",
    minWidth: 100,
  },
  {
    headerName: "Do Not Send Email",
    resizable: true,
    field: "do_not_send_email",
    minWidth: 100,
  },
  {
    headerName: "Expense Report Status",
    resizable: true,
    field: "expense_report_status",
    minWidth: 150,
  },
  {
    headerName: "NSC PO Number",
    resizable: true,
    field: "nsc_po_number",
    minWidth: 150,
  },
  {
    headerName: "Preferred Entity Bank",
    resizable: true,
    field: "preferred_entity_bank",
    minWidth: 150,
  },
  {
    headerName: "Vendor Bank Fees",
    resizable: true,
    field: "vendor_bank_fees",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Bank Fee",
    resizable: true,
    field: "bank_fee",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Created By",
    resizable: true,
    field: "created_by",
    minWidth: 150,
  },
  {
    headerName: "Vendor Bill Approval Status",
    resizable: true,
    field: "vendor_bill_approval_status",
    minWidth: 200,
  },
  {
    headerName: "Entity Bank (Vendor)",
    resizable: true,
    field: "entity_bank_vendor",
    minWidth: 150,
  },
  {
    headerName: "Entity Bank (Employee)",
    resizable: true,
    field: "entity_bank_employee",
    minWidth: 150,
  },
  {
    headerName: "Exclude from Electronic Bank Payments Processing",
    resizable: true,
    field: "exclude_from_ebp_processing",
    minWidth: 300,
  },
  {
    headerName: "Entity Bank (Customer)",
    resizable: true,
    field: "entity_bank_customer",
    minWidth: 150,
  },
  {
    headerName: "Entity Bank (Customer Credit)",
    resizable: true,
    field: "entity_bank_customer_credit",
    minWidth: 200,
  },
  {
    headerName: "Invoice Resend Email",
    resizable: true,
    field: "invoice_resend_email",
    minWidth: 150,
  },
  {
    headerName: "Invoice Additional Attachments",
    resizable: true,
    field: "invoice_additional_attachments",
    minWidth: 200,
  },
];
export const transactionRevenueArrangementTable = [
  {
    headerName: "View",
    resizable: true,
    field: "documentno",
    cellRenderer: renderNavigator,
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Internal Id",
    resizable: true,
    field: "id",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Date",
    resizable: true,
    sortable: true,
    field: "date",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  // {
  //   headerName: "Print",
  //   resizable: true,
  //   field: "",
  //   minWidth: 100,
  // },
  // {
  //   headerName: "Type",
  //   resizable: true,
  //   field: "",
  //   minWidth: 100,
  // },
  // {
  //   headerName: "Payroll Batch",
  //   resizable: true,
  //   field: "",
  //   minWidth: 140,
  // },
  {
    headerName: "Document Number",
    resizable: true,
    field: "documentno",
    minWidth: 140,
    headerClass: "justify-right",
    sortable: true,
    cellClass: " text-right",
  },
  // {
  //   headerName: "Transaction Number",
  //   resizable: true,
  //   field: "",
  //   minWidth: 160,
  //   headerClass: "justify-right",
  //   cellClass: " text-right",
  // },
  {
    headerName: "Name",
    resizable: true,
    field: "name",
    minWidth: 140,
  },
  {
    headerName: "Subsidiary",
    resizable: true,
    field: "subsidiary",
    minWidth: 140,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Account",
    resizable: true,
    field: "account",
    minWidth: 140,
  },
  {
    headerName: "PO/Check Number",
    resizable: true,
    field: "po",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Status",
    resizable: true,
    field: "status",
    minWidth: 100,
  },

  {
    headerName: "Customer",
    resizable: true,
    field: "customer",
    minWidth: 140,
  },
  {
    headerName: "Memo",
    resizable: true,
    field: "memo",
    minWidth: 100,
  },
  {
    headerName: "Currency",
    resizable: true,
    field: "currency",
    minWidth: 100,
  },
  // {
  //   headerName: "Amount (Foreign Currency)",
  //   resizable: true,
  //   field: "amount_foreign",
  //   minWidth: 200,
  // },
  {
    headerName: "Amount",
    resizable: true,
    field: "amount",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },

  // {
  //   headerName: "Transaction Units",
  //   resizable: true,
  //   field: "region",
  //   minWidth: 140,
  // },
  {
    headerName: "Posting",
    resizable: true,
    field: "posting",
    minWidth: 100,
  },
];
/*----------------Sales Order Table-------------------*/
export const transactionTypeDetailSalesOrder = [
  {
    headerName: "View",
    resizable: true,
    field: "documentno",
    cellRenderer: renderNavigator,
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Internal Id",
    resizable: true,
    field: "id",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Date",
    resizable: true,
    sortable: true,
    field: "date",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  // {
  //   headerName: "Print",
  //   resizable: true,
  //   field: "print",
  //   minWidth: 100,
  // },
  {
    headerName: "Type",
    resizable: true,
    field: "type",
    minWidth: 100,
  },
  // {
  //   headerName: "Payroll Batch",
  //   resizable: true,
  //   field: "payrollbatch",
  //   minWidth: 140,
  // },
  {
    headerName: "Subsidiary",
    resizable: true,
    field: "subsidiary",
    minWidth: 140,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  // {
  //   headerName: "Transaction Number",
  //   resizable: true,
  //   field: "transactionno",
  //   minWidth: 160,
  //   headerClass: "justify-right",
  //   cellClass: " text-right",
  // },
  {
    headerName: "Name",
    resizable: true,
    field: "name",
    minWidth: 350,
  },
  {
    headerName: "Account",
    resizable: true,
    field: "account",
    minWidth: 340,
  },
  {
    headerName: "PO/Check Number",
    resizable: true,
    field: "po",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Status",
    resizable: true,
    field: "status",
    minWidth: 100,
  },
  // {
  //   headerName: "Tracking Numbers",
  //   resizable: true,
  //   field: "tracking_number",
  //   minWidth: 140,
  // },
  {
    headerName: "Memo",
    resizable: true,
    field: "memo",
    minWidth: 100,
  },
  {
    headerName: "Currency",
    resizable: true,
    field: "currency",
    minWidth: 100,
  },
  {
    headerName: "Amount (Foreign Currency)",
    resizable: true,
    field: "amount_foreign",
    minWidth: 200,
  },
  {
    headerName: "Amount",
    resizable: true,
    field: "amount",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  // {
  //   headerName: "Transaction Units",
  //   resizable: true,
  //   field: "transaction_units",
  //   minWidth: 140,
  // },
  {
    headerName: "Posting",
    resizable: true,
    field: "posting",
    minWidth: 100,
  },
  // {
  //   headerName: "Po/Afe Required",
  //   resizable: true,
  //   field: "po_afe_required",
  //   minWidth: 130,
  // },
  // {
  //   headerName: "Crm Customer Id",
  //   resizable: true,
  //   field: "crm_customer_id",
  //   minWidth: 140,
  // },
  // {
  //   headerName: "Remittance Info",
  //   resizable: true,
  //   field: "remittance_info",
  //   minWidth: 120,
  // },
  // {
  //   headerName: "Super Approver Approved",
  //   resizable: true,
  //   field: "super_approver_approved",
  //   minWidth: 200,
  // },
  // {
  //   headerName: "Asc 606 Invoice Replacement",
  //   resizable: true,
  //   field: "asc_606_invoice_replacement",
  //   minWidth: 210,
  // },
  // {
  //   headerName: "Roject Helix Transactions",
  //   resizable: true,
  //   field: "roject_helix_transactions",
  //   minWidth: 180,
  // },
  // {
  //   headerName: "Agent?",
  //   resizable: true,
  //   field: "agent",
  //   minWidth: 100,
  // },
];
/*----------------Purchase Order Table-------------------*/
export const transactionTypeDetailPurchaseOrder = [
  {
    headerName: "View",
    resizable: true,
    field: "documentno",
    cellRenderer: renderNavigator,
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Date",
    resizable: true,
    sortable: true,
    field: "trandate",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Document Number",
    resizable: true,
    sortable: true,
    field: "documentno",
    minWidth: 140,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Name",
    resizable: true,
    field: "name",
    minWidth: 300,
  },
  {
    headerName: "PC/PROJECT",
    field: "pc_project",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    minWidth: 350,
  },
  {
    headerName: "Status",
    resizable: true,
    field: "status",
    minWidth: 200,
  },
  {
    headerName: "Tracking Numbers",
    resizable: true,
    field: "",
    minWidth: 140,
  },
  {
    headerName: "Memo",
    resizable: true,
    field: "memo",
    minWidth: 140,
  },
  {
    headerName: "Currency",
    resizable: true,
    field: "currency",
    minWidth: 100,
  },
  {
    headerName: "Amount (Foreign Currency)",
    resizable: true,
    field: "amount_foreign",
    minWidth: 200,
  },
  {
    headerName: "Amount",
    resizable: true,
    field: "amount",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },

  {
    headerName: "Email Sent",
    resizable: true,
    field: "email_sent",
    minWidth: 140,
  },
  {
    headerName: "Do Not Send Email",
    resizable: true,
    field: "do_not_send_email",
    minWidth: 140,
  },
  {
    headerName: "Expense Report Status",
    resizable: true,
    field: "expense_report_status",
    minWidth: 140,
  },
  {
    headerName: "NSC PO Number",
    resizable: true,
    field: "nsc_po_number",
    minWidth: 140,
  },
  {
    headerName: "Preferred Entity Bank",
    resizable: true,
    field: "preferred_entity_bank",
    minWidth: 140,
  },
  {
    headerName: "Vendor Bank Fees",
    resizable: true,
    field: "vendor_bank_fees",
    minWidth: 140,
  },
  {
    headerName: "Bank Fee",
    resizable: true,
    field: "bank_fee",
    minWidth: 140,
  },
  {
    headerName: "Created By",
    resizable: true,
    field: "created_by",
    minWidth: 140,
  },
  {
    headerName: "Vendor Bill Approval Status",
    resizable: true,
    field: "vendor_bill_approval_status",
    minWidth: 140,
  },
  {
    headerName: "Entity Bank (Vendor)",
    resizable: true,
    field: "entity_bank_vendor",
    minWidth: 140,
  },
  {
    headerName: "Entity Bank (Employee)",
    resizable: true,
    field: "entity_bank_employee",
    minWidth: 140,
  },
  {
    headerName: "Exclude from Electronic Bank Payments Processing",
    resizable: true,
    field: "exclude_from_electronic_bank_payments_processing",
    minWidth: 140,
  },
  {
    headerName: "Entity Bank (Customer)",
    resizable: true,
    field: "entity_bank_customer",
    minWidth: 140,
  },
  {
    headerName: "Entity Bank (Customer Credit)",
    resizable: true,
    field: "entity_bank_customer_credit",
    minWidth: 140,
  },
  {
    headerName: "Invoice Resend Email",
    resizable: true,
    field: "invoice_resend_email",
    minWidth: 140,
  },
  {
    headerName: "Invoice Additional Attachments",
    resizable: true,
    field: "invoice_additional_attachments",
    minWidth: 100,
  },
];
/*----------------Invoice Table-------------------*/
export const transactionTypeDetailInvoice = [
  {
    headerName: "View",
    resizable: true,
    field: "id",
    cellRenderer: renderNavigator,
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  // {
  //   headerName: "Trans Id",
  //   resizable: true,
  //   field: "tranid",
  //   headerClass: "justify-center",
  //   cellClass: " text-center",
  //   minWidth: 100,
  // },
  {
    headerName: "Type",
    resizable: true,
    field: "type",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Date",
    resizable: true,
    sortable: true,
    field: "date",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  // {
  //   headerName: "Print",
  //   resizable: true,
  //   field: "print",
  //   minWidth: 100,
  // },
  {
    headerName: "Document Number",
    resizable: true,
    field: "documentno",
    minWidth: 110,
    sortable: true,
  },
  // {
  //   headerName: "Transaction Number",
  //   resizable: true,
  //   field: "transactionno",
  //   minWidth: 140,
  // },
  {
    headerName: "Name",
    resizable: true,
    field: "name",
    minWidth: 350,
  },
  {
    headerName: "Account",
    resizable: true,
    field: "account",
    minWidth: 400,
  },
  {
    headerName: "Pc project",
    resizable: true,
    field: "pc_project",
    minWidth: 300,
  },
  {
    headerName: "PO/Check Number",
    resizable: true,
    field: "po",
    minWidth: 140,
  },
  {
    headerName: "Status",
    resizable: true,
    field: "status",
    minWidth: 120,
  },
  {
    headerName: "Subsidiary",
    resizable: true,
    field: "subsidiary",
    minWidth: 140,
  },
  {
    headerName: "Memo",
    resizable: true,
    field: "memo",
    minWidth: 160,
  },
  {
    headerName: "Currency",
    resizable: true,
    field: "currency",
    minWidth: 100,
  },
  {
    headerName: "Amount (Foreign Currency)",
    resizable: true,
    field: "amount_foreign",
    minWidth: 200,
  },
  {
    headerName: "Amount",
    resizable: true,
    field: "amount",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Email Sent",
    resizable: true,
    field: "email_sent",
    minWidth: 140,
  },
  {
    headerName: "Do Not Send Email",
    resizable: true,
    field: "do_not_send_email",
    minWidth: 140,
  },
  {
    headerName: "Expense Report Status",
    resizable: true,
    field: "expense_report_status",
    minWidth: 140,
  },
  {
    headerName: "NSC PO Number",
    resizable: true,
    field: "nsc_po_number",
    minWidth: 140,
  },
  {
    headerName: "Preferred Entity Bank",
    resizable: true,
    field: "preferred_entity_bank",
    minWidth: 140,
  },
  {
    headerName: "Vendor Bank Fees",
    resizable: true,
    field: "vendor_bank_fees",
    minWidth: 140,
  },
  {
    headerName: "Bank Fee",
    resizable: true,
    field: "bank_fee",
    minWidth: 140,
  },
  {
    headerName: "Created By",
    resizable: true,
    field: "created_by",
    minWidth: 140,
  },
  {
    headerName: "Vendor Bill Approval Status",
    resizable: true,
    field: "vendor_bill_approval_status",
    minWidth: 140,
  },
  {
    headerName: "Entity Bank (Vendor)",
    resizable: true,
    field: "entity_bank_vendor",
    minWidth: 140,
  },
  {
    headerName: "Entity Bank (Employee)",
    resizable: true,
    field: "entity_bank_employee",
    minWidth: 140,
  },
  {
    headerName: "Exclude from Electronic Bank Payments Processing",
    resizable: true,
    field: "exclude_from_electronic_bank_payments_processing",
    minWidth: 140,
  },
  {
    headerName: "Entity Bank (Customer)",
    resizable: true,
    field: "entity_bank_customer",
    minWidth: 140,
  },
  {
    headerName: "Entity Bank (Customer Credit)",
    resizable: true,
    field: "entity_bank_customer_credit",
    minWidth: 140,
  },
  {
    headerName: "Invoice Resend Email",
    resizable: true,
    field: "invoice_resend_email",
    minWidth: 140,
  },
  {
    headerName: "Invoice Additional Attachments",
    resizable: true,
    field: "invoice_additional_attachments",
    minWidth: 100,
  },
  // {
  //   headerName: "Po/Afe Required",
  //   resizable: true,
  //   field: "po_afe_required",
  //   minWidth: 130,
  // },
  // {
  //   headerName: "Crm Customer Id",
  //   resizable: true,
  //   field: "crm_customer_id",
  //   minWidth: 140,
  // },
  // {
  //   headerName: "Remittance Info",
  //   resizable: true,
  //   field: "remittance_info",
  //   minWidth: 120,
  // },
  // {
  //   headerName: "Super Approver Approved",
  //   resizable: true,
  //   field: "super_approver_approved",
  //   minWidth: 200,
  // },
];

/*---------Sales Order Item Table-------*/
export const salesOrderItemsTable1 = [
  {
    headerName: "PROJECT",
    field: "project",
    resizable: true,
    minWidth: 120,
    cellRenderer: renderProjectIdNavigator,
  },
  {
    headerName: "ITEM",
    field: "item",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "REVENUE TYPE",
    field: "revenue_type",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "FULFILLED",
    field: "fullfilled",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "QUANTITY",
    field: "qty",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "DESCRIPTION",
    field: "description",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "INVOICE RATE",
    field: "invoice_rate",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "PRICE LEVEL",
    field: "price_level",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "DISCOUNT AMOUNT",
    field: "discount_amount",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "NET UNIT RATE",
    field: "net_unit_rate",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "AMOUNT",
    field: "amount",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "TAX CODE",
    field: "taxcode",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "TAX RATE",
    field: "tax_rate",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "GROSS AMT",
    field: "gross_amount",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "TAX AMOUNT",
    field: "tax_amount",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "GST",
    field: "gst",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "PST",
    field: "pst",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "FV LIST RATE",
    field: "fv_list_rate",
    resizable: true,
    minWidth: 140,
  },
  {
    headerName: "BILLING SCHEDULE",
    field: "billing_schedule",
    resizable: true,
    minWidth: 140,
  },
  {
    headerName: "EFFECTIVE START DATE",
    field: "effective_start_date",
    resizable: true,
    minWidth: 160,
  },
  {
    headerName: "EFFECTIVE END DATE",
    field: "effective_end_date",
    resizable: true,
    minWidth: 160,
  },
  {
    headerName: "BILLING START DATE",
    field: "billing_start_date",
    resizable: true,
    minWidth: 170,
  },
  {
    headerName: "BILLING END DATE",
    field: "billing_end_date",
    resizable: true,
    minWidth: 160,
  },
  {
    headerName: "SALES MARKET REGION",
    field: "sales_market_region",
    resizable: true,
    minWidth: 170,
  },
  {
    headerName: "TAX REGION",
    field: "tax_region",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "ROYALTY %",
    field: "royalty",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "SOLUTION",
    field: "solution",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "DEPARTMENT",
    field: "department",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "BUSINESS UNIT",
    field: "business_unit",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "OPERATION",
    field: "operation",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "OPTIONS",
    field: "options",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "PROJECT ITEM",
    field: "project_item",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "BILLABLE ESTIMATE",
    field: "billable_estimate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "CHARGE TYPE",
    field: "charge_type",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "REVENUE TYPE (CUSTOM)",
    field: "revenue_type_custom",
    resizable: true,
    minWidth: 170,
  },
  {
    headerName: "PRIMARY SOLUTION",
    field: "primary_solution",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "PRODUCT",
    field: "product",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "TYPE",
    field: "type",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "SHIP-TO ENTITY/USE CODE",
    field: "ship_to_entity_use_code",
    resizable: true,
    minWidth: 180,
  },
  {
    headerName: "% BILLED",
    field: "per_billed",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "USE FV PRICE LIST",
    field: "use_fv_rpice_list",
    resizable: true,
    minWidth: 140,
  },
  {
    headerName: "DISCOUNT UNIT RATE (INVOICE)",
    field: "discount_unit_rate_invoice",
    resizable: true,
    minWidth: 190,
  },
  {
    headerName: "INVOICE AMOUNT NO DISCOUNT",
    field: "invoice_amount_no_discount",
    resizable: true,
    minWidth: 190,
  },
  {
    headerName: "OPENAIR BILLING RULE",
    field: "openair_billing_rule",
    resizable: true,
    minWidth: 180,
  },
  {
    headerName: "OPENAIR INVOICE LINE ID",
    field: "openair_invoice_line_id",
    resizable: true,
    minWidth: 180,
  },
  {
    headerName: "OPENAIR EXPENSE REPORT LINE ID",
    field: "openair_expense_report_line_id",
    resizable: true,
    minWidth: 190,
  },
  {
    headerName: "OPENAIR QUANTITY FROM % INVOICED",
    field: "openair_quantity_from_per_invoiced",
    resizable: true,
    minWidth: 190,
  },
  {
    headerName: "OPENAIR: CHARGE TYPE",
    field: "openair_charge_type",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "EMPLOYEE",
    field: "employee",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "HSN CODE",
    field: "hsn_code",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "CUSTOM DUTY RATE",
    field: "custom_duty_rate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "PRE-OWNED ITEM (2)",
    field: "pre_owned_item",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "VAT CODE",
    field: "vat_code",
    resizable: true,
    minWidth: 120,
  },
];

export const salesOrderItemsTable = [
  {
    headerName: "PROJECT",
    field: "project",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "ITEM",
    field: "item",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "REVENUE TYPE",
    field: "revenue_type",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "FULFILLED",
    field: "fullfilled",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "QUANTITY",
    field: "qty",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "DESCRIPTION",
    field: "description",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "RATE",
    field: "rate",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "PRICE LEVEL",
    field: "price_level",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "DISCOUNT AMOUNT",
    field: "discount_amount",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "NET UNIT RATE",
    field: "net_unit_rate",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "AMOUNT",
    field: "amount",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "TAX CODE",
    field: "taxcode",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "TAX RATE",
    field: "tax_rate",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "GROSS AMT",
    field: "gross_amount",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "TAX AMOUNT",
    field: "tax_amount",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "GST",
    field: "gst",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "PST",
    field: "pst",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "FV LIST RATE",
    field: "fv_list_rate",
    resizable: true,
    minWidth: 140,
  },
  {
    headerName: "BILLING SCHEDULE",
    field: "billing_schedule",
    resizable: true,
    minWidth: 140,
  },
  {
    headerName: "EFFECTIVE START DATE",
    field: "effective_start_date",
    resizable: true,
    minWidth: 160,
  },
  {
    headerName: "EFFECTIVE END DATE",
    field: "effective_end_date",
    resizable: true,
    minWidth: 160,
  },
  {
    headerName: "BILLING START DATE",
    field: "billing_start_date",
    resizable: true,
    minWidth: 170,
  },
  {
    headerName: "BILLING END DATE",
    field: "billing_end_date",
    resizable: true,
    minWidth: 160,
  },
  {
    headerName: "SALES MARKET REGION",
    field: "sales_market_region",
    resizable: true,
    minWidth: 170,
  },
  {
    headerName: "TAX REGION",
    field: "tax_region",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "ROYALTY %",
    field: "royalty",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "SOLUTION",
    field: "solution",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "DEPARTMENT",
    field: "department",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "BUSINESS UNIT",
    field: "business_unit",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "OPERATION",
    field: "operation",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "OPTIONS",
    field: "options",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "PROJECT ITEM",
    field: "project_item",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "BILLABLE ESTIMATE",
    field: "billable_estimate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "CHARGE TYPE",
    field: "charge_type",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "REVENUE TYPE (CUSTOM)",
    field: "revenue_type_custom",
    resizable: true,
    minWidth: 170,
  },
  {
    headerName: "PRIMARY SOLUTION",
    field: "primary_solution",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "PRODUCT",
    field: "product",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "TYPE",
    field: "type",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "SHIP-TO ENTITY/USE CODE",
    field: "ship_to_entity_use_code",
    resizable: true,
    minWidth: 180,
  },
  {
    headerName: "% BILLED",
    field: "per_billed",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "USE FV PRICE LIST",
    field: "use_fv_rpice_list",
    resizable: true,
    minWidth: 140,
  },
  {
    headerName: "DISCOUNT UNIT RATE (INVOICE)",
    field: "discount_unit_rate_invoice",
    resizable: true,
    minWidth: 190,
  },
  {
    headerName: "INVOICE AMOUNT NO DISCOUNT",
    field: "invoice_amount_no_discount",
    resizable: true,
    minWidth: 190,
  },
  {
    headerName: "OPENAIR BILLING RULE",
    field: "openair_billing_rule",
    resizable: true,
    minWidth: 180,
  },
  {
    headerName: "OPENAIR INVOICE LINE ID",
    field: "openair_invoice_line_id",
    resizable: true,
    minWidth: 180,
  },
  {
    headerName: "OPENAIR EXPENSE REPORT LINE ID",
    field: "openair_expense_report_line_id",
    resizable: true,
    minWidth: 190,
  },
  {
    headerName: "OPENAIR QUANTITY FROM % INVOICED",
    field: "openair_quantity_from_per_invoiced",
    resizable: true,
    minWidth: 190,
  },
  {
    headerName: "OPENAIR: CHARGE TYPE",
    field: "openair_charge_type",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "EMPLOYEE",
    field: "employee",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "HSN CODE",
    field: "hsn_code",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "CUSTOM DUTY RATE",
    field: "custom_duty_rate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "PRE-OWNED ITEM (2)",
    field: "pre_owned_item",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "VAT CODE",
    field: "vat_code",
    resizable: true,
    minWidth: 120,
  },
];

/*--------Upload Files Table---------*/
export const uploadFilesTable = [
  {
    headerName: "Serial No.",
    field: "serialno",
    minWidth: 100,
    maxWidth: 100,
  },
  {
    headerName: "Filename",
    field: "filename",
    headerClass: "justify-left",
  },
  {
    headerName: "Size",
    field: "size",
    headerClass: "justify-left",
    valueFormatter: formatFileSize,
  },
  {
    headerName: "Type",
    field: "type",
    headerClass: "justify-left",
  },
  {
    headerName: "Created Date",
    field: "createddate",
    headerClass: "justify-left",
    valueFormatter: toLocalDate,
  },
];
/*--------Accounts Table---------*/
export const accountsTable = [
  { headerName: "Name", field: "name", cellClass: "text-capitalize" },
  { headerName: "Email Address", field: "email" },
  {
    headerName: "Role",
    field: "role",
    minWidth: 200,
    maxWidth: 200,
    cellClass: "text-capitalize",
  },
  {
    headerName: "Created Date",
    field: "created_date",
    minWidth: 200,
    maxWidth: 200,
  },
];
/*--------Sales Order BillingPayment Events---------*/
export const salesOrderPaymentTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "TRANSACTION", resizable: true, field: "", minWidth: 120 },
  { headerName: "EVENT", resizable: true, field: "", minWidth: 120 },
  { headerName: "HANDLING MODE", resizable: true, field: "", minWidth: 120 },
  { headerName: "PAYMENT OPTION", resizable: true, field: "", minWidth: 140 },
  { headerName: "RESULT", resizable: true, field: "", minWidth: 120 },
  { headerName: "REASON", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "AMOUNT",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "VIEW DETAILS", resizable: true, field: "", minWidth: 120 },
];
/*--------Sales Order Billing Schedule Table---------*/
export const salesOrderScheduleTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "date",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "AMOUNT",
    resizable: true,
    field: "amount",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];
/*--------Sales Order Relationship Contact Table---------*/
export const relationshipContactTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "COMPANY", resizable: true, field: "", minWidth: 120 },
  { headerName: "JOB TITLE", resizable: true, field: "", minWidth: 120 },
  { headerName: "PHONE", resizable: true, field: "", minWidth: 120 },
  { headerName: "EMAIL", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "EXPORT TO OPENAIR",
    resizable: true,
    field: "",
    minWidth: 140,
  },
  { headerName: "ROLE", resizable: true, field: "", minWidth: 100 },
];
/*--------Sales Order Custom FAM Asset Table---------*/
export const salesOrderFamAssetTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "ID", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "ASSET DESCRIPTION",
    resizable: true,
    field: "",
    minWidth: 140,
  },
  { headerName: "ASSET TYPE", resizable: true, field: "", minWidth: 100 },
  {
    headerName: "ASSET ORIGINAL COST",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  {
    headerName: "ASSET CURRENT COST",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  {
    headerName: "DEPRECIATION METHOD",
    resizable: true,
    field: "",
    minWidth: 170,
  },
  { headerName: "ASSET LIFETIME", resizable: true, field: "", minWidth: 120 },
  { headerName: "ASSET STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "COMPONENT OF", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "QUANTITY",
    resizable: true,
    field: "",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "BUSINESS UNIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];
/*---------Sales Order Custom Journal Reject Reason--------*/
export const salesOrderCustomJournalRejectReasonTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "ID", resizable: true, field: "", minWidth: 120 },
  { headerName: "REJECT REASON", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];
/*---------Sales Order Custom FAM Depreciation History--------*/
export const salesOrderFAMDepreciationHistoryTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "ACCOUNTING BOOK", resizable: true, field: "", minWidth: 150 },
  { headerName: "TRANSACTION TYPE", resizable: true, field: "", minWidth: 150 },
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "PERIOD",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "TRANSACTION AMOUNT",
    resizable: true,
    field: "",
    minWidth: 180,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "DEPRECIATION POSTING REFERENCE",
    resizable: true,
    field: "",
    minWidth: 240,
  },
  {
    headerName: "QUANTITY",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "SCHEDULE", resizable: true, field: "", minWidth: 120 },
  { headerName: "SCHEDULED NBV", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "PARENT ASSET VALUE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "PRIOR YEAR NBV", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DEPRECIATION PRIOD",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "BUSINESS UNIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];
/*---------Sales Order Approver List--------*/
export const salesOrderApproverList = [
  { headerName: "#", resizable: true, field: "", minWidth: 120 },
  { headerName: "RULE SEQUENCE", resizable: true, field: "", minWidth: 120 },
  { headerName: "APPROVER", resizable: true, field: "", minWidth: 120 },
  { headerName: "DATE/TIME", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "APPROVER ROLE",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "APPROVAL STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "NOTE", resizable: true, field: "", minWidth: 120 },
  { headerName: "SUPER APPROVED", resizable: true, field: "", minWidth: 120 },
];

/*----------Sales Order Philippines Invoicing--------*/
export const salesOrderPhilippinesTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "PRINT NUMBER",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "HEADER OBJECT", resizable: true, field: "", minWidth: 120 },
  { headerName: "FOOTER OBJECT", resizable: true, field: "", minWidth: 120 },
];

/*----------Sales Order Ava Tax-------*/
export const salesOrderAvaTaxTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "date",
    maxWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "AUTHOR", resizable: true, field: "author", maxWidth: 220 },
  { headerName: "TITLE", resizable: true, field: "title", maxWidth: 180 },
  { headerName: "MEMO", resizable: true, field: "memo", minWidth: 120 },
];
/*---------Sales Order Communication Messages-----------*/
export const salesOrderMessageTable = [
  {
    headerName: "#",
    field: "count",
    resizable: true,
    minWidth: 80,
    cellRenderer: (params) => {
      return params.node.rowIndex + 1;
    },
  },
  {
    headerName: "View",
    resizable: true,
    field: "view",
    cellRenderer: renderViewNavigator,
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "DATE",
    field: "date",
    resizable: true,
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "AUTHOR", field: "Author", resizable: true, minWidth: 200 },
  {
    headerName: "PRIMARY RECIPIENT",
    field: "primary_recipient",
    resizable: true,
    minWidth: 250,
  },
  { headerName: "SUBJECT", field: "Subject", resizable: true, minWidth: 240 },
  { headerName: "TYPE", field: "type", resizable: true, minWidth: 120 },
  { headerName: "FILES", field: "Files", resizable: true, minWidth: 120 },
  {
    headerName: "ATTACHMENTS",
    field: "attachments",
    resizable: true,
    cellRenderer: renderTAbNavigator,
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 250,
  },
  {
    headerName: "INTERNAL ONLY",
    field: "internal_only",
    resizable: true,
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 120,
  },
  {
    headerName: "REMOVE",
    field: "remove",
    cellRenderer: () => <p style={{ margin: 1 }}>Remove</p>,
    resizable: true,
    minWidth: 120,
    headerClass: "justify-center",
    cellClass: " text-center",
  },
];

/*---------Sales Order Communication Activities-----------*/
export const salesOrderCommunicationActivitiesTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "TITLE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE",
    resizable: true,
    field: "date",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "TIME", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "OWNER",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "ASSIGNED TO", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "MARK", resizable: true, field: "", minWidth: 120 },
  { headerName: "TASK DUE DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "NEXT STEP", resizable: true, field: "", minWidth: 120 },
];

/*---------Sales Order Communication Files-----------*/
export const salesOrderCommunicationFilesTable = [
  // {
  //   headerName: "ATTACHED FILE",
  //   resizable: true,
  //   field: "filename",
  //   minWidth: 120,
  // },
  {
    headerName: "ATTACHED FILE",
    resizable: true,
    field: "filename",
    minWidth: 120,
    cellRenderer: function (params) {
      if (params.value) {
        return <Link>{params.value}</Link>;
      } else {
        return "";
      }
    },
  },
  { headerName: "FOLDER", resizable: true, field: "folder", minWidth: 120 },
  {
    headerName: "SIZE(KB)",
    resizable: true,
    field: "size_in_kb",
    minWidth: 120,
  },
  {
    headerName: "LAST MODIFILED",
    resizable: true,
    field: "last_modified",
    minWidth: 120,
  },
  {
    headerName: "DOCUMENT TYPE",
    resizable: true,
    field: "file_type",
    minWidth: 120,
  },

  {
    headerName: "REMOVE",
    resizable: true,
    field: "remove",
    minWidth: 120,
    cellRenderer: () => <p style={{ margin: 1 }}>Remove</p>,
  },
  {
    headerName: "EDIT",
    resizable: true,
    field: "",
    minWidth: 120,
    cellRenderer: () => <p style={{ margin: 1 }}>Edit</p>,
  },
  {
    headerName: "DOWNLOAD",
    cellRenderer: () => (
      <Button sx={{ margin: 1, color: "#0066b2" }}>
        {" "}
        <DownloadIcon />
      </Button>
    ),
    resizable: true,
    field: "transaction_id",
    maxWidth: 120,
  },
];

/*---------Sales Order Communication User Notes-----------*/
export const salesOrderCommunicationUserNotesTable = [
  { headerName: "ATTACHED FILE", resizable: true, field: "", minWidth: 120 },
  { headerName: "FOLDER", resizable: true, field: "", minWidth: 120 },
  { headerName: "SIZE(KB)", resizable: true, field: "", minWidth: 120 },
  { headerName: "LAST MODIFILED", resizable: true, field: "", minWidth: 120 },
  { headerName: "DOCUMENT TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DOWNLOAD",
    resizable: true,
    field: "",
    minWidth: 120,
    cellRenderer: () => (
      <Button sx={{ margin: 1, color: "#0066b2" }}>
        {" "}
        <DownloadIcon />
      </Button>
    ),
  },
];
/*---------Sales Order Related Record Transformation-----------*/
export const salesOrderRelatedRecordTransformationTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "NUMBER",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "LINK TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "AMOUNT",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];
/*---------Sales Order Related Record -----------*/
export const salesOrderRelatedRecordTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "date",
    minWidth: 90,
    // headerClass: "justify-right",
    // cellClass: " text-right",
    cellRenderer: renderOrderIdNavigator,
  },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  {
    headerName: "NUMBER",
    resizable: true,
    field: "number",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
    cellRenderer: renderOrderIdNavigatorNumber,
  },
  {
    headerName: "STATUS",
    resizable: true,
    field: "status",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "LINK TYPE",
    resizable: true,
    field: "linktype",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  // {
  //   headerName: "NUMBER",
  //   resizable: true,
  //   field: "number",
  //   minWidth: 120,
  //   headerClass: "justify-right",
  //   cellClass: " text-right",
  // },
  {
    headerName: "AMOUNT",
    resizable: true,
    field: "amount",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];

export const salesOrderTransactionsTable = [
  { headerName: "LINE ID", resizable: true, field: "", minWidth: 120 },
  { headerName: "LINE ORDER TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "ITEM", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "QUANTITY",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "SUM OF AMOUNT",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "REV. REC. START DATE",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "REV. REC. END DATE",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "DURATION", resizable: true, field: "", minWidth: 120 },
  { headerName: "RECALCULATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "CIB ASSET ID", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "QUOTE LINE NUMBER",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "QUOTE ASSET LINE NUMBER",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "RECURRING BILLING GROUP",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "MAINT SERIAL NUMBER",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];

/*------------Sales Order System Information System Notes--------------*/
export const salesOrderSystemNotesTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "Date",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "SET BY", resizable: true, field: "Set by", minWidth: 120 },
  { headerName: "CONTEXT", resizable: true, field: "Context", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "Type", minWidth: 120 },
  { headerName: "FIELD", resizable: true, field: "Field", minWidth: 120 },
  {
    headerName: "OLD VALUE",
    resizable: true,
    field: "Old Value",
    minWidth: 120,
  },
  {
    headerName: "NEW VALUE",
    resizable: true,
    field: "New Value",
    minWidth: 120,
  },
];

/*------------Sales Order System Information Active Workflows--------------*/
export const salesOrderActiveWorkfowTables = [
  { headerName: "WORKFLOW", resizable: true, field: "", minWidth: 120 },
  { headerName: "CURRENT STATE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE ENTERED WORKFLOW",
    resizable: true,
    field: "",
    minWidth: 180,
  },
  {
    headerName: "DATE ENTERED STATE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "OPTIONS", resizable: true, field: "", minWidth: 120 },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "CANCEL", resizable: true, field: "", minWidth: 120 },
];

/*------------Sales Order System Information Workflow History--------------*/
export const salesOrderWorkflowHistoryTables = [
  { headerName: "WORKFLOW", resizable: true, field: "", minWidth: 120 },
  { headerName: "STATE NAME INFO", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE ENTERED STATE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  {
    headerName: "DATE EXITIED STATE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "OPTIONS", resizable: true, field: "", minWidth: 120 },
  { headerName: "NOTES", resizable: true, field: "", minWidth: 120 },
];

/*------------Sales Order System Information Applied Rules--------------*/
export const salesOrderAppliedRulesTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "RULE TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "DETAILS", resizable: true, field: "", minWidth: 160 },
];
/*------------Purchase Order Item Table--------------*/
export const purchaseOrderItemsTable = [
  {
    headerName: "ITEM",
    resizable: true,
    field: "Item",
    minWidth: 250,
  },
  {
    headerName: "VENDOR NAME",
    resizable: true,
    field: "vendor_name",
    minWidth: 120,
  },
  {
    headerName: "VENDOR TEXT",
    resizable: true,
    field: "vendor_name",
    minWidth: 120,
  },
  {
    headerName: "DESCRIPTION",
    resizable: true,
    field: "description",
    minWidth: 350,
  },
  {
    headerName: "MANUFACTURER CATALOG NUMBER",
    field: "mfg_catalog_number",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "RECEIVED",
    resizable: true,
    field: "received",
    minWidth: 120,
  },
  {
    headerName: "BILLED",
    resizable: true,
    field: "billed",
    minWidth: 120,
  },
  {
    headerName: "QUANTITY",
    resizable: true,
    field: "quantity",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },

  {
    headerName: "RATE+SALES TAX",
    resizable: true,
    field: "item_rate",
    minWidth: 120,
  },
  {
    headerName: "AMOUNT",
    resizable: true,
    field: "amount_exclude_tax",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },

  {
    headerName: "CLIN #",
    resizable: true,
    field: "clin_number",
    minWidth: 120,
  },
  { headerName: "IJO #", resizable: true, field: "ijo", minWidth: 120 },
  {
    headerName: "PC/PROJECT",
    resizable: true,
    field: "pc_project",
    minWidth: 120,
  },
  { headerName: "BILLABLE", resizable: true, field: "billable", minWidth: 120 },

  {
    headerName: "DEPARTMENT",
    resizable: true,
    field: "department",
    minWidth: 120,
  },
  {
    headerName: "SERVICE LINE",
    resizable: true,
    field: "serviceline",
    minWidth: 120,
  },

  {
    headerName: "CLOSED",
    resizable: true,
    field: "closed",
    minWidth: 120,
  },
  {
    headerName: "OPTIONS",
    resizable: true,
    field: "Option",
    minWidth: 120,
  },

  {
    headerName: "PRE-OWNED ITEM(2)",
    resizable: true,
    field: "pre_owned_item",
    minWidth: 120,
  },
  {
    headerName: "VAT CODE",
    resizable: true,
    field: "vat_code",
    minWidth: 120,
  },
  {
    headerName: "VAT BIN",
    resizable: true,
    field: "vat_bin",
    minWidth: 120,
  },
  {
    headerName: "HISTORY",
    resizable: true,
    field: "history",
    minWidth: 120,
  },
];
/*------------Purchase Order Item Expenses Table--------------*/
export const purchaseOrderItemsExpensesTable = [
  {
    headerName: "ACCOUNT",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "AMOUNT",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "MEMO",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "DEPARTMENT",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "CLASS",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "LOCATION",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "BUSINESS UNIT",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "ADDBACKS",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "INTERNAL PROJECT",
    resizable: true,
    field: "",
    minWidth: 140,
  },
  {
    headerName: "REQUIRES AMORTIZATION",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  {
    headerName: "OPTIONS",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "CLIENT",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "BILLABLE",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "TECHNICIAN",
    resizable: true,
    field: "isclosed",
    minWidth: 120,
  },
  {
    headerName: "VAT CODE",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "CLOSED",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "HISTORY",
    resizable: true,
    field: "",
    minWidth: 120,
  },
];
/*--------Purchase Order Relationship Contact Table---------*/
export const purchaseRelationshipContactTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "COMPANY", resizable: true, field: "", minWidth: 120 },
  { headerName: "JOB TITLE", resizable: true, field: "", minWidth: 120 },
  { headerName: "PHONE", resizable: true, field: "", minWidth: 120 },
  { headerName: "EMAIL", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "EXPORT TO OPENAIR",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "ROLE", resizable: true, field: "", minWidth: 100 },
];
/*---------Purchase Order Communication Messages-----------*/
export const purchaseOrderMessageTable = [
  { headerName: "#", resizable: true, field: "", minWidth: 80 },
  { headerName: "VIEW", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "AUTHOR", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "PRIMARY RECIPIENT",
    resizable: true,
    field: "",
    minWidth: 150,
  },
  { headerName: "SUBJECT", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "FILES", resizable: true, field: "", minWidth: 120 },
  { headerName: "ATTACHMENTS", resizable: true, field: "", minWidth: 120 },
];
/*---------Purchase Order Communication Activities-----------*/
export const purchaseOrderCommunicationActivitiesTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "TITLE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "TIME", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "OWNER",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "ASSIGNED TO", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "MARK", resizable: true, field: "", minWidth: 120 },
  { headerName: "NEXT DUE DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "NEXT STEP", resizable: true, field: "", minWidth: 120 },
];

/*---------Purchase Order Communication Files-----------*/
export const purchaseOrderCommunicationFilesTable = [
  { headerName: "ATTACHED FILE", resizable: true, field: "", minWidth: 120 },
  { headerName: "FOLDER", resizable: true, field: "", minWidth: 120 },
  { headerName: "SIZE(KB)", resizable: true, field: "", minWidth: 120 },
  { headerName: "LAST MODIFILED", resizable: true, field: "", minWidth: 120 },
  { headerName: "DOCUMENT TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DOWNLOAD",
    resizable: true,
    field: "",
    minWidth: 120,
    cellRenderer: () => (
      <Button sx={{ margin: 1, color: "#0066b2" }}>
        {" "}
        <DownloadIcon />
      </Button>
    ),
  },
];
/*---------Purchase Order Communication User Notes-----------*/
export const purchaseOrderCommunicationUserNotesTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "AUTHOR", resizable: true, field: "", minWidth: 120 },
  { headerName: "TITLE", resizable: true, field: "", minWidth: 120 },
  { headerName: "MEMO", resizable: true, field: "", minWidth: 120 },
  { headerName: "DIRECTION", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
];
/*---------Purchase Order Related Record -----------*/
export const purchaseOrderRelatedRecordReceiptsBillsTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "NUMBER",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "LINK TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "AMOUNT",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];
/*---------Purchase Order Related Record Approvals -----------*/
export const purchaseOrderRelatedRecordApprovals = [
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "NUMBER",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "LINK TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "AMOUNT",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];
/*---------Purchase Order Related Record Transformation-----------*/
export const purchaseOrderRelatedRecordTransformation = [
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "NUMBER",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "LINK TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "AMOUNT",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];
/*------------Purchase Order System Information System Notes--------------*/
export const purchaseOrderSystemNotesTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "SET BY", resizable: true, field: "", minWidth: 120 },
  { headerName: "CONTEXT", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "FIELD", resizable: true, field: "", minWidth: 120 },
  { headerName: "OLD VALUE", resizable: true, field: "", minWidth: 120 },
  { headerName: "NEW VALUE", resizable: true, field: "", minWidth: 120 },
];

/*------------Purchase Order System Information Active Workflows--------------*/
export const purchaseOrderActiveWorkfowTables = [
  { headerName: "WORKFLOW", resizable: true, field: "", minWidth: 120 },
  { headerName: "CURRENT STATE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE ENTERED WORKFLOW",
    resizable: true,
    field: "",
    minWidth: 180,
  },
  {
    headerName: "DATE ENTERED STATE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "OPTIONS", resizable: true, field: "", minWidth: 120 },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "CANCEL", resizable: true, field: "", minWidth: 120 },
];

/*------------Purchase Order System Information Workflow History--------------*/
export const purchaseOrderWorkflowHistoryTables = [
  { headerName: "WORKFLOW", resizable: true, field: "", minWidth: 120 },
  { headerName: "STATE NAME INFO", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE ENTERED STATE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  {
    headerName: "DATE EXITIED STATE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "OPTIONS", resizable: true, field: "", minWidth: 120 },
  { headerName: "NOTES", resizable: true, field: "", minWidth: 120 },
];

/*------------Purchase Order System Information Applied Rules--------------*/
export const purchaseOrderAppliedRulesTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "RULE TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "DETAILS", resizable: true, field: "", minWidth: 160 },
];
/*--------Purchase Order Custom FAM Asset Table---------*/
export const purchaseOrderFamAssetTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "ID", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "ASSET DESCRIPTION",
    resizable: true,
    field: "",
    minWidth: 140,
  },
  { headerName: "ASSET TYPE", resizable: true, field: "", minWidth: 100 },
  {
    headerName: "ASSET ORIGINAL COST",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  {
    headerName: "ASSET CURRENT COST",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  {
    headerName: "DEPRECIATION METHOD",
    resizable: true,
    field: "",
    minWidth: 170,
  },
  { headerName: "ASSET LIFETIME", resizable: true, field: "", minWidth: 120 },
  { headerName: "ASSET STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "COMPONENT OF", resizable: true, field: "", minWidth: 120 },
  { headerName: "BUSINESS UNIT", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "QUANTITY",
    resizable: true,
    field: "",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];
/*---------Purchase Order Custom Journal Reject Reason--------*/
export const purchaseOrderCustomJournalRejectReasonTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "ID", resizable: true, field: "", minWidth: 120 },
  { headerName: "REJECT REASON", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];
/*---------Purchase Order Custom FAM Depreciation History--------*/
export const purchaseOrderFAMDepreciationHistoryTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "ACCOUNTING BOOK", resizable: true, field: "", minWidth: 150 },
  { headerName: "TRANSACTION TYPE", resizable: true, field: "", minWidth: 150 },
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "PERIOD",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "TRANSACTION AMOUNT",
    resizable: true,
    field: "",
    minWidth: 180,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "NET BOOK VALUE", resizable: true, field: "", minWidth: 150 },
  {
    headerName: "DEPRECIATION POSTING REFERENCE",
    resizable: true,
    field: "",
    minWidth: 240,
  },
  {
    headerName: "QUANTITY",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "SCHEDULE", resizable: true, field: "", minWidth: 120 },
  { headerName: "SCHEDULED NBV", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "PARENT ASSET VALUE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "PRIOR YEAR NBV", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DEPRECIATION PRIOD",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "BUSINESS UNIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];
/*---------Purchase Order Approver List--------*/
export const purchaseOrderApproverList = [
  { headerName: "#", resizable: true, field: "", minWidth: 120 },
  { headerName: "RULE SEQUENCE", resizable: true, field: "", minWidth: 120 },
  { headerName: "APPROVER", resizable: true, field: "", minWidth: 120 },
  { headerName: "DATE/TIME", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "APPROVER ROLE",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "APPROVER TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "APPROVAL STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "NOTE", resizable: true, field: "", minWidth: 120 },
  { headerName: "SUPER APPROVED", resizable: true, field: "", minWidth: 120 },
];
/*----------Purchase Order Philippines Invoicing--------*/
export const purchaseOrderPhilippinesTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "PRINT NUMBER",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "HEADER OBJECT", resizable: true, field: "", minWidth: 120 },
  { headerName: "FOOTER OBJECT", resizable: true, field: "", minWidth: 120 },
];
/*----------Saved Search List Table--------*/
export const savedSearchListTable = [
  {
    headerName: "Report Name",
    field: "report_name",
    minWidth: 100,
    cellRenderer: renderNavigatorBySavedReport,
  },
  { headerName: "Table Name", field: "table_name", minWidth: 100 },
  {
    headerName: "Type",
    field: "type",
    minWidth: 100,
    cellRenderer: (params) => {
      if (params.value === "SavedSearch") return "Saved Search";
      else {
        return params.value;
      }
    },
  },
];

/*------------------*/
export const pageDetailListTable = [
  {
    headerName: "Page Name",
    resizable: true,
    field: "pagename",
    headerClass: "justify-left",
  },

  {
    headerName: "Section Name",
    resizable: true,
    field: "secname",
  },
  {
    headerName: "View Name",
    resizable: true,
    field: "viewname",
    headerClass: "justify-left",
  },

  {
    headerName: "Columns Name",
    resizable: true,
    field: "colname",
  },
];
/*---------Invoice Item Table-------*/
export const invoiceItemsTable = [
  // { headerName: "PROJECT", field: "project", resizable: true, minWidth: 150, cellRenderer: renderProjectIdNavigator, },
  { headerName: "ITEM", field: "item", resizable: true, minWidth: 80 },
  {
    headerName: "ITEM NAME",
    field: "item_name",
    resizable: true,
    minWidth: 80,
  },
  { headerName: "TAX CODE", field: "tax_code", resizable: true, minWidth: 120 },

  {
    headerName: "AVATAX AMOUNT",
    field: "avatax_amount",
    resizable: true,
    minWidth: 100,
  },
  // {
  //   headerName: "REVENUE TYPE",
  //   field: "revenue_type",
  //   resizable: true,
  //   minWidth: 150,
  // },
  {
    headerName: "QUANTITY",
    field: "quantity",
    resizable: true,
    minWidth: 80,
  },
  // {
  //   headerName: "Invoice Rate",
  //   field: "invoice_rate",
  //   resizable: true,
  //   minWidth: 150,
  // },

  {
    headerName: "PRICE",
    field: "price",
    resizable: true,
    minWidth: 150,
  },

  { headerName: "TOTAL", field: "total", resizable: true, minWidth: 120 },
  {
    headerName: "TAX AMOUNT",
    field: "tax_amount",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "DESCRIPTION",
    field: "description",
    resizable: true,
    minWidth: 300,
  },
  { headerName: "JOB", field: "job", resizable: true, minWidth: 120 },
  { headerName: "TAX RATE", field: "tax_rate", resizable: true, minWidth: 150 },
  {
    headerName: "CHARGE TYPE",
    field: "charge_type",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "BACK ORDERED",
    field: "back_ordered",
    resizable: true,
    minWidth: 80,
  },
  {
    headerName: "CHARGE",
    field: "charge",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "CHARGE DESCRIPTION",
    field: "charge_description",
    resizable: true,
    minWidth: 250,
  },
  {
    headerName: "SHIP-TO ENTITY/USE CODE",
    field: "ship_to_entity_use_code",
    resizable: true,
    minWidth: 150,
  },

  {
    headerName: "GOV CLIN #",
    field: "gov_clin",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "HSN CODE", field: "hst_code", resizable: true, minWidth: 150 },
  {
    headerName: "CUSTOM DUTY RATE",
    field: "custom_dutyrate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "PRE-OWNED ITEM (2)",
    field: "pre_owned_item",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "VAT CODE", field: "vatcode", resizable: true, minWidth: 150 },

  {
    headerName: "RENTAL AND LEASING TAX RATE",
    field: "rental_and_leasing_tax_rate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "RENTAL AND LEASING TAX",
    field: "rental_and_leasing_tax",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "CUSTOMER INVOICE LINE ATTACHMENT",
    field: "customer_invoice_line_attachment_name",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "SHIP FROM VAT BIN",
    field: "ship_from_vatbin",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "SHIP TO VAT BIN",
    field: "ship_to_vatbin",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "BOTTLE TAX RATE",
    field: "bottle_tax_rate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "BOTTLE TAX",
    field: "bottle_tax",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "RECYCLING FEES RATE",
    field: "recycling_fees_rate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "RECYCLING FEES",
    field: "recycling_fees",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "HISTORY", field: "history", resizable: true, minWidth: 150 },

  {
    headerName: "SELECT TAX TYPE",
    field: "select_tax_type",
    resizable: true,
    minWidth: 150,
  },
];

/*--------Invoice Relationship Contact Table---------*/
export const invoiceRelationshipContactTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "COMPANY", resizable: true, field: "", minWidth: 120 },
  { headerName: "JOB TITLE", resizable: true, field: "", minWidth: 120 },
  { headerName: "PHONE", resizable: true, field: "", minWidth: 120 },
  { headerName: "EMAIL", resizable: true, field: "", minWidth: 120 },
  { headerName: "ROLE", resizable: true, field: "", minWidth: 100 },
  {
    headerName: "REMOVE",
    resizable: true,
    field: "",
    minWidth: 140,
  },
];
/*---------Invoice Communication Messages-----------*/
export const invoiceMessageTable = [
  { headerName: "#", resizable: true, field: "", minWidth: 80 },
  { headerName: "VIEW", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "AUTHOR", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "PRIMARY RECIPIENT",
    resizable: true,
    field: "",
    minWidth: 150,
  },
  { headerName: "SUBJECT", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "FILES", resizable: true, field: "", minWidth: 120 },
  { headerName: "ATTACHMENTS", resizable: true, field: "", minWidth: 120 },
];
/*---------Invoice Communication Activities-----------*/
export const invoiceCommunicationActivitiesTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "TITLE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "TIME", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "OWNER",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "ASSIGNED TO", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "MARK", resizable: true, field: "", minWidth: 120 },
  { headerName: "TASK DUE DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "NEXT STEP", resizable: true, field: "", minWidth: 120 },
];

/*---------Invoice Communication Files-----------*/
// export const invoiceCommunicationFilesTable = [
//   { headerName: "ATTACHED FILE", resizable: true, field: "", minWidth: 120 },
//   { headerName: "FOLDER", resizable: true, field: "", minWidth: 120 },
//   { headerName: "SIZE(KB)", resizable: true, field: "", minWidth: 120 },
//   { headerName: "LAST MODIFILED", resizable: true, field: "", minWidth: 120 },
//   { headerName: "DOCUMENT TYPE", resizable: true, field: "", minWidth: 120 },
//   { headerName: "DOWNLOAD", resizable: true, field: "", minWidth: 120 },
// ];
export const invoiceCommunicationFilesTable = [
  // {
  //   headerName: "ATTACHED FILE",
  //   resizable: true,
  //   field: "filename",
  //   minWidth: 120,
  // },
  { headerName: "FOLDER", resizable: true, field: "folder", minWidth: 120 },
  {
    headerName: "SIZE(KB)",
    resizable: true,
    field: "size_in_kb",
    minWidth: 120,
  },
  {
    headerName: "LAST MODIFILED",
    resizable: true,
    field: "last_modified",
    minWidth: 120,
  },
  {
    headerName: "DOCUMENT TYPE",
    resizable: true,
    field: "file_type",
    minWidth: 120,
  },
  {
    headerName: "ATTACHED FILE",
    resizable: true,
    field: "filename",
    minWidth: 120,
    cellRenderer: function (params) {
      // Assuming params.value contains the URL for the attached file
      if (params.value) {
        return <Link>{params.value}</Link>;
      } else {
        return ""; // Empty string for cases where there is no attached file
      }
    },
  },
  // { headerName: "DOWNLOAD", resizable: true, field: "", minWidth: 120 },
];

/*---------Invoice Communication User Notes-----------*/
export const invoiceCommunicationUserNotesTable = [
  { headerName: "ATTACHED FILE", resizable: true, field: "", minWidth: 120 },
  { headerName: "FOLDER", resizable: true, field: "", minWidth: 120 },
  { headerName: "SIZE(KB)", resizable: true, field: "", minWidth: 120 },
  { headerName: "LAST MODIFILED", resizable: true, field: "", minWidth: 120 },
  { headerName: "DOCUMENT TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DOWNLOAD",
    resizable: true,
    field: "",
    minWidth: 120,
    cellRenderer: () => (
      <Button sx={{ margin: 1, color: "#0066b2" }}>
        {" "}
        <DownloadIcon />
      </Button>
    ),
  },
];
/*---------Invoice Payment-----------*/
export const invoicePayment = [
  {
    headerName: "DATE",
    resizable: true,
    field: "date",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
    cellRenderer: renderRevenueNavigator,
  },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  {
    headerName: "NUMBER",
    resizable: true,
    field: "number",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "STATUS", resizable: true, field: "status", minWidth: 120 },
  {
    headerName: "AMOUNT",
    resizable: true,
    field: "formatted_amount",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];
/*---------Invoice Related Record Transformation-----------*/
export const invoiceTransformationTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
    // cellRenderer:renderRevenueNavigator,
  },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "NUMBER",
    resizable: true,
    field: "number",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "AMOUNT",
    resizable: true,
    field: "amount",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];
/*---------Invoice Related Record -----------*/
export const invoiceRevenueArrangement = [
  {
    headerName: "DATE",
    resizable: true,
    field: "date",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
    cellRenderer: renderRevenueNavigator,
  },
  { headerName: "TYPE", resizable: true, field: "linktype", minWidth: 120 },
  {
    headerName: "NUMBER",
    resizable: true,
    field: "number",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "STATUS", resizable: true, field: "status", minWidth: 120 },
  {
    headerName: "LINK TYPE",
    resizable: true,
    field: "linktype",
    minWidth: 120,
  },
  {
    headerName: "AMOUNT",
    resizable: true,
    field: "amount",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];
/*------------Invoice System Information System Notes--------------*/
export const invoiceSystemNotesTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "date",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "SET BY", resizable: true, field: "", minWidth: 120 },
  { headerName: "CONTEXT", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "FIELD", resizable: true, field: "", minWidth: 120 },
  { headerName: "OLD VALUE", resizable: true, field: "", minWidth: 120 },
  { headerName: "NEW VALUE", resizable: true, field: "", minWidth: 120 },
];

/*------------Invoice System Information Active Workflows--------------*/
export const invoiceActiveWorkfowTables = [
  { headerName: "WORKFLOW", resizable: true, field: "", minWidth: 120 },
  { headerName: "CURRENT STATE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE ENTERED WORKFLOW",
    resizable: true,
    field: "",
    minWidth: 180,
  },
  {
    headerName: "DATE ENTERED STATE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "OPTIONS", resizable: true, field: "", minWidth: 120 },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "CANCEL", resizable: true, field: "", minWidth: 120 },
];

/*------------Invoice System Information Workflow History--------------*/
export const invoiceWorkflowHistoryTables = [
  { headerName: "WORKFLOW", resizable: true, field: "", minWidth: 120 },
  { headerName: "STATE NAME INFO", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE ENTERED STATE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  {
    headerName: "DATE EXITIED STATE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "OPTIONS", resizable: true, field: "", minWidth: 120 },
  { headerName: "NOTES", resizable: true, field: "", minWidth: 120 },
];

/*------------Invoice System Information Applied Rules--------------*/
export const invoiceAppliedRulesTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "STATE NAME INFO", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE ENTERED STATE",
    resizable: true,
    field: "Context",
    minWidth: 120,
  },
  {
    headerName: "DATE EXITED STATE",
    resizable: true,
    field: "Type",
    minWidth: 120,
  },
  { headerName: "OPTIONS", resizable: true, field: "Field", minWidth: 120 },

  { headerName: "LOG", resizable: true, field: "", minWidth: 120 },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 160 },
];
/*---------Invoice Approver List--------*/
export const invoiceApproverList = [
  { headerName: "#", resizable: true, field: "", minWidth: 120 },
  { headerName: "RULE SEQUENCE", resizable: true, field: "", minWidth: 120 },
  { headerName: "APPROVER", resizable: true, field: "", minWidth: 120 },
  { headerName: "DATE/TIME", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "APPROVER ROLE",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "APPROVAL STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "NOTE", resizable: true, field: "", minWidth: 120 },
  { headerName: "SUPER APPROVED", resizable: true, field: "", minWidth: 120 },
];
/*----------Invoice Ava Tax-------*/
export const invoiceAvaTaxTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "AUTHOR", resizable: true, field: "", minWidth: 120 },
  { headerName: "TITLE", resizable: true, field: "", minWidth: 120 },
  { headerName: "MEMO", resizable: true, field: "", minWidth: 120 },
];
/*--------Invoice Custom FAM Asset Table---------*/
export const invoiceFamAssetTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "ID", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "ASSET DESCRIPTION",
    resizable: true,
    field: "",
    minWidth: 140,
  },
  { headerName: "ASSET TYPE", resizable: true, field: "", minWidth: 100 },
  {
    headerName: "ASSET ORIGINAL COST",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  {
    headerName: "ASSET CURRENT COST",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  {
    headerName: "DEPRECIATION METHOD",
    resizable: true,
    field: "",
    minWidth: 170,
  },
  { headerName: "ASSET LIFETIME", resizable: true, field: "", minWidth: 120 },
  { headerName: "ASSET STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "COMPONENT OF", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "QUANTITY",
    resizable: true,
    field: "",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "BUSINESS UNIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];
/*---------Invoice Custom Journal Reject Reason--------*/
export const invoiceCustomJournalRejectReasonTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "ID", resizable: true, field: "", minWidth: 120 },
  { headerName: "REJECT REASON", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];
/*---------Invoice Custom FAM Depreciation History--------*/
export const invoiceFAMDepreciationHistoryTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "ACCOUNTING BOOK", resizable: true, field: "", minWidth: 150 },
  { headerName: "TRANSACTION TYPE", resizable: true, field: "", minWidth: 150 },
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "PERIOD",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "TRANSACTION AMOUNT",
    resizable: true,
    field: "",
    minWidth: 180,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "DEPRECIATION POSTING REFERENCE",
    resizable: true,
    field: "",
    minWidth: 240,
  },
  {
    headerName: "QUANTITY",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "SCHEDULE", resizable: true, field: "", minWidth: 120 },
  { headerName: "SCHEDULED NBV", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "PARENT ASSET VALUE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "PRIOR YEAR NBV", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DEPRECIATION PRIOD",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "BUSINESS UNIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];
/*----------------Bill Table-------------------*/
export const transactionTypeDetailBill = [
  {
    headerName: "View",
    resizable: true,
    field: "documentno",
    cellRenderer: renderNavigator,
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Internal Id",
    resizable: true,
    field: "id",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Date",
    resizable: true,
    sortable: true,
    field: "date",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  // { headerName: "Print", resizable: true, field: "print", minWidth: 100, },
  {
    headerName: "Document Number",
    resizable: true,
    field: "documentno",
    minWidth: 140,
    headerClass: "justify-right",
    sortable: true,
    cellClass: " text-right",
  },
  {
    headerName: "Subsidiary",
    resizable: true,
    field: "subsidiary",
    minWidth: 140,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  // { headerName: "Payroll Batch", resizable: true, field: "payrollbatch", minWidth: 140, },

  {
    headerName: "Transaction Number",
    resizable: true,
    sortable: true,
    field: "transactionno",
    minWidth: 160,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  // { headerName: "Transaction Number", resizable: true, field: "transactionno", minWidth: 160, headerClass: "justify-right", cellClass: " text-right", },
  {
    headerName: "Name",
    resizable: true,
    field: "name",
    minWidth: 350,
  },
  {
    headerName: "PC/PROJECT",
    resizable: true,
    field: "pc_project",
    minWidth: 250,
  },
  {
    headerName: "Account",
    resizable: true,
    field: "account",
    minWidth: 240,
  },
  {
    headerName: "PO/Check Number",
    resizable: true,
    field: "po",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Status",
    resizable: true,
    field: "status",
    minWidth: 100,
  },
  {
    headerName: "Memo",
    resizable: true,
    field: "memo",
    minWidth: 100,
  },
  {
    headerName: "Currency",
    resizable: true,
    field: "currency",
    minWidth: 100,
  },
  {
    headerName: "Amount (Foreign Currency)",
    resizable: true,
    field: "amount_foreign",
    minWidth: 200,
  },
  {
    headerName: "Amount",
    resizable: true,
    field: "amount",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  // { headerName: "Transaction Units", resizable: true, field: "transaction_units", minWidth: 140, },
  {
    headerName: "Posting",
    resizable: true,
    field: "posting",
    minWidth: 100,
  },

  // New columns added as per request:
  {
    headerName: "Email Sent",
    resizable: true,
    field: "email_sent",
    minWidth: 120,
    headerClass: "justify-center",
    cellClass: "text-center",
  },
  {
    headerName: "Do Not Send Email",
    resizable: true,
    field: "do_not_send_email",
    minWidth: 150,
    headerClass: "justify-center",
    cellClass: "text-center",
  },
  {
    headerName: "Expense Report Status",
    resizable: true,
    field: "expense_report_status",
    minWidth: 160,
    headerClass: "justify-center",
    cellClass: "text-center",
  },
  {
    headerName: "NSC PO Number",
    resizable: true,
    field: "nsc_po_number",
    minWidth: 140,
    headerClass: "justify-center",
    cellClass: "text-center",
  },
  {
    headerName: "Preferred Entity Bank",
    resizable: true,
    field: "preferred_entity_bank",
    minWidth: 180,
    headerClass: "justify-center",
    cellClass: "text-center",
  },
  {
    headerName: "Vendor Bank Fees",
    resizable: true,
    field: "vendor_bank_fees",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: "text-right",
  },
  {
    headerName: "Bank Fee",
    resizable: true,
    field: "bank_fee",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: "text-right",
  },
  {
    headerName: "Created By",
    resizable: true,
    field: "created_by",
    minWidth: 140,
  },
  {
    headerName: "Vendor Bill Approval Status",
    resizable: true,
    field: "vendor_bill_approval_status",
    minWidth: 200,
  },
  {
    headerName: "Entity Bank (Vendor)",
    resizable: true,
    field: "entity_bank_vendor",
    minWidth: 180,
    headerClass: "justify-center",
    cellClass: "text-center",
  },
  {
    headerName: "Entity Bank (Employee)",
    resizable: true,
    field: "entity_bank_employee",
    minWidth: 180,
    headerClass: "justify-center",
    cellClass: "text-center",
  },
  {
    headerName: "Exclude from Electronic Bank Payments Processing",
    resizable: true,
    field: "exclude_from_electronic_processing",
    minWidth: 250,
    headerClass: "justify-center",
    cellClass: "text-center",
  },
  {
    headerName: "Entity Bank (Customer)",
    resizable: true,
    field: "entity_bank_customer",
    minWidth: 180,
    headerClass: "justify-center",
    cellClass: "text-center",
  },
  {
    headerName: "Entity Bank (Customer Credit)",
    resizable: true,
    field: "entity_bank_customer_credit",
    minWidth: 200,
    headerClass: "justify-center",
    cellClass: "text-center",
  },
  {
    headerName: "Invoice Resend Email",
    resizable: true,
    field: "invoice_resend_email",
    minWidth: 150,
    headerClass: "justify-center",
    cellClass: "text-center",
  },
  {
    headerName: "Invoice Additional Attachments",
    resizable: true,
    field: "invoice_additional_attachments",
    minWidth: 200,
    headerClass: "justify-center",
    cellClass: "text-center",
  },
];

/*---------Customer Payment Apply Table---------*/
export const PaymentAppliedTable = [
  { headerName: "DATE ", resizable: true, field: "date", minWidth: 120 },
  {
    headerName: "PC/PROJECT/SUB ",
    resizable: true,
    field: "pc_project",
    minWidth: 200,
  },
  {
    headerName: "TYPE ",
    resizable: true,
    field: "type",
    minWidth: 120,
    cellRenderer: renderAppliedNavigator,

  },
  { headerName: "REF NO. ", resizable: true, field: "refno", minWidth: 120 },
  {
    headerName: "ORIG. AMT.",
    resizable: true,
    field: "orig_amt",
    minWidth: 120,
  },
  { headerName: "AMT. DUE", resizable: true, field: "amt_due", minWidth: 120 },
  {
    headerName: "CURRENCY ",
    resizable: true,
    field: "currency",
    minWidth: 120,
  },
  {
    headerName: "DISC. DATE ",
    resizable: true,
    field: "disc_date",
    minWidth: 120,
  },
  {
    headerName: " DISC. AVAIL.",
    resizable: true,
    field: "disc_avail",
    minWidth: 120,
  },
  {
    headerName: "DISC. TAKEN",
    resizable: true,
    field: "disc_taken",
    minWidth: 120,
  },
  { headerName: "PAYMENT", resizable: true, field: "payment", minWidth: 120 },
];

export const PaymentCreditTable = [
  { headerName: "DATE ", resizable: true, field: "date", minWidth: 120 },
  { headerName: "TYPE ", resizable: true, field: "type", minWidth: 120 },
  { headerName: "REF NO. ", resizable: true, field: "refno", minWidth: 120 },
  {
    headerName: "APPLIED TO ",
    resizable: true,
    field: "applied_to",
    minWidth: 120,
  },
  {
    headerName: "CURRENCY ",
    resizable: true,
    field: "currency",
    minWidth: 120,
  },
  { headerName: "CREDIT", resizable: true, field: "credit", minWidth: 120 },
];
export const PaymentDepositTable = [
  { headerName: "DATE ", resizable: true, field: "date", minWidth: 120 },
  { headerName: "REF NO. ", resizable: true, field: "refno", minWidth: 120 },
  {
    headerName: " ORIG. AMT.",
    resizable: true,
    field: "orig_amt",
    minWidth: 120,
  },
  {
    headerName: "AMOUNT REMAINING ",
    resizable: true,
    field: "amt_remaining",
    minWidth: 120,
  },
  {
    headerName: "CURRENCY ",
    resizable: true,
    field: "currency",
    minWidth: 120,
  },
  { headerName: "PAYMENT", resizable: true, field: "payment", minWidth: 120 },
];

/*---------Sales Order Item Table---------*/
export const billExpensesTable = [
  { headerName: "CATEGORY", resizable: true, field: "category", minWidth: 120 },
  { headerName: " CLIN #", resizable: true, field: "clin", minWidth: 120 },
  {
    headerName: "PC/PROJECT",
    resizable: true,
    field: "pc_project",
    minWidth: 250,
  },
  { headerName: "ACCOUNT", resizable: true, field: "account", minWidth: 350 },
  { headerName: "AMOUNT", resizable: true, field: "amount", minWidth: 120 },
  { headerName: "LOCATION", resizable: true, field: "location", minWidth: 120 },
  { headerName: "MEMO", resizable: true, field: "memo", minWidth: 120 },
  { headerName: "COMMENTS", resizable: true, field: "comments", minWidth: 180 },
  { headerName: "BILLABLE", resizable: true, field: "billable", minWidth: 120 },
  {
    headerName: "AMORT.SCHEDULE",
    resizable: true,
    field: "amortization_schedule",
    minWidth: 120,
  },
  {
    headerName: "AMORT.START",
    resizable: true,
    field: "amortization_start",
    minWidth: 120,
  },
  {
    headerName: "AMORT.END",
    resizable: true,
    field: "amortization_end",
    minWidth: 120,
  },
  // { headerName: "EXPENSE REPORT VENDOR", resizable: true, field: "expense_reoprt_vendor", minWidth: 120 },
  // {
  //   headerName: "NEW VENDOR TEXT",
  //   resizable: true,
  //   field: "new_vendor",
  //   minWidth: 120,
  // },
  // // { headerName: "REF NO", resizable: true, field: "ref_no", minWidth: 120 },
  // { headerName: "GOVT CLIN NUMBER", resizable: true, field: "govt_clin_number", minWidth: 120 },
  {
    headerName: "VAT CODE",
    resizable: true,
    field: "vat_code",
    minWidth: 120,
  },
  {
    headerName: "VAT BIN",
    resizable: true,
    field: "vat_bin",
    minWidth: 120,
  },

  { headerName: "HISTORY", resizable: true, field: "history", minWidth: 120 },
];
/*bill items table */
export const billItemsTable = [
  { headerName: "ITEM", resizable: true, field: "item", minWidth: 120 },
  {
    headerName: "VENDOR TEXT",
    resizable: true,
    field: "vendor_text",
    minWidth: 120,
  },
  {
    headerName: "MFG. CATALOG NUMBER (NSC ITEM CODE)",
    resizable: true,
    field: "mfg_catalog_number",
    minWidth: 180,
  },
  {
    headerName: "DESCRIPTION",
    resizable: true,
    field: "description",
    minWidth: 350,
  },
  { headerName: "QUANTITY", resizable: true, field: "quantity", minWidth: 120 },
  {
    headerName: "TAX AMOUNT PAYABLE TO VENDOR (IF NOT IN RATE)",
    resizable: true,
    field: "tax_amount_payable",
    minWidth: 180,
  },
  { headerName: "RATE", resizable: true, field: "rate", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "amount", minWidth: 120 },
  {
    headerName: "PC/PROJECT CUSTOMER",
    resizable: true,
    field: "pc_project",
    minWidth: 120,
  },
  { headerName: "BILLABLE", resizable: true, field: "billable", minWidth: 120 },
  {
    headerName: "AMORT. SCHEDULE",
    resizable: true,
    field: "amort_schedule",
    minWidth: 120,
  },
  {
    headerName: "AMORT. START",
    resizable: true,
    field: "amort_start",
    minWidth: 120,
  },
  {
    headerName: "AMORT. END",
    resizable: true,
    field: "amort_end",
    minWidth: 120,
  },
  { headerName: "RESIDUAL", resizable: true, field: "residual", minWidth: 120 },
  {
    headerName: "LOCATION OPTIONS",
    resizable: true,
    field: "location_options",
    minWidth: 180,
  },
  {
    headerName: "ASSET ACCOUNT",
    resizable: true,
    field: "asset_account",
    minWidth: 120,
  },
  {
    headerName: "EXPENSE ACCOUNT",
    resizable: true,
    field: "expense_account",
    minWidth: 120,
  },
  {
    headerName: "GOVT CLIN #",
    resizable: true,
    field: "govt_clin_number",
    minWidth: 120,
  },
  {
    headerName: "PRE-OWNED ITEM (2)",
    resizable: true,
    field: "pre_owned_item",
    minWidth: 120,
  },
  { headerName: "VAT CODE", resizable: true, field: "vat_code", minWidth: 120 },
  { headerName: "COMMENTS", resizable: true, field: "comments", minWidth: 180 },
  { headerName: "VAT BIN", resizable: true, field: "vat_bin", minWidth: 120 },
  { headerName: "HISTORY", resizable: true, field: "history", minWidth: 120 },
];

/*--------Bill Relationship Contact Table---------*/
export const billRelationshipContactTable = [
  { headerName: "EDIT", resizable: true, field: "Internal ID", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "Name", minWidth: 120 },
  { headerName: "COMPANY", resizable: true, field: "Company", minWidth: 120 },
  {
    headerName: "JOB TITLE",
    resizable: true,
    field: "Job Title",
    minWidth: 120,
  },
  { headerName: "PHONE", resizable: true, field: "Phone", minWidth: 120 },
  { headerName: "EMAIL", resizable: true, field: "Email", minWidth: 120 },
  { headerName: "ROLE", resizable: true, field: "Role", minWidth: 100 },
  {
    headerName: "REMOVE",
    resizable: true,
    field: "",
    cellRenderer: () => <p style={{ margin: 1 }}>Remove</p>,
    minWidth: 120,
  },
];
/*---------Bill Communication Messages-----------*/
export const billMessageTable = [
  {
    headerName: "#",
    field: "count",
    resizable: true,
    minWidth: 80,
    cellRenderer: (params) => {
      return params.node.rowIndex + 1;
    },
  },
  {
    headerName: "View",
    resizable: true,
    field: "view",
    minWidth: 90,
    cellRenderer: renderViewNavigator,
    valueGetter: (params) => {
      return "View";
    },
  },
  {
    headerName: "DATE",
    resizable: true,
    field: "date",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "AUTHOR", resizable: true, field: "Author", minWidth: 120 },
  {
    headerName: "PRIMARY RECIPIENT",
    resizable: true,
    field: "primary_recipient",
    minWidth: 150,
  },
  { headerName: "SUBJECT", resizable: true, field: "Subject", minWidth: 400 },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  { headerName: "FILES", resizable: true, field: "Files", minWidth: 120 },
  {
    headerName: "ATTACHMENTS",
    resizable: true,
    field: "attachments",
    minWidth: 250,
    cellRenderer: renderTAbNavigator,
  },
  {
    headerName: "INTERNAL ONLY",
    resizable: true,
    field: "",
    cellRenderer: () => <p style={{ margin: 1 }}>Internal Only</p>,
    minWidth: 120,
  },
  {
    headerName: "REMOVE",
    resizable: true,
    field: "",
    cellRenderer: () => <p style={{ margin: 1 }}>Remove</p>,
    minWidth: 120,
  },
];
/*---------Bill Communication Activities-----------*/
export const billCommunicationActivitiesTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "TITLE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "TIME", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "OWNER",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "ASSIGNED TO", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "MARK", resizable: true, field: "", minWidth: 120 },
  // { headerName: "TASK DUE DATE", resizable: true, field: "", minWidth: 120 },
  // { headerName: "NEXT STEP", resizable: true, field: "", minWidth: 120 },
];

export const projectCommunicationActivitiesTable = [
  // { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "TITLE", resizable: true, field: "TITLE", minWidth: 120 },
  {
    headerName: "DATE",
    resizable: true,
    field: "DATE",
    minWidth: 90,
  },
  { headerName: "TIME", resizable: true, field: "TIME", minWidth: 120 },
  {
    headerName: "OWNER",
    resizable: true,
    field: "OWNER",
    minWidth: 120,
  },
  { headerName: "STATUS", resizable: true, field: "STATUS", minWidth: 120 },
  {
    headerName: "ASSIGNED TO",
    resizable: true,
    field: "ASSIGNED_TO",
    minWidth: 120,
  },
  { headerName: "TYPE", resizable: true, field: "TYPE", minWidth: 120 },
  { headerName: "MARK", resizable: true, field: "MARK", minWidth: 120 },
];
/*---------Bill Communication Files-----------*/
export const billCommunicationFilesTable = [
  {
    headerName: "ATTACHED FILES",
    resizable: true,
    field: "filename",
    minWidth: 150,
    cellRenderer: renderTAbNavigator,
  },
  { headerName: "FOLDER", resizable: true, field: "folder", minWidth: 150 },
  {
    headerName: "SIZE(KB)",
    resizable: true,
    field: "size_in_kb",
    maxWidth: 90,
  },
  {
    headerName: "LAST MODIFILED",
    resizable: true,
    field: "last_modified",
    maxWidth: 150,
  },
  {
    headerName: "DOCUMENT TYPE",
    resizable: true,
    field: "file_type",
    maxWidth: 200,
  },
  {
    headerName: "REMOVE",
    resizable: true,
    field: "remove",
    maxWidth: 100,
    cellRenderer: () => <p style={{ margin: 1 }}>Remove</p>,
  },
  {
    headerName: "EDIT",
    resizable: true,
    field: "",
    maxWidth: 100,
    cellRenderer: () => <p style={{ margin: 1 }}>Edit</p>,
  },
  {
    headerName: "DOWNLOAD",
    cellRenderer: () => (
      <Button sx={{ margin: 1, color: "#0066b2" }}>
        {" "}
        <DownloadIcon />
      </Button>
    ),
    resizable: true,
    field: "transaction_id",
    maxWidth: 100,
  },
];

export const projectCommunicationFilesTable = [
  {
    headerName: "ATTACHED FILES",
    resizable: true,
    field: "ATTACHED_FILES",
    minWidth: 120,
  },
  { headerName: "FOLDER", resizable: true, field: "FOLDER", minWidth: 120 },
  {
    headerName: "SIZE(KB)",
    resizable: true,
    field: "SIZE",
    minWidth: 120,
  },
  {
    headerName: "LAST MODIFILED",
    resizable: true,
    field: "LAST_MODIFILED",
    minWidth: 120,
  },
  {
    headerName: "DOCUMENT TYPE",
    resizable: true,
    field: "DOCUMENT_TYPE",
    minWidth: 120,
  },
  {
    headerName: "REMOVE",
    resizable: true,
    field: "REMOVE",
    minWidth: 120,
  },
  {
    headerName: "EDIT",
    resizable: true,
    field: "EDIT",
    minWidth: 120,
  },
  {
    headerName: "DOWNLOAD",
    cellRenderer: () => (
      <Button sx={{ margin: 1, color: "#0066b2" }}>
        {" "}
        <DownloadIcon />
      </Button>
    ),
    resizable: true,
    field: "DOWNLOAD",
    maxWidth: 120,
  },
];
/*---------Bill Communication User Notes-----------*/
export const billCommunicationUserNotesTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 80 },
  // { headerName: "Document Number", resizable: true, field: "Document Number", minWidth: 140 },
  { headerName: "DATE", resizable: true, field: "Date", minWidth: 140 },
  { headerName: "AUTHOR", resizable: true, field: "Author", minWidth: 120 },
  { headerName: "TITLE", resizable: true, field: "Title", minWidth: 120 },
  { headerName: "MEMO", resizable: true, field: "Memo", minWidth: 220 },
  {
    headerName: "DIRECTION",
    resizable: true,
    field: "Direction",
    minWidth: 120,
  },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  // { headerName: "Company", resizable: true, field: "Company", minWidth: 220 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];
/*---------Bill Related Records Payment-----------*/
export const billRelatedRecordsPayment = [
  {
    headerName: "DATE",
    resizable: true,
    field: "date",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
    cellRenderer: renderRevenueNavigator,
  },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  {
    headerName: "NUMBER",
    resizable: true,
    field: "number",
    minWidth: 120,
  },
  {
    headerName: "STATUS",
    resizable: true,
    field: "status",
    minWidth: 120,
  },
  {
    headerName: "AMOUNT",
    resizable: true,
    field: "formatted_amount",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];
/*---------Bill Related Records  Purchase Order-----------*/
export const billRelatedRecordsPurchaseOrder = [
  { headerName: "DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "NUMBER", resizable: true, field: "", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "", minWidth: 120 },
];
/*---------Bill Related Records Reimbursements -----------*/
export const billRelatedRecordsReimbursements = [
  { headerName: "DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "NUMBER", resizable: true, field: "", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "", minWidth: 120 },
];
/*---------Bill Related Records Transformations -----------*/
export const billRelatedRecordsTransformations = [
  { headerName: "DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "NUMBER", resizable: true, field: "", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "", minWidth: 120 },
];
/*------------Bill System Information System Notes--------------*/
export const billSystemNotesTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "Date",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "SET BY", resizable: true, field: "Set by", minWidth: 120 },
  { headerName: "CONTEXT", resizable: true, field: "Context", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "Type", minWidth: 120 },
  { headerName: "FIELD", resizable: true, field: "Field", minWidth: 120 },
  {
    headerName: "OLD VALUE",
    resizable: true,
    field: "Old Value",
    minWidth: 120,
  },
  {
    headerName: "NEW VALUE",
    resizable: true,
    field: "New Value",
    minWidth: 120,
  },
];

/*------------Bill System Information Active Workflows--------------*/
export const billActiveWorkfowTables = [
  { headerName: "WORKFLOW", resizable: true, field: "", minWidth: 120 },
  { headerName: "CURRENT STATE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE ENTERED WORKFLOW",
    resizable: true,
    field: "",
    minWidth: 180,
  },
  {
    headerName: "DATE ENTERED STATE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "OPTIONS", resizable: true, field: "", minWidth: 120 },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "CANCEL", resizable: true, field: "", minWidth: 120 },
];

/*------------Bill System Information Workflow History--------------*/
export const billWorkflowHistoryTables = [
  { headerName: "WORKFLOW", resizable: true, field: "", minWidth: 120 },
  { headerName: "STATE NAME INFO", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE ENTERED STATE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  {
    headerName: "DATE EXITIED STATE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "OPTIONS", resizable: true, field: "", minWidth: 120 },
  { headerName: "NOTES", resizable: true, field: "", minWidth: 120 },
];

/*------------Bill System Information Applied Rules--------------*/
export const billAppliedRulesTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "RULE TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "DETAILS", resizable: true, field: "", minWidth: 160 },
];
/*--------customer payment Table---------*/
export const paymentTable = [
  { headerName: "DATE", resizable: true, field: "date", minWidth: 120 },
  {
    headerName: "DOCUMENT NUMBER",
    resizable: true,
    field: "document_number",
    minWidth: 150,
  },
  { headerName: "NAME", resizable: true, field: "name", minWidth: 150 },
  { headerName: "ACCOUNT", resizable: true, field: "account", minWidth: 150 },
  {
    headerName: "PO/CHECK NUMBER",
    resizable: true,
    field: "po_check_number",
    minWidth: 150,
  },
  { headerName: "STATUS", resizable: true, field: "status", minWidth: 120 },
  { headerName: "MEMO", resizable: true, field: "memo", minWidth: 180 },
  { headerName: "CURRENCY", resizable: true, field: "currency", minWidth: 100 },
  {
    headerName: "AMOUNT (FOREIGN CURRENCY)",
    resizable: true,
    field: "foreign_currency_amount",
    minWidth: 180,
  },
  { headerName: "AMOUNT", resizable: true, field: "amount", minWidth: 170 },
  {
    headerName: "EMAIL SENT",
    resizable: true,
    field: "email_sent",
    minWidth: 120,
  },
  {
    headerName: "DO NOT SEND EMAIL",
    resizable: true,
    field: "do_not_send_email",
    minWidth: 150,
  },
  {
    headerName: "EXPENSE REPORT STATUS",
    resizable: true,
    field: "expense_report_status",
    minWidth: 180,
  },
  {
    headerName: "NSC PO NUMBER",
    resizable: true,
    field: "nsc_po_number",
    minWidth: 150,
  },
  {
    headerName: "PREFERRED ENTITY BANK",
    resizable: true,
    field: "preferred_entity_bank",
    minWidth: 180,
  },
  {
    headerName: "VENDOR BANK FEES",
    resizable: true,
    field: "vendor_bank_fees",
    minWidth: 150,
  },
  { headerName: "BANK FEE", resizable: true, field: "bank_fee", minWidth: 120 },
  {
    headerName: "CREATED BY",
    resizable: true,
    field: "created_by",
    minWidth: 150,
  },
  {
    headerName: "VENDOR BILL APPROVAL STATUS",
    resizable: true,
    field: "vendor_bill_approval_status",
    minWidth: 180,
  },
  {
    headerName: "ENTITY BANK (VENDOR)",
    resizable: true,
    field: "entity_bank_vendor",
    minWidth: 180,
  },
  {
    headerName: "ENTITY BANK (EMPLOYEE)",
    resizable: true,
    field: "entity_bank_employee",
    minWidth: 180,
  },
  {
    headerName: "EXCLUDE FROM ELECTRONIC BANK PAYMENTS PROCESSING",
    resizable: true,
    field: "exclude_from_electronic_payments",
    minWidth: 230,
  },
  {
    headerName: "ENTITY BANK (CUSTOMER)",
    resizable: true,
    field: "entity_bank_customer",
    minWidth: 180,
  },
  {
    headerName: "ENTITY BANK (CUSTOMER CREDIT)",
    resizable: true,
    field: "entity_bank_customer_credit",
    minWidth: 180,
  },
  {
    headerName: "INVOICE RESEND EMAIL",
    resizable: true,
    field: "invoice_resend_email",
    minWidth: 150,
  },
  {
    headerName: "INVOICE ADDITIONAL ATTACHMENTS",
    resizable: true,
    field: "invoice_additional_attachments",
    minWidth: 180,
  },
];

export const paymentMethodDepositsTable = [
  {
    headerName: "EDIT",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: "text-right",
  },
  {
    headerName: "DOCUMENT NUMBER",
    resizable: true,
    field: "document_number",
    minWidth: 150,
  },
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "APPLIED TO TRANSACTION",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "AS-OF DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "PERIOD", resizable: true, field: "", minWidth: 120 },
  { headerName: "TAX PERIOD", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "ACCOUNT", resizable: true, field: "", minWidth: 120 },
  { headerName: "MEMO", resizable: true, field: "", minWidth: 160 },
  { headerName: "AMOUNT", resizable: true, field: "", minWidth: 120 },
];
/*--------Bill Custom FAM Asset Table---------*/
export const billFamAssetTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "ID", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "ASSET DESCRIPTION",
    resizable: true,
    field: "",
    minWidth: 140,
  },
  { headerName: "ASSET TYPE", resizable: true, field: "", minWidth: 100 },
  {
    headerName: "ASSET ORIGINAL COST",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  {
    headerName: "ASSET CURRENT COST",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  {
    headerName: "DEPRECIATION METHOD",
    resizable: true,
    field: "",
    minWidth: 170,
  },
  { headerName: "ASSET LIFETIME", resizable: true, field: "", minWidth: 120 },
  { headerName: "ASSET STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "COMPONENT OF", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "QUANTITY",
    resizable: true,
    field: "",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "BUSINESS UNIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];
/*---------Bill Custom Journal Reject Reason--------*/
export const billCustomJournalRejectReasonTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "ID", resizable: true, field: "", minWidth: 120 },
  { headerName: "REJECT REASON", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];
/*---------Bill Custom FAM Depreciation History--------*/
export const billFAMDepreciationHistoryTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "ACCOUNTING BOOK", resizable: true, field: "", minWidth: 150 },
  { headerName: "TRANSACTION TYPE", resizable: true, field: "", minWidth: 150 },
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "PERIOD",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "TRANSACTION AMOUNT",
    resizable: true,
    field: "",
    minWidth: 180,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "DEPRECIATION POSTING REFERENCE",
    resizable: true,
    field: "",
    minWidth: 240,
  },
  {
    headerName: "QUANTITY",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "SCHEDULE", resizable: true, field: "", minWidth: 120 },
  { headerName: "SCHEDULED NBV", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "PARENT ASSET VALUE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "PRIOR YEAR NBV", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DEPRECIATION PRIOD",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "BUSINESS UNIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];
/*---------Bill Custom FAM Depreciation History--------*/
export const billApprovalHistoryTable = [
  { headerName: "ACTION DATE ", resizable: true, field: "", minWidth: 120 },
  { headerName: "ACTION", resizable: true, field: "", minWidth: 120 },
  { headerName: "ACTION OWNER", resizable: true, field: "", minWidth: 150 },
  { headerName: "APPROVAL STATUS ", resizable: true, field: "", minWidth: 150 },
  {
    headerName: "APPROVER TYPE ",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "NEXT APPROVER/S ",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "REMARKS ",
    resizable: true,
    field: "",
    minWidth: 180,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];
/*---------Bill Approver List--------*/
export const billApproverList = [
  { headerName: "#", resizable: true, field: "", minWidth: 120 },
  { headerName: "RULE SEQUENCE", resizable: true, field: "", minWidth: 120 },
  { headerName: "APPROVER", resizable: true, field: "", minWidth: 120 },
  { headerName: "DATE/TIME", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "APPROVER ROLE",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "APPROVAL STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "NOTE", resizable: true, field: "", minWidth: 120 },
  { headerName: "SUPER APPROVED", resizable: true, field: "", minWidth: 120 },
];
/*----------Bill Ava Tax-------*/
export const billAvaTaxTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "date",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "AUTHOR", resizable: true, field: "author", minWidth: 120 },
  { headerName: "TITLE", resizable: true, field: "title", minWidth: 120 },
  { headerName: "MEMO", resizable: true, field: "memo", minWidth: 120 },
];
/*----------Bill GL IMPACT-------*/
export const billGLImpaactTable = [
  { headerName: "ACCOUNT", resizable: true, field: "", minWidth: 120 },
  { headerName: "DEBIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "CREDIT", resizable: true, field: "", minWidth: 120 },
];
/*----------Bill Philippines Invoicing-------*/
export const billPhilippinesInvoicingTable = [
  {
    headerName: "EDIT",
    resizable: true,
    field: "",
    minWidth: 90,
  },
  { headerName: "PRINT NUMBER", resizable: true, field: "", minWidth: 120 },
  { headerName: "HEADER OBJECT", resizable: true, field: "", minWidth: 120 },
  { headerName: "FOOTER OBJECT", resizable: true, field: "", minWidth: 120 },
];
/*----------------Credit Memo-------------------*/
export const transactionTypeCreditMemo = [
  {
    headerName: "View",
    resizable: true,
    field: "documentno",
    cellRenderer: renderNavigator,
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Date",
    resizable: true,
    sortable: true,
    field: "date",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: "text-right",
  },
  // {
  //   headerName: "Print",
  //   resizable: true,
  //   field: "print",
  //   minWidth: 100
  // },
  {
    headerName: "Document Number",
    resizable: true,
    field: "documentno",
    minWidth: 140,
    sortable: true,
    headerClass: "justify-right",
    cellClass: "text-right",
  },
  {
    headerName: "Name",
    resizable: true,
    field: "name",
    minWidth: 340,
  },
  {
    headerName: "Account",
    resizable: true,
    field: "account",
    minWidth: 240,
  },
  {
    headerName: "PC/PROJECT",
    field: "pc_project",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    minWidth: 350,
  },
  {
    headerName: "PO/Check Number",
    resizable: true,
    field: "po",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: "text-right",
  },
  {
    headerName: "Status",
    resizable: true,
    field: "status",
    minWidth: 100,
  },
  {
    headerName: "Memo",
    resizable: true,
    field: "memo",
    minWidth: 200,
  },
  {
    headerName: "Currency",
    resizable: true,
    field: "currency",
    minWidth: 100,
  },
  {
    headerName: "Amount (Foreign Currency)",
    resizable: true,
    field: "amount_foreign",
    minWidth: 200,
  },
  {
    headerName: "Amount",
    resizable: true,
    field: "amount",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: "text-right",
  },
  {
    headerName: "Email Sent",
    resizable: true,
    field: "emailSent",
    minWidth: 120,
    headerClass: "justify-center",
    cellClass: "text-center",
  },
  {
    headerName: "Do Not Send Email",
    resizable: true,
    field: "doNotSendEmail",
    minWidth: 150,
    headerClass: "justify-center",
    cellClass: "text-center",
  },
  {
    headerName: "Expense Report Status",
    resizable: true,
    field: "expenseReportStatus",
    minWidth: 160,
  },
  {
    headerName: "NSC PO Number",
    resizable: true,
    field: "nscPoNumber",
    minWidth: 160,
  },
  {
    headerName: "Preferred Entity Bank",
    resizable: true,
    field: "preferredEntityBank",
    minWidth: 180,
  },
  {
    headerName: "Vendor Bank Fees",
    resizable: true,
    field: "vendorBankFees",
    minWidth: 160,
    headerClass: "justify-right",
    cellClass: "text-right",
  },
  {
    headerName: "Bank Fee",
    resizable: true,
    field: "bankFee",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: "text-right",
  },
  {
    headerName: "Created By",
    resizable: true,
    field: "createdBy",
    minWidth: 140,
  },
  {
    headerName: "Vendor Bill Approval Status",
    resizable: true,
    field: "vendorBillApprovalStatus",
    minWidth: 200,
  },
  {
    headerName: "Entity Bank (Vendor)",
    resizable: true,
    field: "entityBankVendor",
    minWidth: 180,
  },
  {
    headerName: "Entity Bank (Employee)",
    resizable: true,
    field: "entityBankEmployee",
    minWidth: 180,
  },
  {
    headerName: "Exclude from Electronic Bank Payments Processing",
    resizable: true,
    field: "excludeFromBankPayments",
    minWidth: 260,
    headerClass: "justify-center",
    cellClass: "text-center",
  },
  {
    headerName: "Entity Bank (Customer)",
    resizable: true,
    field: "entityBankCustomer",
    minWidth: 180,
  },
  {
    headerName: "Entity Bank (Customer Credit)",
    resizable: true,
    field: "entityBankCustomerCredit",
    minWidth: 200,
  },
  {
    headerName: "Invoice Resend Email",
    resizable: true,
    field: "invoiceResendEmail",
    minWidth: 180,
    headerClass: "justify-center",
    cellClass: "text-center",
  },
  {
    headerName: "Invoice Additional Attachments",
    resizable: true,
    field: "invoiceAdditionalAttachments",
    minWidth: 180,
  },
];
/*----------Credit Memo Item Table-------*/
export const creditMemoitemsTable = [
  // { headerName: "PROJECT", resizable: true, field: "project", minWidth: 120, cellRenderer: renderProjectIdNavigator,  },
  { headerName: "ITEM", resizable: true, field: "Item", minWidth: 120 },
  // {
  //   headerName: "REVENUE TYPE",
  //   resizable: true,
  //   field: "revenue_type",
  //   minWidth: 120,
  // },
  { headerName: "QUANTITY", resizable: true, field: "quantity", minWidth: 120 },
  // { headerName: "UNITS", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DESCRIPTION",
    resizable: true,
    field: "description",
    minWidth: 320,
  },
  {
    headerName: "PRICE LEVEL",
    resizable: true,
    field: "pricelevel",
    minWidth: 120,
  },
  { headerName: "RATE", resizable: true, field: "Rate", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "amount", minWidth: 120 },
  { headerName: "JOB", resizable: true, field: "job", minWidth: 120 },
  { headerName: "TAX CODE", resizable: true, field: "tax_code", minWidth: 120 },
  { headerName: "TAX RATE", resizable: true, field: "tax_rate", minWidth: 120 },
  { headerName: "CHARGES", resizable: true, field: "charge", minWidth: 120 },
  {
    headerName: "CHARGE TYPE",
    resizable: true,
    field: "charge_type",
    minWidth: 120,
  },
  {
    headerName: "CHARGE DESCRIPTION",
    resizable: true,
    field: "charge_description",
    minWidth: 120,
  },
  {
    headerName: "SHIP TO ENTITY/USE CODE",
    resizable: true,
    field: "shiptousecode",
    minWidth: 120,
  },

  { headerName: "OPTIONS", resizable: true, field: "options", minWidth: 120 },
  {
    headerName: "ITEM NAME",
    resizable: true,
    field: "item_name",
    minWidth: 120,
  },
  {
    headerName: "AVATAX AMOUNT",
    field: "tax_amount",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "GOV CLIN #",
    field: "giv_clin",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "HSN CODE", field: "hsn_code", resizable: true, minWidth: 150 },
  {
    headerName: "CUSTOM DUTY RATE",
    field: "custom_duty_rate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "PRE-OWNED ITEM (2)",
    field: "pre_owned_item",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "VAT CODE", field: "vat_code", resizable: true, minWidth: 150 },
  {
    headerName: "TAX AMOUNT",
    field: "tax_amount",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "RENTAL AND LEASING TAX RATE",
    field: "rental_leasing_rate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "RENTAL AND LEASING TAX",
    field: "rental_leasing_tax",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "CUSTOMER INVOICE LINE ATTACHMENT",
    field: "customer_invoice_line_attachment_name",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "SHIP FROM VAT BIN",
    field: "ship_from_vat_bin",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "SHIP TO VAT BIN",
    field: "ship_to_vat_bin",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "BOTTLE TAX RATE",
    field: "bottle_tax_rate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "BOTTLE TAX",
    field: "bottle_tax",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "RECYCLING FEES RATE",
    field: "recycling_fees_rate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "RECYCLING FEES",
    field: "recycling_fee",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "HISTORY", resizable: true, field: "history", minWidth: 120 },
  {
    headerName: "SELECTED TAX TYPE",
    resizable: true,
    field: "select_tax_type",
    minWidth: 120,
  },
];
/*----------Credit Memo Items Apply Table-------*/
export const creditMemoApplyTable = [
  { headerName: "DATE", resizable: true, field: "duedate", minWidth: 120 },
  {
    headerName: "PC/PROJECT/SUB",
    resizable: true,
    field: "history",
    minWidth: 120,
  },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  { headerName: "REF NO.", resizable: true, field: "refno", minWidth: 120 },

  {
    headerName: "ORIG. AMT.",
    resizable: true,
    field: "original_amt",
    minWidth: 120,
  },
  {
    headerName: "AMT. DUE",
    resizable: true,
    field: "amountdue",
    minWidth: 120,
  },
  { headerName: "CURRENCY", resizable: true, field: "currency", minWidth: 120 },
  { headerName: "PAYMENT", resizable: true, field: "payment", minWidth: 120 },
];
/*--------Credit Memo Relationship Contact Table---------*/
export const creditMemoRelationshipContactTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "COMPANY", resizable: true, field: "", minWidth: 120 },
  { headerName: "JOB TITLE", resizable: true, field: "", minWidth: 120 },
  { headerName: "PHONE", resizable: true, field: "", minWidth: 120 },
  { headerName: "EMAIL", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "EXPORT TO OPENAIR",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "ROLE", resizable: true, field: "", minWidth: 100 },
];
/*---------Credit Memo Communication Messages-----------*/
export const creditMemoMessageTable = [
  { headerName: "#", resizable: true, field: "", minWidth: 80 },
  { headerName: "VIEW", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "AUTHOR", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "PRIMARY RECIPIENT",
    resizable: true,
    field: "",
    minWidth: 150,
  },
  { headerName: "SUBJECT", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "FILES", resizable: true, field: "", minWidth: 120 },
  { headerName: "ATTACHMENTS", resizable: true, field: "", minWidth: 120 },
];
/*---------Credit Memo Communication Activities-----------*/
export const creditMemoCommunicationActivitiesTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "TITLE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "TIME", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "OWNER",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "ASSIGNED TO", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "MARK", resizable: true, field: "", minWidth: 120 },
  { headerName: "NEXT DUE DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "NEXT STEP", resizable: true, field: "", minWidth: 120 },
];

/*---------Credit Memo Communication Files-----------*/
export const creditMemoCommunicationFilesTable = [
  { headerName: "ATTACHED FILE", resizable: true, field: "", minWidth: 120 },
  { headerName: "FOLDER", resizable: true, field: "", minWidth: 120 },
  { headerName: "SIZE(KB)", resizable: true, field: "", minWidth: 120 },
  { headerName: "LAST MODIFILED", resizable: true, field: "", minWidth: 120 },
  { headerName: "DOCUMENT TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DOWNLOAD",
    resizable: true,
    field: "",
    minWidth: 120,
    cellRenderer: () => (
      <Button sx={{ margin: 1, color: "#0066b2" }}>
        {" "}
        <DownloadIcon />
      </Button>
    ),
  },
];
/*---------Credit Memo Communication User Notes-----------*/
export const creditMemoCommunicationUserNotesTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "AUTHOR", resizable: true, field: "", minWidth: 120 },
  { headerName: "TITLE", resizable: true, field: "", minWidth: 120 },
  { headerName: "MEMO", resizable: true, field: "", minWidth: 120 },
  { headerName: "DIRECTION", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
];
/*---------Credit Memo Related Records -----------*/
export const creditMemoRelatedRecords = [
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "NUMBER",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "STATUS",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-left",
    cellClass: " text-left",
  },
  {
    headerName: "LINK TYPE",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "AMOUNT",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];
/*------------Credit Memo System Information System Notes--------------*/
export const creditMemoSystemNotesTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "SET BY", resizable: true, field: "", minWidth: 120 },
  { headerName: "CONTEXT", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "FIELD", resizable: true, field: "", minWidth: 120 },
  { headerName: "OLD VALUE", resizable: true, field: "", minWidth: 120 },
  { headerName: "NEW VALUE", resizable: true, field: "", minWidth: 120 },
];

/*------------Credit Memo System Information Active Workflows--------------*/
export const creditMemoActiveWorkfowTables = [
  { headerName: "WORKFLOW", resizable: true, field: "", minWidth: 120 },
  { headerName: "CURRENT STATE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE ENTERED WORKFLOW",
    resizable: true,
    field: "",
    minWidth: 180,
  },
  {
    headerName: "DATE ENTERED STATE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "OPTIONS", resizable: true, field: "", minWidth: 120 },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "CANCEL", resizable: true, field: "", minWidth: 120 },
];

/*------------Credit Memo System Information Workflow History--------------*/
export const creditMemoWorkflowHistoryTables = [
  { headerName: "WORKFLOW", resizable: true, field: "", minWidth: 120 },
  { headerName: "STATE NAME INFO", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE ENTERED STATE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  {
    headerName: "DATE EXITIED STATE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "OPTIONS", resizable: true, field: "", minWidth: 120 },
  { headerName: "NOTES", resizable: true, field: "", minWidth: 120 },
];

/*------------Credit Memo System Information Applied Rules--------------*/
export const creditMemoAppliedRulesTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "RULE TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "DETAILS", resizable: true, field: "", minWidth: 160 },
];
/*--------Credit Memo Custom FAM Asset Table---------*/
export const creditMemoFamAssetTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "ID", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "ASSET DESCRIPTION",
    resizable: true,
    field: "",
    minWidth: 140,
  },
  { headerName: "ASSET TYPE", resizable: true, field: "", minWidth: 100 },
  {
    headerName: "ASSET ORIGINAL COST",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  {
    headerName: "ASSET CURRENT COST",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  {
    headerName: "DEPRECIATION METHOD",
    resizable: true,
    field: "",
    minWidth: 170,
  },
  { headerName: "ASSET LIFETIME", resizable: true, field: "", minWidth: 120 },
  { headerName: "ASSET STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "COMPONENT OF", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "QUANTITY",
    resizable: true,
    field: "",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "BUSINESS UNIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];
/*---------Credit Memo Custom Journal Reject Reason--------*/
export const creditMemoCustomJournalRejectReasonTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "ID", resizable: true, field: "", minWidth: 120 },
  { headerName: "REJECT REASON", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];
/*---------Credit Memo Custom FAM Depreciation History--------*/
export const creditMemoFAMDepreciationHistoryTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "ACCOUNTING BOOK", resizable: true, field: "", minWidth: 150 },
  { headerName: "TRANSACTION TYPE", resizable: true, field: "", minWidth: 150 },
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "PERIOD",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "TRANSACTION AMOUNT",
    resizable: true,
    field: "",
    minWidth: 180,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "DEPRECIATION POSTING REFERENCE",
    resizable: true,
    field: "",
    minWidth: 240,
  },
  {
    headerName: "QUANTITY",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "SCHEDULE", resizable: true, field: "", minWidth: 120 },
  { headerName: "SCHEDULED NBV", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "PARENT ASSET VALUE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "PRIOR YEAR NBV", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DEPRECIATION PRIOD",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  { headerName: "BUSINESS UNIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];
/*---------Credit Memo Approver List--------*/
export const creditMemoApproverList = [
  { headerName: "#", resizable: true, field: "", minWidth: 120 },
  { headerName: "RULE SEQUENCE", resizable: true, field: "", minWidth: 120 },
  { headerName: "APPROVER", resizable: true, field: "", minWidth: 120 },
  { headerName: "DATE/TIME", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "APPROVER ROLE",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "APPROVAL STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "NOTES", resizable: true, field: "", minWidth: 120 },
  { headerName: "SUPER APPROVED", resizable: true, field: "", minWidth: 120 },
];
/*----------Credit Memo Ava Tax-------*/
export const creditMemoAvaTaxTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "AUTHOR", resizable: true, field: "", minWidth: 120 },
  { headerName: "TITLE", resizable: true, field: "", minWidth: 120 },
  { headerName: "MEMO", resizable: true, field: "", minWidth: 120 },
];
/*----------Credit Memo GLImpact -------*/
export const creditMemoGLImpactTable = [
  { headerName: "ACCOUNT", resizable: true, field: "", minWidth: 120 },
  { headerName: "AMOUNT (DEBIT)", resizable: true, field: "", minWidth: 120 },
  { headerName: "AMOUNT (CREDIT)", resizable: true, field: "", minWidth: 120 },
  { headerName: "POSTING", resizable: true, field: "", minWidth: 120 },
  { headerName: "MEMO", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "SUBSIDIARY", resizable: true, field: "", minWidth: 120 },
  { headerName: "DEPARTMENT", resizable: true, field: "", minWidth: 120 },
  { headerName: "SF PRODUCT LINE", resizable: true, field: "", minWidth: 120 },
  { headerName: "LOCATION", resizable: true, field: "", minWidth: 120 },
  { headerName: "CUSTOM SCRIPT", resizable: true, field: "", minWidth: 120 },
  { headerName: "REVENUE GROUP", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "SF PRODUCT SOLUTIONS",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "SF PRODUCT FAMILY",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "INTERNAL PROJECT", resizable: true, field: "", minWidth: 120 },
  { headerName: "BUSINESSUNIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "TAX REGION", resizable: true, field: "", minWidth: 120 },
  { headerName: "IPOWNER(BUINSF)", resizable: true, field: "", minWidth: 120 },
  { headerName: "GL#", resizable: true, field: "", minWidth: 120 },
];
/*----------Credit Memo GL Impact Changes-------*/
export const creditMemoGLImpactChangesTable = [
  { headerName: "CREATION DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "TRANSACTION DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "TRANSACTION TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "TRANSACTION NUMBER",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "LAST STATE CHANGED BY",
    resizable: true,
    field: "",
    minWidth: 120,
  },
];
/*----------Credit Memo Transformation-------*/
export const creditMemoCustomTransformationTable = [
  { headerName: "DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "NUMBER", resizable: true, field: "", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "", minWidth: 120 },
];

//Lists table//
export const ListsTable = [
  // {
  //   headerName: "id",
  //   field: "id",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font capitalizeNone",
  //   cellRenderer: renderNavigatorByName,
  //   maxWidth: 50,
  // },

  {
    headerName: "Name",
    field: "report_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellRenderer: ListrenderNavigatorByName,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },

  // {
  //   headerName: "Table Name",
  //   field: "table_name",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font capitalizeNone",
  //   minWidth: 90,
  // },

  {
    headerName: "Type",
    field: "type",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
];
export const AttachmentsListsTable = [
  // {
  //   headerName: "id",
  //   field: "id",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font capitalizeNone",
  //   cellRenderer: renderNavigatorByName,
  //   maxWidth: 50,
  // },

  {
    headerName: "Name",
    field: "report_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellRenderer: ListrenderNavigatorByName,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },

  // {
  //   headerName: "Table Name",
  //   field: "table_name",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font capitalizeNone",
  //   minWidth: 90,
  // },

  {
    headerName: "Type",
    field: "type",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
];
//reports table//
export const ReportsTable = [
  // {
  //   headerName: "id",
  //   field: "id",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font capitalizeNone",
  //   cellRenderer: renderNavigatorByName,
  //   maxWidth: 50,
  // },

  {
    headerName: "Name",
    field: "report_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellRenderer: renderNavigatorByName,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },

  // {
  //   headerName: "Table Name",
  //   field: "table_name",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font capitalizeNone",
  //   minWidth: 90,
  // },

  {
    headerName: "Type",
    field: "type",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
];
export const InvoiceItemsLinesTable = [
  { headerName: "ACCOUNT", field: "account", resizable: true, minWidth: 150 },
  { headerName: "DEBIT", field: "debit", resizable: true, minWidth: 150 },
  { headerName: "CREDIT", field: "credit", resizable: true, minWidth: 150 },
  { headerName: "TAX CODE", field: "tax_code", resizable: true, minWidth: 150 },
  { headerName: "TAX RATE", field: "tax_rate", resizable: true, minWidth: 150 },
  {
    headerName: "GROSS AMT.",
    field: "gross_amt",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "MEMO", field: "memo", resizable: true, minWidth: 150 },
  { headerName: "NAME", field: "name", resizable: true, minWidth: 150 },
  {
    headerName: "DEPARTMENT",
    field: "department",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "SOLUTION", field: "solution", resizable: true, minWidth: 150 },
  {
    headerName: "OPERATION",
    field: "operation",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "REVENUE TYPE",
    field: "revenue_type",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "SALES MARKET REGION",
    field: "sales_market_region",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "TAX REGION",
    field: "tax_region",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "PROJECT", field: "project", resizable: true, minWidth: 150 },
  {
    headerName: "BUSINESS UNIT",
    field: "business_unit",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "EFFECTIVE START DATE",
    field: "effective_start_date",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "EFFECTIVE END DATE",
    field: "effective_end_date",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "REVENUE RECOGNITION RULE",
    field: "revenue_recognition_rule",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "AMORT. TEMPLATE",
    field: "amort_template",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "AMORT. START DATE",
    field: "amort_start_date",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "AMORT. END DATE",
    field: "amort_end_date",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "ELIMINATE",
    field: "eliminate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "OPENAIR EXPENSE REPORT LINE ID",
    field: "openair_expense_report_line_id",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "OPENAIR: PST",
    field: "openair_pst",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "OPENAIR: GST/HST",
    field: "openair_gst_hst",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "VAT CODE", field: "vat_code", resizable: true, minWidth: 150 },
  { headerName: "VAT AMT", field: "vat_amt", resizable: true, minWidth: 150 },
  {
    headerName: "TAX AMOUNT",
    field: "tax_amount",
    resizable: true,
    minWidth: 150,
  },
];
export const journalItemsLinesTable = [
  {
    headerName: "Account",
    field: "account",
    resizable: true,
    minWidth: 450,
  },
  {
    headerName: "Debit",
    field: "debit",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Credit",
    field: "credit",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Name",
    field: "name",
    resizable: true,
    minWidth: 200,
  },
  {
    headerName: "Memo",
    field: "memo",
    resizable: true,
    minWidth: 350,
  },
  {
    headerName: "PC/Project - Entity",
    field: "pc_project_entity",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Location",
    field: "location",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Revenue Recognition Rule",
    field: "revenue_recognition_rule",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Schedule",
    field: "schedule",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Start Date",
    field: "start_date",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "End Date",
    field: "end_date",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Residual",
    field: "residual",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Eliminate",
    field: "eliminate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Related Asset",
    field: "related_asset",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Bill Back Invoice",
    field: "bill_black_invoice",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "VAT Code",
    field: "vat_code",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "VAT BIN",
    field: "vat_bin",
    resizable: true,
    minWidth: 150,
  },

  {
    headerName: "Department",
    field: "department",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Service Line",
    field: "service_line",
    resizable: true,
    minWidth: 150,
  },

  {
    headerName: "Source Recognition Plan",
    field: "source_recognition_plan",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Director",
    field: "director",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "VP",
    field: "vp",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "EVP",
    field: "evp",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Related Journal",
    field: "related_journal",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Govt Exp Subcategory",
    field: "govt_exp_subcategory",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "GOVT CLIN Number",
    field: "govt_clin_number",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "GOVT IJO Number",
    field: "govt_ijo_number",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Direct Debit File Format",
    field: "direct_debit_file_format",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "History",
    field: "history",
    resizable: true,
    minWidth: 150,
  },
];

export const amortizationReportTable = [
  {
    headerName: "SUBSIDIARY NAME",
    field: "Subsidiary: Name",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "DOCUMENT NUMBER",
    field: "Document Number",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "TRANSACTION TYPE",
    field: "Transaction Type",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "DATE", field: "date", resizable: true, minWidth: 150 },
  { headerName: "VENDOR", field: "vendor", resizable: true, minWidth: 150 },
  { headerName: "AMOUNT", field: "amount", resizable: true, minWidth: 150 },
];
export const journalApprovalHistoryTable = [
  {
    headerName: "ACTION DATE",
    field: "action_date",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "ACTION", field: "action", resizable: true, minWidth: 150 },
  {
    headerName: "ACTION OWNER",
    field: "action_owner",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "APPROVAL STATUS",
    field: "approval_status",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "APPROVER TYPE",
    field: "approver_type",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "NEXT APPROVER/S",
    field: "next_approvers",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "REMARKS", field: "remarks", resizable: true, minWidth: 150 },
];

export const ReportsViewTable = [];

// Deposit PAYMENTS //
export const depositPayments_Tab_Table = [
  {
    headerName: "Date",
    field: "date",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    maxWidth: 120,
    cellRenderer: renderRevenueNavigatorWithID,
  },

  {
    headerName: "Type",
    field: "type",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
  {
    headerName: "Number",
    field: "number",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
  {
    headerName: "MEMO",
    field: "memo",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },

  {
    headerName: "PC/PROJECT",
    field: "pcproject",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },

  {
    headerName: "Payment Method",
    field: "payment_method",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
  {
    headerName: "Ref No.",
    field: "refno",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
  {
    headerName: "From",
    field: "from",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
  {
    headerName: "Amount",
    field: "amount",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
];

export const depositother_Tab_Table = [
  {
    headerName: "Name",
    field: "date",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",

    maxWidth: 120,
  },

  {
    headerName: "Amount",
    field: "type",
    resizable: true,
    wrapText: true,
    autoHeight: true,

    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },

  {
    headerName: "Account",
    field: "number",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },

  {
    headerName: "Payment Method",
    field: "type",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
  {
    headerName: "Number",
    field: "ref_no",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
  {
    headerName: "Department",
    field: "department",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
  {
    headerName: "Service Line",
    field: "service_line",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
  {
    headerName: "Location",
    field: "location",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
  {
    headerName: "Memo",
    field: "amount",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
];

export const depositcash_Tab_Table = [
  {
    headerName: "Amount",
    field: "amount",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",

    maxWidth: 120,
  },

  {
    headerName: "Account",
    field: "account",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },

  {
    headerName: "Department",
    field: "department",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
  {
    headerName: "Service Line",
    field: "service_line",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
  {
    headerName: "Location",
    field: "location",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
  {
    headerName: "Memo",
    field: "memo",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
];

/*---------Deposit Communication Files-----------*/
export const DepositCommunicationFilesTable = [
  {
    headerName: "ATTACHED FILE",
    resizable: true,
    field: "filename",
    width: "auto",
  },
  { headerName: "FOLDER", resizable: true, field: "folder", width: "auto" },
  {
    headerName: "SIZE(KB)",
    resizable: true,
    field: "size_in_kb",
    width: "auto",
  },
  {
    headerName: "LAST MODIFILED",
    resizable: true,
    field: "last_modified",
    width: "auto",
  },
  {
    headerName: "DOCUMENT TYPE",
    resizable: true,
    field: "file_type",
    width: "auto",
  },
  {
    headerName: "DOWNLOAD",
    resizable: true,
    field: "transaction_id",
    cellRenderer: () => (
      <Button sx={{ margin: 1, color: "#0066b2" }}>
        {" "}
        <DownloadIcon />
      </Button>
    ),
    width: "auto",
  },
];

export const transactionJournalTable = [
  {
    headerName: "View",
    resizable: true,
    field: "documentno",
    cellRenderer: renderNavigator,
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Date",
    resizable: true,
    sortable: true,
    field: "date",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Transaction No.",
    resizable: true,
    field: "transactionno",
    minWidth: 100,
    headerClass: "justify-center",
    cellClass: " text-center",
  },
  {
    headerName: "Journal No.",
    resizable: true,
    field: "documentno",
    minWidth: 140,
    headerClass: "justify-center",
    cellClass: " text-right",
  },
  {
    headerName: "Name",
    resizable: true,
    field: "name",
    minWidth: 400,
  },
  {
    headerName: "Document Number",
    resizable: true,
    field: "documentno",
    minWidth: 140,
    sortable: true,
    headerClass: "justify-right",
    cellClass: "text-right",
  },
  {
    headerName: "PC/PROJECT",
    resizable: true,
    field: "pc_project",
    minWidth: 350,
  },
  {
    headerName: "Account",
    resizable: true,
    field: "account",
    minWidth: 300,
  },
  {
    headerName: "Status",
    resizable: true,
    field: "status",
    minWidth: 180,
  },
  {
    headerName: "Memo",
    resizable: true,
    field: "memo",
    minWidth: 250,
  },
  {
    headerName: "Currency",
    resizable: true,
    field: "currency",
    minWidth: 100,
  },
  {
    headerName: "Amount (Foreign Currency)",
    resizable: true,
    field: "amount_foreign",
    minWidth: 200,
  },
  {
    headerName: "Amount",
    resizable: true,
    field: "amount",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Reversal#",
    resizable: true,
    field: "reversal",
    minWidth: 100,
    headerClass: "justify-center",
    cellClass: " text-center",
  },
  {
    headerName: "TypeType (Record Type)",
    resizable: true,
    field: "type",
    minWidth: 140,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Email Sent",
    resizable: true,
    field: "email_sent",
    minWidth: 120,
    headerClass: "justify-center",
    cellClass: " text-center",
  },
  {
    headerName: "Do Not Send Email",
    resizable: true,
    field: "do_not_send_email",
    minWidth: 150,
    headerClass: "justify-center",
    cellClass: " text-center",
  },
  {
    headerName: "Expense Report Status",
    resizable: true,
    field: "expense_report_status",
    minWidth: 160,
  },
  {
    headerName: "NSC PO Number",
    resizable: true,
    field: "nsc_po_number",
    minWidth: 140,
  },
  {
    headerName: "Preferred Entity Bank",
    resizable: true,
    field: "preferred_entity_bank",
    minWidth: 160,
  },
  {
    headerName: "Vendor Bank Fees",
    resizable: true,
    field: "vendor_bank_fees",
    minWidth: 160,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Bank Fee",
    resizable: true,
    field: "bank_fee",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Created By",
    resizable: true,
    field: "created_by",
    minWidth: 140,
  },
  {
    headerName: "Vendor Bill Approval Status",
    resizable: true,
    field: "vendor_bill_approval_status",
    minWidth: 200,
  },
  {
    headerName: "Entity Bank (Vendor)",
    resizable: true,
    field: "entity_bank_vendor",
    minWidth: 160,
  },
  {
    headerName: "Entity Bank (Employee)",
    resizable: true,
    field: "entity_bank_employee",
    minWidth: 160,
  },
  {
    headerName: "Exclude from Electronic Bank Payments Processing",
    resizable: true,
    field: "exclude_from_electronic_bank_payments",
    minWidth: 260,
  },
  {
    headerName: "Entity Bank (Customer)",
    resizable: true,
    field: "entity_bank_customer",
    minWidth: 160,
  },
  {
    headerName: "Entity Bank (Customer Credit)",
    resizable: true,
    field: "entity_bank_customer_credit",
    minWidth: 160,
  },
  {
    headerName: "Invoice Resend Email",
    resizable: true,
    field: "invoice_resend_email",
    minWidth: 160,
  },
  {
    headerName: "Invoice Additional Attachments",
    resizable: true,
    field: "invoice_additional_attachments",
    minWidth: 200,
  },
];

export const transactionDepositTable = [
  {
    headerName: "View",
    resizable: true,
    field: "documentno",
    cellRenderer: renderNavigator,
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Internal Id",
    resizable: true,
    field: "id",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Date",
    resizable: true,
    sortable: true,
    field: "date",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Type",
    resizable: true,
    field: "type",
    minWidth: 100,
  },
  {
    headerName: "Subsidiary",
    resizable: true,
    field: "subsidiary",
    minWidth: 140,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  // {
  //   headerName: "Payroll Batch",
  //   resizable: true,
  //   field: "",
  //   minWidth: 140,
  // },
  {
    headerName: "Document Number",
    resizable: true,
    field: "documentno",
    minWidth: 140,
    headerClass: "justify-right",
    sortable: true,
    cellClass: " text-right",
  },
  // {
  //   headerName: "Transaction Number",
  //   resizable: true,
  //   field: "transactionno",
  //   minWidth: 160,
  //   headerClass: "justify-right",
  //   cellClass: " text-right",
  // },
  {
    headerName: "Account",
    resizable: true,
    field: "account",
    minWidth: 240,
  },
  // {
  //   headerName: "Name",
  //   resizable: true,
  //   field: "name",
  //   minWidth: 140,
  // },
  // {
  //   headerName: "PO/Check Number",
  //   resizable: true,
  //   field: "po",
  //   minWidth: 150,
  //   headerClass: "justify-right",
  //   cellClass: " text-right",
  // },
  // {
  //   headerName: "Status",
  //   resizable: true,
  //   field: "status",
  //   minWidth: 100,
  // },
  // {
  //   headerName: "Tracking Numbers",
  //   resizable: true,
  //   field: "",
  //   minWidth: 140,
  // },
  {
    headerName: "Memo",
    resizable: true,
    field: "memo",
    minWidth: 200,
  },
  {
    headerName: "Currency",
    resizable: true,
    field: "currency",
    minWidth: 100,
  },
  {
    headerName: "Amount (Foreign Currency)",
    resizable: true,
    field: "amount_foreign",
    minWidth: 200,
  },
  {
    headerName: "Amount",
    resizable: true,
    field: "amount",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Posting",
    resizable: true,
    field: "posting",
    minWidth: 100,
  },
];

export const billCreditExpensesTable = [
  { headerName: "CATEGORY", resizable: true, field: "category", minWidth: 250 },
  {
    headerName: "PC/PROJECT",
    resizable: true,
    field: "pc_project",
    minWidth: 350,
  },
  { headerName: "ACCOUNT", resizable: true, field: "account", minWidth: 350 },
  { headerName: "AMOUNT", resizable: true, field: "amount", minWidth: 120 },
  { headerName: "MEMO", resizable: true, field: "memo", minWidth: 120 },
  { headerName: "RESIDUAL", resizable: true, field: "residual", minWidth: 120 },
  { headerName: "COMMENTS", resizable: true, field: "comments", minWidth: 120 },
  { headerName: "BILLABLE", resizable: true, field: "billable", minWidth: 120 },
  {
    headerName: "AMORT. SCHEDULE",
    resizable: true,
    field: "amort_schedule",
    minWidth: 140,
  },
  {
    headerName: "AMORT. START",
    resizable: true,
    field: "amort_start",
    minWidth: 120,
  },
  {
    headerName: "AMORT. END",
    resizable: true,
    field: "amort_end",
    minWidth: 120,
  },

  {
    headerName: "GROSS AMT",
    resizable: true,
    field: "grossamt",
    minWidth: 120,
  },
  {
    headerName: "GOVT CLIN NUMBER",
    resizable: true,
    field: "govt_clin_number",
    minWidth: 120,
  },
  {
    headerName: "VAT CODE",
    resizable: true,
    field: "vat_code",
    minWidth: 120,
  },
  {
    headerName: "VAT BIN",
    resizable: true,
    field: "vat_bin",
    minWidth: 120,
  },

  { headerName: "HISTORY", resizable: true, field: "history", minWidth: 120 },
];

export const billCreditItemsTable = [
  { headerName: "ITEM", resizable: true, field: "Item", minWidth: 180 },
  {
    headerName: "VENDOR NAME",
    resizable: true,
    field: "vendor_name",
    minWidth: 150,
  },
  {
    headerName: "VENDOR TEXT",
    resizable: true,
    field: "vendor_text",
    minWidth: 120,
  },
  {
    headerName: "MFG. CATALOG NUMBER (NSC ITEM CODE)",
    resizable: true,
    field: "mfg_catalog_number",
    minWidth: 180,
  },

  {
    headerName: "DESCRIPTION",
    resizable: true,
    field: "description",
    minWidth: 350,
  },
  {
    headerName: "PC/PROJECT",
    resizable: true,
    field: "pc_project",
    minWidth: 250,
  },
  { headerName: "QUANTITY", resizable: true, field: "quantity", minWidth: 120 },

  {
    headerName: "TAX AMOUNT CREDITED BY VENDOR (IF NOT IN RATE",
    resizable: true,
    field: "tax_amount_credited_by_vendor",
    minWidth: 120,
  },
  { headerName: "RATE", resizable: true, field: "rate", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "amount", minWidth: 120 },

  { headerName: "OPTIONS", resizable: true, field: "options", minWidth: 120 },
  {
    headerName: "OPERATION",
    resizable: true,
    field: "operation",
    minWidth: 120,
  },
  {
    headerName: "DEPARTMENT",
    resizable: true,
    field: "department",
    minWidth: 120,
  },
  {
    headerName: "COMMENTS",
    resizable: true,
    field: "comments",
    minWidth: 160,
  },
  { headerName: "BILLABLE", resizable: true, field: "billable", minWidth: 120 },
  {
    headerName: "AMORT. SCHEDULE",
    resizable: true,
    field: "amort_schedule",
    minWidth: 140,
  },
  {
    headerName: "AMORT. START",
    resizable: true,
    field: "amort_start",
    minWidth: 120,
  },
  {
    headerName: "AMORT. END",
    resizable: true,
    field: "amort_end",
    minWidth: 120,
  },
  { headerName: "RESIDUAL", resizable: true, field: "residual", minWidth: 120 },

  {
    headerName: "ASSETACCOUNT",
    resizable: true,
    field: "assetaccount",
    minWidth: 300,
  },
  {
    headerName: "EXPENSEACCOUNT",
    resizable: true,
    field: "expenseaccount",
    minWidth: 140,
  },

  {
    headerName: "OPTIONS",
    resizable: true,
    field: "options",
    minWidth: 120,
  },
  {
    headerName: "GOV CLIN #",
    field: "giv_clin_#",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "PRE-OWNED ITEM (2)",
    field: "pre_owned_item_2",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "PRE-OWNED ITEM (2)",
    resizable: true,
    field: "pre_owned_item",
    minWidth: 150,
  },
  { headerName: "VAT CODE", resizable: true, field: "vat_code", minWidth: 120 },
  { headerName: "VAT BIN", resizable: true, field: "vat_bin", minWidth: 120 },
  {
    headerName: "REMOVE",
    resizable: true,
    field: "REMOVE",
    minWidth: 120,
  },
];

export const billCreditApplyTable = [
  {
    headerName: "DATE DUE",
    resizable: true,
    field: "duedate",
    cellRenderer: renderRevenueNavigator,
    minWidth: 120,
  },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  { headerName: "REF NO.", resizable: true, field: "refno", minWidth: 120 },
  {
    headerName: "ORIG. AMT.",
    resizable: true,
    field: "original_amt",
    minWidth: 120,
  },
  {
    headerName: "AMT. DUE",
    resizable: true,
    field: "amountdue",
    minWidth: 120,
  },
  { headerName: "CURRENCY", resizable: true, field: "currency", minWidth: 120 },
  { headerName: "PAYMENT", resizable: true, field: "payment", minWidth: 120 },
];

export const billCreditRelationshipsContactsTable = [
  {
    headerName: "EDIT",
    resizable: true,
    field: "",
    minWidth: 120,
    cellRendererFramework: () => (
      <Button className="actionIcon">
        {" "}
        <EditOutlinedIcon />{" "}
      </Button>
    ),
  },
  { headerName: "NAME", resizable: true, field: "name", minWidth: 120 },
  {
    headerName: "COMPANY",
    resizable: true,
    field: "companyname",
    minWidth: 120,
  },
  {
    headerName: "JOB TITLE",
    resizable: true,
    field: "jobtitle",
    minWidth: 120,
  },
  { headerName: "PHONE", resizable: true, field: "phone", minWidth: 120 },
  { headerName: "EMAIL", resizable: true, field: "email", minWidth: 120 },
  // {
  //   headerName: "EXPORT TO OPENAIR",
  //   resizable: true,
  //   field: "export_to_openair",
  //   minWidth: 160,
  // },
  { headerName: "ROLE", resizable: true, field: "role", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "role", minWidth: 120 },
];

export const projectRelationshipsContactsTable = [
  // {
  //   headerName: "EDIT",
  //   resizable: true,
  //   field: "",
  //   minWidth: 120,
  //   cellRendererFramework: () => (
  //     <Button className="actionIcon">
  //       {" "}
  //       <EditOutlinedIcon />{" "}
  //     </Button>
  //   ),
  // },
  { headerName: "NAME", resizable: true, field: "NAME", minWidth: 120 },
  {
    headerName: "COMPANY",
    resizable: true,
    field: "COMPANY",
    minWidth: 120,
  },
  {
    headerName: "JOB TITLE",
    resizable: true,
    field: "JOB_TITLE",
    minWidth: 120,
  },
  { headerName: "PHONE", resizable: true, field: "PHONE", minWidth: 120 },
  { headerName: "EMAIL", resizable: true, field: "EMAIL", minWidth: 120 },
  {
    headerName: "EXPORT TO OPENAIR",
    resizable: true,
    field: "EXPORT_TO_OPENAIR",
    minWidth: 160,
  },
  { headerName: "ROLE", resizable: true, field: "ROLE", minWidth: 120 },
  // { headerName: "REMOVE", resizable: true, field: "role", minWidth: 120 },
];

export const billCreditCommuFilesTable = [
  {
    headerName: "ATTACHED FILES",
    resizable: true,
    field: "attachedfiles",
    minWidth: 455,
  },
  { headerName: "FOLDER", resizable: true, field: "folder", minWidth: 120 },
  { headerName: "SIZE (KB)", resizable: true, field: "size", minWidth: 120 },
  {
    headerName: "LAST MODIFIED",
    resizable: true,
    field: "lastmodifieddate",
    minWidth: 150,
  },
  {
    headerName: "DOCUMENT TYPE",
    resizable: true,
    field: "documenttype",
    minWidth: 150,
  },
];

export const billCreditCommuMessagesTable = [
  { headerName: "#", resizable: true, field: "sno", minWidth: 80 },
  { headerName: "VIEW", resizable: true, field: "view", minWidth: 160 },
  { headerName: "DATE", resizable: true, field: "datewithtime", minWidth: 160 },
  { headerName: "AUTHOR", resizable: true, field: "author", minWidth: 180 },
  {
    headerName: "PRIMARY RECIPIENT",
    resizable: true,
    field: "primary_recipient",
    minWidth: 220,
  },
  { headerName: "SUBJECT", resizable: true, field: "subject", minWidth: 160 },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  { headerName: "FILES", resizable: true, field: "files", minWidth: 120 },
  {
    headerName: "ATTACHMENTS",
    resizable: true,
    field: "attachments",
    minWidth: 120,
  },
];

export const billCreditCommuActivitiesTable = [
  {
    headerName: "EDIT",
    resizable: true,
    field: "",
    minWidth: 120,
    cellRendererFramework: () => (
      <Button className="actionIcon">
        {" "}
        <EditOutlinedIcon />{" "}
      </Button>
    ),
  },
  { headerName: "TITLE", resizable: true, field: "", minWidth: 120 },
  { headerName: "DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "TIME", resizable: true, field: "", minWidth: 120 },
  { headerName: "OWNER", resizable: true, field: "", minWidth: 120 },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "ASSIGNED TO", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "MARK", resizable: true, field: "", minWidth: 120 },
];

export const billCreditRelatedRecReimbursementsTable = [
  { headerName: "DATE", resizable: true, field: "date", minWidth: 80 },
  { headerName: "NUMBER", resizable: true, field: "number", minWidth: 100 },
  { headerName: "AMOUNT", resizable: true, field: "amount", minWidth: 100 },
];

export const billCreditRelatedRecTransactionsTable = [
  { headerName: "DATE", resizable: true, field: "date", minWidth: 80 },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 80 },
  { headerName: "NUMBER", resizable: true, field: "number", minWidth: 100 },
  { headerName: "AMOUNT", resizable: true, field: "amount", minWidth: 100 },
];

export const billCreditSystemInfoActiveWorkflowsTable = [
  { headerName: "WORKFLOW", resizable: true, field: "workflow", minWidth: 120 },
  {
    headerName: "CURRENT STATE",
    resizable: true,
    field: "current_state",
    minWidth: 120,
  },
  {
    headerName: "DATE ENTERED WORKFLOW",
    resizable: true,
    field: "date_entered_workflow",
    minWidth: 200,
  },
  {
    headerName: "DATE ENTERED STATE",
    resizable: true,
    field: "date_enetered_state",
    minWidth: 160,
  },
  { headerName: "OPTIONS", resizable: true, field: "options", minWidth: 120 },
  { headerName: "STATUS", resizable: true, field: "status", minWidth: 120 },
  { headerName: "CANCEL", resizable: true, field: "cancel", minWidth: 120 },
];

export const billCreditSystemInfoWorkflowHistoryTable = [
  { headerName: "WORKFLOW", resizable: true, field: "workflow", minWidth: 120 },
  {
    headerName: "STATE NAME INFO",
    resizable: true,
    field: "date_entered_workflow",
    minWidth: 120,
  },
  {
    headerName: "DATE ENTERED STATE ",
    resizable: true,
    field: "date_enetered_state",
    minWidth: 120,
  },
  {
    headerName: "DATE EXITED STATE",
    resizable: true,
    field: "date_exited_state",
    minWidth: 120,
  },
  { headerName: "OPTIONS", resizable: true, field: "options", minWidth: 120 },
  { headerName: "LOG", resizable: true, field: "log", minWidth: 120 },
  { headerName: "NOTES", resizable: true, field: "notes", minWidth: 120 },
];

export const billPaymentAppliedTable = [
  { headerName: "DATE DUE", resizable: true, field: "duedate", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  { headerName: "REF NO.", resizable: true, field: "refno", minWidth: 120 },
  {
    headerName: "ORIG. AMT.",
    resizable: true,
    field: "original_amt",
    minWidth: 120,
  },
  {
    headerName: "AMT. DUE",
    resizable: true,
    field: "amountdue",
    minWidth: 120,
  },
  { headerName: "CURRENCY", resizable: true, field: "currency", minWidth: 120 },
  {
    headerName: "DISC. DATE ",
    resizable: true,
    field: "disc_date",
    minWidth: 120,
  },
  {
    headerName: "DISC. AVAIL.",
    resizable: true,
    field: "disc_avail",
    minWidth: 120,
  },
  {
    headerName: "DISC. TAKEN",
    resizable: true,
    field: "disc_taken",
    minWidth: 120,
  },
  { headerName: "PAYMENT", resizable: true, field: "payment", minWidth: 120 },
];

export const billPaymentCreditsAppliedTable = [
  { headerName: "DATE", resizable: true, field: "date", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  { headerName: "REF NO.", resizable: true, field: "refno", minWidth: 120 },
  {
    headerName: "APPLIED TO",
    resizable: true,
    field: "appliedto",
    minWidth: 120,
  },
  { headerName: "CURRENCY", resizable: true, field: "currency", minWidth: 120 },
  { headerName: "PAYMENT", resizable: true, field: "payment", minWidth: 120 },
];

export const billPaymentRelationshipsContactsTable = [
  {
    headerName: "EDIT",
    resizable: true,
    field: "",
    minWidth: 120,
    cellRendererFramework: () => (
      <Button className="actionIcon">
        {" "}
        <EditOutlinedIcon />{" "}
      </Button>
    ),
  },
  { headerName: "NAME", resizable: true, field: "name", minWidth: 120 },
  {
    headerName: "COMPANY",
    resizable: true,
    field: "companyname",
    minWidth: 120,
  },
  {
    headerName: "JOB TITLE",
    resizable: true,
    field: "jobtitle",
    minWidth: 120,
  },
  { headerName: "PHONE", resizable: true, field: "phone", minWidth: 120 },
  { headerName: "EMAIL", resizable: true, field: "email", minWidth: 120 },
  {
    headerName: "EXPORT TO OPENAIR",
    resizable: true,
    field: "export_to_openair",
    minWidth: 160,
  },
  { headerName: "ROLE", resizable: true, field: "role", minWidth: 120 },
];

export const creditMemoChargesTable = [
  { headerName: "ERROR", resizable: true, field: "", minWidth: 120 },
];

//  Check Transformations //
export const TransformationsTable = [
  { headerName: "DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "NUMBER", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "AMOUNT",
    resizable: true,
    field: "",
    minWidth: 140,
  },
];
export const commuMessageDialogAttachmentsTable = [
  {
    headerName: "ATTACHED FILES",
    resizable: true,
    field: "Name",
    minWidth: 220,
  },
  { headerName: "FOLDER", resizable: true, field: "Folder", minWidth: 230 },
  {
    headerName: "SIZE(KB)",
    resizable: true,
    field: "Size (KB)",
    minWidth: 100,
  },
  {
    headerName: "LAST MODIFIED",
    resizable: true,
    field: "Last Modified",
    minWidth: 150,
  },
  {
    headerName: "DOCUMENT TYPE",
    resizable: true,
    field: "Type",
    minWidth: 120,
  },
  // { headerName: "DOWNLOAD", resizable: true, field: "", minWidth: 120 },
];

/*----------Credit Memo Items Apply Table-------*/
export const customerRefundApplyCreditsTable = [
  { headerName: "DATE", resizable: true, field: "date", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  { headerName: "REF NO.", resizable: true, field: "refno", minWidth: 120 },
  {
    headerName: "ORIG. AMT.",
    resizable: true,
    field: "orig_amt",
    minWidth: 120,
  },
  {
    headerName: "AMOUNT REMAINING",
    resizable: true,
    field: "amt_remaining",
    minWidth: 120,
  },
  { headerName: "CURRENCY", resizable: true, field: "currency", minWidth: 120 },
  { headerName: "PAYMENT", resizable: true, field: "payment", minWidth: 120 },
];

export const customerRefundApplyDepositsTable = [
  { headerName: "DATE", resizable: true, field: "date", minWidth: 120 },
  { headerName: "REF NO.", resizable: true, field: "refno", minWidth: 120 },
  {
    headerName: "ORIG. AMT.",
    resizable: true,
    field: "orig_amt",
    minWidth: 120,
  },
  {
    headerName: "AMOUNT REMAINING",
    resizable: true,
    field: "amt_remaining",
    minWidth: 120,
  },
  { headerName: "CURRENCY", resizable: true, field: "currency", minWidth: 120 },
  { headerName: "PAYMENT", resizable: true, field: "payment", minWidth: 120 },
];

export const customerRefundPaymentEventTable = [
  { headerName: "DATE", resizable: true, field: "date", minWidth: 120 },
  {
    headerName: "TRANSACTION",
    resizable: true,
    field: "transaction",
    minWidth: 120,
  },
  { headerName: "EVENT", resizable: true, field: "event", minWidth: 120 },
  {
    headerName: "HANDLING MODE",
    resizable: true,
    field: "handling_mode",
    minWidth: 140,
  },
  {
    headerName: "PAYMENT OPTION",
    resizable: true,
    field: "payment_option",
    minWidth: 140,
  },
  { headerName: "RESULT", resizable: true, field: "result", minWidth: 120 },
  { headerName: "REASON", resizable: true, field: "reason", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "amount", minWidth: 120 },
];

export const customerRefundRelationshipsContactsTable = [
  { headerName: "Edit", resizable: true, field: "name", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "name", minWidth: 120 },
  {
    headerName: "COMPANY",
    resizable: true,
    field: "companyname",
    minWidth: 120,
  },
  {
    headerName: "JOB TITLE",
    resizable: true,
    field: "jobtitle",
    minWidth: 120,
  },
  { headerName: "PHONE", resizable: true, field: "phone", minWidth: 120 },
  { headerName: "EMAIL", resizable: true, field: "email", minWidth: 120 },
  {
    headerName: "EXPORT TO OPENAIR",
    resizable: true,
    field: "export_to_openair",
    minWidth: 120,
  },
  { headerName: "ROLE", resizable: true, field: "role", minWidth: 120 },
];
export const commuMessageDialogReadReceiptsTable = [
  { headerName: "DATE SENT", resizable: true, field: "", minWidth: 120 },
  { headerName: "AUTHOR", resizable: true, field: "", minWidth: 120 },
  { headerName: "EMAIL ADDRESS", resizable: true, field: "", minWidth: 120 },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
];
export const commonSystemNotesTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "Date",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "SET BY", resizable: true, field: "Set by", minWidth: 120 },
  { headerName: "CONTEXT", resizable: true, field: "Context", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "Type", minWidth: 120 },
  { headerName: "FIELD", resizable: true, field: "Field", minWidth: 120 },
  {
    headerName: "OLD VALUE",
    resizable: true,
    field: "Old Value",
    minWidth: 120,
  },
  {
    headerName: "NEW VALUE",
    resizable: true,
    field: "New Value",
    minWidth: 120,
  },
];
{
  /*system information activeflowtable */
}
export const activeflowworkTable = [
  {
    headerName: "WORKFLOW",
    resizable: true,
    field: "workflow",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "CURRENT STATE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE ENTERED WORKFLOW",
    resizable: true,
    field: "Context",
    minWidth: 120,
  },
  {
    headerName: "DATE ENTERED STATE",
    resizable: true,
    field: "Type",
    minWidth: 120,
  },
  { headerName: "OPTIONS", resizable: true, field: "Field", minWidth: 120 },
  {
    headerName: "STATUS",
    resizable: true,
    field: "Old Value",
    minWidth: 120,
  },
  {
    headerName: "CANCEL",
    resizable: true,
    field: "New Value",
    minWidth: 120,
  },
];
export const currencyRevaluationRealizedGainLossTable = [
  { headerName: "DATE", resizable: true, field: "date", minWidth: 120 },
  { headerName: "PAYEE", resizable: true, field: "payee", minWidth: 120 },
  { headerName: "CURRENCY", resizable: true, field: "currency", minWidth: 120 },
  {
    headerName: "SOURCE TRANS",
    resizable: true,
    field: "source_trans",
    minWidth: 120,
  },
  {
    headerName: "SOURCE TRANS RATE",
    resizable: true,
    field: "source_trans_rate",
    minWidth: 160,
  },
  {
    headerName: "PMT TRANS",
    resizable: true,
    field: "pmt_trans",
    minWidth: 120,
  },
  {
    headerName: "PMT TRANS RATE",
    resizable: true,
    field: "pmt_trans_rate",
    minWidth: 150,
  },
  {
    headerName: "APPLIED AMOUNT (FOREIGN)",
    resizable: true,
    field: "applied_amount_foreign",
    minWidth: 200,
  },
  {
    headerName: "GAIN/LOSS",
    resizable: true,
    field: "gain_loss",
    minWidth: 120,
  },
];

export const currencyRevaluationOpenReceivablesTable = [
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  { headerName: "DATE", resizable: true, field: "date", minWidth: 120 },
  { headerName: "PAYEE", resizable: true, field: "payee", minWidth: 120 },
  { headerName: "CURRENCY", resizable: true, field: "currency", minWidth: 120 },
  {
    headerName: "TRANSACTION EXCHANGE RATE",
    resizable: true,
    field: "transaction_exchange_rate",
    minWidth: 220,
  },
  {
    headerName: "ENDING EXCHANGE RATE",
    resizable: true,
    field: "ending_exchange_rate",
    minWidth: 180,
  },
  { headerName: "BALANCE", resizable: true, field: "balance", minWidth: 120 },
  {
    headerName: "GAIN/LOSS",
    resizable: true,
    field: "gain_loss",
    minWidth: 120,
  },
  {
    headerName: "PRIOR GAIN/LOSS",
    resizable: true,
    field: "prior_gain_loss",
    minWidth: 140,
  },
  {
    headerName: "NET GAIN/LOSS",
    resizable: true,
    field: "net_gain_loss",
    minWidth: 140,
  },
];

export const currencyRevaluationOtherAccountsTable = [
  { headerName: "ACCOUNT", resizable: true, field: "account", minWidth: 120 },
  { headerName: "CURRENCY", resizable: true, field: "currency", minWidth: 120 },
  {
    headerName: "FOREIGN CURRENCY BALANCE",
    resizable: true,
    field: "foreign_currency_balance",
    minWidth: 220,
  },
  {
    headerName: "BASE CURRENCY BALANCE",
    resizable: true,
    field: "base_currency_balance",
    minWidth: 220,
  },
  {
    headerName: "EXCHANGE RATE",
    resizable: true,
    field: "exchange_rate",
    minWidth: 120,
  },
  {
    headerName: "NET GAIN/LOSS",
    resizable: true,
    field: "net_gain_loss",
    minWidth: 140,
  },
];

export const currencyRevaluationRoundingTable = [
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  { headerName: "DATE", resizable: true, field: "date", minWidth: 120 },
  { headerName: "PAYEE", resizable: true, field: "payee", minWidth: 120 },
  { headerName: "CURRENCY", resizable: true, field: "currency", minWidth: 120 },
  {
    headerName: "TRANSACTION EXCHANGE RATE",
    resizable: true,
    field: "transaction_exchange_rate",
    minWidth: 220,
  },
  {
    headerName: "FOREIGN CURRENCY BALANCE",
    resizable: true,
    field: "foreign_currency_balance",
    minWidth: 220,
  },
  {
    headerName: "BASE CURRENCY BALANCE",
    resizable: true,
    field: "base_currency_balance",
    minWidth: 220,
  },
  {
    headerName: "ROUNDING GAIN/LOSS",
    resizable: true,
    field: "rounding_gainloss",
    minWidth: 160,
  },
];

export const currencyRevaluationGlImpactTable = [
  { headerName: "ACCOUNT", resizable: true, field: "account", minWidth: 120 },
  {
    headerName: "AMOUNT (DEBIT)",
    resizable: true,
    field: "debit",
    minWidth: 140,
  },
  {
    headerName: "AMOUNT (CREDIT)",
    resizable: true,
    field: "credit",
    minWidth: 140,
  },
  { headerName: "POSTING", resizable: true, field: "posting", minWidth: 120 },
  { headerName: "MEMO", resizable: true, field: "Memo", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "name", minWidth: 120 },
  {
    headerName: "SUBSIDIARY",
    resizable: true,
    field: "subsidiary",
    minWidth: 120,
  },
  {
    headerName: "DEPARTMENT",
    resizable: true,
    field: "department",
    minWidth: 120,
  },
  {
    headerName: "SERVICE LINE",
    resizable: true,
    field: "service_line",
    minWidth: 120,
  },
  {
    headerName: "LOCATION",
    resizable: true,
    field: "location",
    minWidth: 120,
  },
  {
    headerName: "CUSTOM SCRIPT",
    resizable: true,
    field: "custom_script",
    minWidth: 140,
  },
  // {
  //   headerName: "REVENUE TYPE",
  //   resizable: true,
  //   field: "revenue_type",
  //   minWidth: 120,
  // },
  // {
  //   headerName: "SALES MARKET REGION",
  //   resizable: true,
  //   field: "sales_market_region",
  //   minWidth: 180,
  // },
  // {
  //   headerName: "TAX REGION",
  //   resizable: true,
  //   field: "tax_region",
  //   minWidth: 120,
  // },
  // { headerName: "PROJECT", resizable: true, field: "project", minWidth: 120 },
  // {
  //   headerName: "BUSINESS UNIT",
  //   resizable: true,
  //   field: "business_unit",
  //   minWidth: 120,
  // },
];
export const expenseReportExpensesTable = [
  {
    headerName: "REF NO.",
    field: "ref_no",
    resizable: true,
    minWidth: 90,
    cellRenderer: (params) => {
      return params.node.rowIndex + 1;
    },
  },
  { headerName: "DATE", field: "date", resizable: true, minWidth: 150 },
  { headerName: "CATEGORY", field: "category", resizable: true, minWidth: 350 },
  { headerName: "AMOUNT", field: "amount", resizable: true, minWidth: 90 },
  {
    headerName: "LOCATION",
    field: "location",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "CURRENCY", field: "currency", resizable: true, minWidth: 150 },
  { headerName: "MEMO", field: "memo", resizable: true, minWidth: 350 },
  {
    headerName: "EXPENSE REPORT VENDOR",
    field: "expense_report_vendor",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "NEW VENDOR TEXT",
    field: "new_vendor_text",
    resizable: true,
    minWidth: 150,
  },

  {
    headerName: "BILLING {SUBSIDIARY}",
    field: "billing_subsidiary",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "ATTACH FILE",
    field: "attachfile",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "BILLABLE",
    field: "billable",
    resizable: true,
    minWidth: 150,
  },

  {
    headerName: "PC/PROJECT",
    resizable: true,
    field: "pc_project",
    minWidth: 300,
  },
  {
    headerName: "CLIN #",
    resizable: true,
    field: "govt_clin_number",
    minWidth: 120,
  },
  { headerName: "IJO #", resizable: true, field: "ijo", minWidth: 120 },
  {
    headerName: "DIRECTOR",
    resizable: true,
    field: "director",
    minWidth: 120,
  },
  {
    headerName: "DEPARTMENT",
    resizable: true,
    field: "department",
    minWidth: 180,
  },
  { headerName: "VP", resizable: true, field: "vp", minWidth: 120 },
  {
    headerName: "SERVICE LINE",
    resizable: true,
    field: "serviceline",
    minWidth: 200,
  },

  {
    headerName: "EVP",
    resizable: true,
    field: "evp",
    minWidth: 120,
  },
  {
    headerName: "GL EXP. ACCT",
    field: "gl_exp_acct",
    resizable: true,
    minWidth: 150,
  },

  {
    headerName: "CORPORATE CARD",
    field: "corporate_card",
    resizable: true,
    minWidth: 150,
  },
];
export const ExpensesReportRelatedRecordsApprovals = [
  {
    headerName: "EMPLOYEE",
    resizable: true,
    field: "",
    minWidth: 90,
  },
  { headerName: "ACTION", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DATE/TIME",
    resizable: true,
    field: "",
    minWidth: 120,
  },
];
export const ExpensesReportRelatedRecordsReimbursements = [
  {
    headerName: "DATE",
    resizable: true,
    field: "date",
    minWidth: 120,
    cellRenderer: renderRevenueNavigator,
  },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  { headerName: "NUMBER", resizable: true, field: "number", minWidth: 120 },
  { headerName: "STATUS", resizable: true, field: "status", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "amount", minWidth: 120 },
];
export const ExpensesReportRelatedRecordsLinks = [
  { headerName: "DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "NUMBER", resizable: true, field: "", minWidth: 120 },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "", minWidth: 120 },
];

export const revenueArrangementRelatedRecordsTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "date",
    minWidth: 120,
    cellRenderer: renderRevenueNavigator,
  },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  {
    headerName: "NUMBER",
    resizable: true,
    field: "number",
    minWidth: 120,
    cellRenderer: renderRevenueNavigator,
  },
  {
    headerName: "LINK TYPE",
    resizable: true,
    field: "linktype",
    minWidth: 120,
  },
  { headerName: "AMOUNT", resizable: true, field: "amount", minWidth: 120 },
];

export const revArrRevenueElementTable = [
  {
    headerName: "REVENUE ELEMENT",
    resizable: true,
    field: "revenue_element",
    minWidth: 140,
  },
  { headerName: "SOURCE", resizable: true, field: "source", minWidth: 250 },
  {
    headerName: "SOURCE DATE",
    resizable: true,
    field: "source_date",
    minWidth: 120,
  },
  {
    headerName: "EFFECTIVE START DATE",
    resizable: true,
    field: "effective_start_date",
    minWidth: 170,
  },
  {
    headerName: "EFFECTIVE END DATE",
    resizable: true,
    field: "effective_end_date",
    minWidth: 170,
  },

  { headerName: "ITEM", resizable: true, field: "item", minWidth: 120 },
  {
    headerName: "ORIGINAL QUANTITY",
    resizable: true,
    field: "original_quantity",
    minWidth: 140,
  },
  { headerName: "QUANTITY", resizable: true, field: "quantity", minWidth: 120 },
  {
    headerName: "UNITS",
    resizable: true,
    field: "units",
    minWidth: 140,
  },
  {
    headerName: "SALES AMOUNT",
    resizable: true,
    field: "sales_amount",
    minWidth: 140,
  },

  {
    headerName: "ORIGINAL DISCOUNTED SALES AMOUNT",
    resizable: true,
    field: "original_discounted_sales_amount",
    minWidth: 280,
  },
  // {
  //   headerName: "DISCOUNTED SALES AMOUNT",
  //   resizable: true,
  //   field: "discounted_sales_amount",
  //   minWidth: 220,
  // },
  {
    headerName: "RESIDUAL DISCOUNTED SALES AMOUNT",
    resizable: true,
    field: "residual_discounted_sales_amount",
    minWidth: 280,
  },
  {
    headerName: "START DATE",
    resizable: true,
    field: "start_date",
    minWidth: 120,
  },
  {
    headerName: "REV REC FORECAST RULE",
    resizable: true,
    field: "rev_rec_forecast_rule",
    minWidth: 180,
  },
  {
    headerName: "REVENUE RECOGNITION PLAN",
    resizable: true,
    field: "revenue_recognition_plan",
    minWidth: 200,
  },
  {
    headerName: "DEFERRAL ACCOUNT",
    resizable: true,
    field: "deferral_account",
    minWidth: 180,
  },
  {
    headerName: "RECOGNITION ACCOUNT",
    resizable: true,
    field: "recognition_account",
    minWidth: 180,
  },
  {
    headerName: "FOREIGN CURRENCY ADJUSTMENT ACCOUNT",
    resizable: true,
    field: "foreign_currency_adjustment_account",
    minWidth: 300,
  },
  {
    headerName: "REFERENCE ID",
    resizable: true,
    field: "reference_id",
    minWidth: 120,
  },
  {
    headerName: "CREATE REVENUE PLANS ON",
    resizable: true,
    field: "create_revenue_plans_on",
    minWidth: 200,
  },
  {
    headerName: "REVENUE RECOGNITION RULE",
    resizable: true,
    field: "revenue_recognition_rule",
    minWidth: 200,
  },

  { headerName: "END DATE", resizable: true, field: "end_date", minWidth: 120 },
  {
    headerName: "TERM IN DAYS",
    resizable: true,
    field: "terms_in_days",
    minWidth: 120,
  },
  {
    headerName: "FORECAST START DATE",
    resizable: true,
    field: "forecast_start_date",
    minWidth: 180,
  },

  {
    headerName: "FORECAST END DATE",
    resizable: true,
    field: "forecast_end_date",
    minWidth: 180,
  },
  {
    headerName: "TRANSITION TO NEW STANDARD",
    resizable: true,
    field: "transition_to_new_standard",
    minWidth: 220,
  },
  {
    headerName: "REVENUE MIGRATION ADJUSTMENT ACCOUNT",
    resizable: true,
    field: "revenue_migration_adjustment_account",
    minWidth: 300,
  },
  {
    headerName: "SERVICE LINE",
    resizable: true,
    field: "service_line",
    minWidth: 120,
  },
  {
    headerName: "DEPARTMENT",
    resizable: true,
    field: "department",
    minWidth: 120,
  },
  {
    headerName: "LOCATION",
    resizable: true,
    field: "location",
    minWidth: 140,
  },
  {
    headerName: "PRORATED DISCOUNTED SALES AMOUNT (FOREIGN CURRENCY)",
    resizable: true,
    field: "prorated_discounted_sales_amount_foreign_currency",
    minWidth: 420,
  },
  {
    headerName: "PREMERGE PRORATED DISCOUNTED SALES AMOUNT (FOREIGN CURRENCY)",
    resizable: true,
    field: "premerge_prorated_discounted_sales_amount_foreign_currency",
    minWidth: 470,
  },

  {
    headerName: "PRORATED DISCOUNTED SALES AMOUNT (BASE CURRENCY)",
    resizable: true,
    field: "prorated_discounted_sales_amount_base_currency",
    minWidth: 390,
  },
  {
    headerName: "PREMERGE PRORATED DISCOUNTED SALES AMOUNT (BASE CURRENCY)",
    resizable: true,
    field: "premerge_prorated_discounted_sales_amount_base_currency",
    minWidth: 440,
  },
  { headerName: "LAST MERGE TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "TERM IN MONTHS",
    resizable: true,
    field: "term_in_months",
    minWidth: 120,
  },
  {
    headerName: "REVENUE PLANS STATUS",
    resizable: true,
    field: "revenue_plan_status",
    minWidth: 200,
  },
];

export const revArrAllocationDetailTable = [
  {
    headerName: "REVENUE ELEMENT",
    resizable: true,
    field: "revenue_element",
    minWidth: 140,
  },
  { headerName: "ITEM", resizable: true, field: "item", minWidth: 120 },
  {
    headerName: "FAIR VALUE PRICE RECORD",
    resizable: true,
    field: "fair_value_price_record",
    minWidth: 180,
  },
  {
    headerName: "BASE FAIR VALUE",
    resizable: true,
    field: "base_fair_value",
    minWidth: 200,
  },
  {
    headerName: "USED SALES PRICE AS FAIR VALUE",
    resizable: true,
    field: "used_sales_price_as_fair_value",
    minWidth: 250,
  },
  {
    headerName: "IS VSOE PRICE?",
    resizable: true,
    field: "is_vsoe_price",
    minWidth: 140,
  },
  {
    headerName: "FAIR VALUE FORMULA",
    resizable: true,
    field: "fair_value_formula",
    minWidth: 180,
  },
  {
    headerName: "PRE-RANGE CHECKING CALCULATED AMOUNT",
    resizable: true,
    field: "",
    minWidth: 180,
  },
  {
    headerName: "RANGE POLICY",
    resizable: true,
    field: "",
    minWidth: 180,
  },
  {
    headerName: "LOW VALUE",
    resizable: true,
    field: "",
    minWidth: 180,
  },
  {
    headerName: "DISCOUNT SALES AMOUNT",
    resizable: true,
    field: "",
    minWidth: 180,
  },
  {
    headerName: "HIGH VALUE",
    resizable: true,
    field: "",
    minWidth: 180,
  },
  {
    headerName: "CALCULATED FAIR VALUE AMOUNT",
    resizable: true,
    field: "calculated_fair_value_amount",
    minWidth: 250,
  },
  {
    headerName: "STEP ONE RESULT",
    resizable: true,
    field: "step_one_result",
    minWidth: 140,
  },
  {
    headerName: "STEP TWO RESULT",
    resizable: true,
    field: "step_two_result",
    minWidth: 140,
  },
  { headerName: "ERROR", resizable: true, field: "error", minWidth: 120 },
];

export const revArrRevenueArrangementVersionTable = [
  { headerName: "VERSION", resizable: true, field: "version", minWidth: 120 },
  {
    headerName: "DATE CHANGED",
    resizable: true,
    field: "date_changes",
    minWidth: 120,
  },
  {
    headerName: "CREATED BY",
    resizable: true,
    field: "created_by",
    minWidth: 120,
  },
];

export const revArrRevenueArrangementMessageTable = [
  { headerName: "DATE", resizable: true, field: "date", minWidth: 120 },
  { headerName: "PROCESS", resizable: true, field: "process", minWidth: 120 },
  {
    headerName: "IS COMPLIANT",
    resizable: true,
    field: "is_compliant",
    minWidth: 120,
  },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  {
    headerName: "DESCRIPTION",
    resizable: true,
    field: "description",
    minWidth: 120,
  },
  {
    headerName: "RELATED RECORD",
    resizable: true,
    field: "related_record",
    minWidth: 120,
  },
  {
    headerName: "MIGRATION LOG",
    resizable: true,
    field: "migration_logs",
    minWidth: 120,
  },
];
export const revRecognitionPlanTable = [
  { headerName: "CUSTOMER", field: "customer", resizable: true, minWidth: 150 },
  { headerName: "SOURCE", field: "source", resizable: true, minWidth: 150 },
  {
    headerName: "REVENUE PLAN NUMBER",
    field: "revenue_plan_number",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "REVENUE PLAN TYPE",
    field: "revenue_plan_type",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "REVENUE RECOGNITION RULE",
    field: "revenue_recognition_rule",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "REVENUE RECOGNITION START DATE",
    field: "revenue_recognition_start_date",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "REVENUE RECOGNITION END DATE",
    field: "revenue_recognition_end_date",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "ITEM", field: "item", resizable: true, minWidth: 150 },
  {
    headerName: "PLAN TOTAL",
    field: "plan_total",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "STATUS", field: "status", resizable: true, minWidth: 150 },
  {
    headerName: "AMOUNT (RECOGNIZED)",
    field: "amount_recognised",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "REMAINING",
    field: "remaining",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "HOLD REVENUE RECOGNITION",
    field: "hold_revenue_recognition",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "REFORECAST METHOD",
    field: "reforecast_method",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "RECALCULATION ADJUSTMENT PERIOD OFFSET",
    field: "recalculation_adjustment_period_offset",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "CATCH UP PERIOD",
    field: "catch_up_period",
    resizable: true,
    minWidth: 150,
  },
];
export const revFairValueFormulaTable = [
  { headerName: "DATE", field: "date", resizable: true, minWidth: 150 },
  { headerName: "SET BY", field: "set_by", resizable: true, minWidth: 150 },
  {
    headerName: "CONTEXT",
    field: "context",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "TYPE",
    field: "type",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "FIELD",
    field: "field",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "OLD VALUE",
    field: "old_value",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "NEW VALUE",
    field: "new_value",
    resizable: true,
    minWidth: 150,
  },
];

export const transactionTotalTable = [
  { headerName: "Transaction Type", field: "ve_type", resizable: true },
  { headerName: "VE Count", field: "ve_total", resizable: true },
  { headerName: "NS Count", field: "ns_total", resizable: true },
];

/*----------Sales Order Ava Tax-------*/
export const vendorsSubsidiariesTable = [
  {
    headerName: "SUBSIDIARY",
    resizable: true,
    field: "subsidiary",
    minWidth: 120,
  },
  { headerName: "PRIMARY", resizable: true, field: "primary", minWidth: 120 },
  { headerName: "INACTIVE", resizable: true, field: "inactive", minWidth: 120 },
  { headerName: "BALANCE", resizable: true, field: "balance", minWidth: 120 },
  {
    headerName: "BALANCE (BASE)",
    resizable: true,
    field: "balance_base",
    minWidth: 120,
  },
  {
    headerName: "UNBILLED ORDERS",
    resizable: true,
    field: "unbilled_orders",
    minWidth: 160,
  },
  {
    headerName: "UNBILLED ORDERS (BASE)",
    resizable: true,
    field: "unbilled_order_base",
    minWidth: 180,
  },
  {
    headerName: "CREDIT LIMIT",
    resizable: true,
    field: "credit_limit",
    minWidth: 120,
  },
  { headerName: "TAX CODE", resizable: true, field: "tax_code", minWidth: 120 },
];

export const vendorsAddressTable = [
  {
    headerName: "DEFAULT SHIPPING",
    resizable: true,
    field: "default_shipping",
    minWidth: 120,
  },
  {
    headerName: "DEFAULT BILLING",
    resizable: true,
    field: "default_billing",
    minWidth: 120,
  },
  { headerName: "LABEL", resizable: true, field: "label", minWidth: 120 },
  { headerName: "ADDRESS", resizable: true, field: "address", minWidth: 120 },
  // { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
];

export const vendorsFinancialCurrenciesTable = [
  {
    headerName: "CURRENCY",
    resizable: true,
    field: "primary_currency",
    minWidth: 120,
  },
  { headerName: "BALANCE", resizable: true, field: "balance", minWidth: 120 },
  {
    headerName: "UNBILLED ORDERS",
    resizable: true,
    field: "unbilled_orders",
    minWidth: 120,
  },
];

export const vendorsFinancialPricingSchedulesTable = [
  { headerName: "SCHEDULE", resizable: true, field: "", minWidth: 120 },
  { headerName: "BASE DISCOUNT", resizable: true, field: "", minWidth: 120 },
];

export const vendorsFinancialTransactionsTable = [
  {
    headerName: "EDIT",
    resizable: true,
    field: "",
    valueGetter: <p>Edit</p>,
    minWidth: 120,
  },
  { headerName: "DATE", resizable: true, field: "date", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  {
    headerName: "DOCUMENT NUMBER",
    resizable: true,
    field: "document_number",
    cellRenderer: renderBillNavigator,
    minWidth: 180,
  },
  {
    headerName: "PO/CHECK #",
    resizable: true,
    field: "po_check_number",
    minWidth: 120,
  },
  { headerName: "NAME", resizable: true, field: "name", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "amount", minWidth: 120 },
  {
    headerName: "AMOUNT (FOREIGN CURRENCY)",
    resizable: true,
    field: "amount_foreign",
    minWidth: 220,
  },
  {
    headerName: "CURRENCY",
    resizable: true,
    field: "primary_currency",
    minWidth: 120,
  },
  { headerName: "STATUS", resizable: true, field: "status", minWidth: 120 },
  {
    headerName: "DAYS OPEN",
    resizable: true,
    field: "days_open",
    minWidth: 120,
  },
  {
    headerName: "EMAIL SENT",
    resizable: true,
    field: "email_sent",
    minWidth: 120,
  },
  {
    headerName: "DO NOT SEND EMAIL",
    resizable: true,
    field: "do_not_send_email",
    minWidth: 150,
  },
  {
    headerName: "EXPENSE REPORT STATUS",
    resizable: true,
    field: "expense_report_status",
    minWidth: 180,
  },
  {
    headerName: "NSC PO NUMBER",
    resizable: true,
    field: "nsc_po_number",
    minWidth: 180,
  },
  {
    headerName: "PREFERRED ENTITY BANK",
    resizable: true,
    field: "preferred_entity_bank",
    minWidth: 220,
  },
  {
    headerName: "VENDOR BANK FEES",
    resizable: true,
    field: "vendor_bank_fees",
    minWidth: 150,
  },
  { headerName: "BANK FEE", resizable: true, field: "bank_fee", minWidth: 120 },
  {
    headerName: "CREATED BY",
    resizable: true,
    field: "created_by",
    minWidth: 120,
  },
  {
    headerName: "VENDOR BILL APPROVAL STATUS",
    resizable: true,
    field: "vendor_bill_approval_status",
    minWidth: 220,
  },
  {
    headerName: "ENTITY BANK (VENDOR)",
    resizable: true,
    field: "entity_bank_vendor",
    minWidth: 180,
  },
  {
    headerName: "ENTITY BANK (EMPLOYEE)",
    resizable: true,
    field: "entity_bank_employee",
    minWidth: 180,
  },
  {
    headerName: "EXCLUDE FROM ELECTRONIC BANK PAYMENTS PROCESSING",
    resizable: true,
    field: "exclude_from_electronic_bank_payments_processing",
    minWidth: 380,
  },
  {
    headerName: "ENTITY BANK (CUSTOMER)",
    resizable: true,
    field: "entity_bank_customer",
    minWidth: 180,
  },
  {
    headerName: "ENTITY BANK (CUSTOMER CREDIT)",
    resizable: true,
    field: "entity_bank_customer_credit",
    minWidth: 230,
  },
  {
    headerName: "INVOICE RESEND EMAIL",
    resizable: true,
    field: "invoice_resend_email",
    minWidth: 180,
  },
  {
    headerName: "INVOICE ADDITIONAL ATTACHMENTS",
    resizable: true,
    field: "invoice_additional_attachments",
    minWidth: 220,
  },
  { headerName: "REMOVE", resizable: true, field: "remove", minWidth: 120 },
];

export const vendorsFinancialItemsTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "PURCHASE DESCRIPTION",
    resizable: true,
    field: "",
    minWidth: 200,
  },
  { headerName: "VENDOR CODE", resizable: true, field: "", minWidth: 120 },
  { headerName: "VENDOR PRICE", resizable: true, field: "", minWidth: 120 },
  { headerName: "VENDOR SCHEDULE", resizable: true, field: "", minWidth: 140 },
  {
    headerName: "VENDOR PRICE CURRENCY",
    resizable: true,
    field: "",
    minWidth: 200,
  },
  { headerName: "BASE PRICE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "EXPORT TO OPENAIR",
    resizable: true,
    field: "",
    minWidth: 150,
  },
];

export const vendorsFinancialRatesTable = [
  { headerName: "CURRENCY", resizable: true, field: "", minWidth: 120 },
  { headerName: "HOURLY RATE", resizable: true, field: "", minWidth: 120 },
];

export const vendorsTimeTrackingTable = [
  // { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "DATE", resizable: true, field: "DATE", minWidth: 120 },
  { headerName: "ITEM", resizable: true, field: "ITEM", minWidth: 120 },
  { headerName: "DURATION", resizable: true, field: "DURATION", minWidth: 120 },
  { headerName: "APPROVED", resizable: true, field: "APPROVED", minWidth: 120 },
  { headerName: "STATUS", resizable: true, field: "STATUS", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "TYPE", minWidth: 120 },
];

export const vendorsEntityBankDetailsTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "PAYMENT FILE FORMAT",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "SUBSIDIARY", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];

export const vendorsSkillExpertiseLanguageTable = [
  { headerName: "SKILL", resizable: true, field: "", minWidth: 120 },
  { headerName: "LEVEL", resizable: true, field: "", minWidth: 120 },
];

export const vendorsSkillExpertiseProjectTable = [
  {
    headerName: "CUSTOMER : PROJECT",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "ROLE", resizable: true, field: "", minWidth: 120 },
  { headerName: "PROJECT MANAGER", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "PROJECT MANAGER E-MAIL",
    resizable: true,
    field: "",
    minWidth: 120,
  },
];

export const vendorsSkillExpertisePortfolioTable = [
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "CREATED", resizable: true, field: "", minWidth: 120 },
  { headerName: "MODIFIED", resizable: true, field: "", minWidth: 120 },
  { headerName: "DOWNLOAD", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];

export const customersClientsAddressTable = [
  {
    headerName: "DEFAULT SHIPPING",
    resizable: true,
    field: "default_shipping",
    minWidth: 120,
  },
  {
    headerName: "DEFAULT BILLING",
    resizable: true,
    field: "default_billing",
    minWidth: 120,
  },
  {
    headerName: "RESIDENTIAL ADDRESS",
    resizable: true,
    field: "residential_address",
    minWidth: 120,
  },
  { headerName: "LABEL", resizable: true, field: "label", minWidth: 120 },
  { headerName: "ADDRESS", resizable: true, field: "address", minWidth: 320 },
  { headerName: "EDIT", resizable: true, field: "edit", minWidth: 120 },
];

export const customersClientsItemsPurchasedTable = [
  { headerName: "ITEM", resizable: true, field: "item", minWidth: 250 },
  {
    headerName: "DESCRIPTION",
    resizable: true,
    field: "description",
    minWidth: 250,
  },
  { headerName: "QUANTITY", resizable: true, field: "quantity", minWidth: 80 },
  { headerName: "TOTAL", resizable: true, field: "total", minWidth: 80 },
  {
    headerName: "UNIT PRICE (AVERAGE)",
    resizable: true,
    field: "unit_price_average",
    minWidth: 80,
  },
  {
    headerName: "LAST PURCHASE DATE",
    resizable: true,
    field: "last_puchased_date",
    minWidth: 120,
  },
];

export const customersClientsUpsellTable = [
  {
    headerName: "ITEMS PURCHASED",
    resizable: true,
    field: "item_puchased",
    minWidth: 220,
  },
  {
    headerName: "ITEMS TO UPSELL",
    resizable: true,
    field: "items_to_upsell",
    minWidth: 120,
  },
  {
    headerName: "CORRELATION",
    resizable: true,
    field: "correlation",
    minWidth: 120,
  },
  { headerName: "COUNT", resizable: true, field: "count", minWidth: 120 },
];

export const customersClientsProjectsTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "ID", resizable: true, field: "", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "PROJECT TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "PRIMARY CONTACT", resizable: true, field: "", minWidth: 150 },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "START DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "ACTUAL END DATE", resizable: true, field: "", minWidth: 150 },
  { headerName: "PROJECT NOTES", resizable: true, field: "", minWidth: 120 },
  { headerName: "PROJECT MANAGER", resizable: true, field: "", minWidth: 140 },
  { headerName: "SOLUTION TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "CRM QUOTE ID", resizable: true, field: "", minWidth: 120 },
  { headerName: "SERVICE TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "PRODUCT TYPE - 1", resizable: true, field: "", minWidth: 160 },
  {
    headerName: "EXPORT TO OPENAIR",
    resizable: true,
    field: "",
    minWidth: 160,
  },
];

export const customersClientsOnlineFormsTable = [
  { headerName: "FORM", resizable: true, field: "", minWidth: 120 },
  { headerName: "DATE SENT", resizable: true, field: "", minWidth: 120 },
  { headerName: "CONTACT", resizable: true, field: "", minWidth: 120 },
  { headerName: "LEAD SOURCE", resizable: true, field: "", minWidth: 120 },
  { headerName: "CAMPAIGN EVENT", resizable: true, field: "", minWidth: 120 },
];

export const customersClientsCurrenciesTable = [
  { headerName: "CURRENCY", resizable: true, field: "name", minWidth: 120 },
  { headerName: "BALANCE", resizable: true, field: "balance", minWidth: 120 },
  {
    headerName: "DEPOSIT BALANCE",
    resizable: true,
    field: "deposit_balance",
    minWidth: 120,
  },
  {
    headerName: "OVERDUE BALANCE",
    resizable: true,
    field: "overdue_balance",
    minWidth: 120,
  },
  {
    headerName: "UNBILLED ORDERS",
    resizable: true,
    field: "unbilled_orders",
    minWidth: 120,
  },
  { headerName: "FORMAT", resizable: true, field: "format", minWidth: 120 },
];

export const customersClientsCreditCardsTable = [
  {
    headerName: "CREDIT CARD NUMBER",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "EXPIRATION DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "CARDHOLDER NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "CREDIT CARD TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "CARD STATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "MEMO", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DEFAULT CREDIT CARD",
    resizable: true,
    field: "",
    minWidth: 120,
  },
];

export const customersClientsGroupPricingTable = [
  { headerName: "PRICING GROUP", resizable: true, field: "", minWidth: 120 },
  { headerName: "PRICE LEVEL", resizable: true, field: "", minWidth: 120 },
];

export const customersClientsItemPricingTable = [
  { headerName: "ITEM", resizable: true, field: "", minWidth: 120 },
  { headerName: "PRICE LEVEL", resizable: true, field: "", minWidth: 120 },
  { headerName: "CURRENCY", resizable: true, field: "", minWidth: 120 },
  { headerName: "UNIT PRICE", resizable: true, field: "", minWidth: 120 },
];

export const customersClientsTimeTrackingTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "ID", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];

export const customersClientsAccessTable = [
  { headerName: "CONTACT", resizable: true, field: "", minWidth: 120 },
  { headerName: "EMAIL", resizable: true, field: "", minWidth: 120 },
  { headerName: "ROLE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "PASSWORD STRENGTH",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "PREVIEW", resizable: true, field: "", minWidth: 120 },
];

export const customersClientsSubsidiariesTable = [
  {
    headerName: "SUBSIDIARY",
    resizable: true,
    field: "subsidiary",
    minWidth: 120,
  },
  { headerName: "PRIMARY", resizable: true, field: "primary", minWidth: 120 },
  { headerName: "INACTIVE", resizable: true, field: "inactive", minWidth: 120 },
  { headerName: "BALANCE", resizable: true, field: "balance", minWidth: 120 },
  {
    headerName: "UNBILLED ORDERS",
    resizable: true,
    field: "unbilled_orders",
    minWidth: 160,
  },
  {
    headerName: "DEPOSIT BALANCE",
    resizable: true,
    field: "deposit_balance",
    minWidth: 120,
  },
];

export const relatedCreditMemoTable = [
  { headerName: "DATE", resizable: true, field: "date", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  { headerName: "NUMBER", resizable: true, field: "number", minWidth: 120 },
  {
    headerName: "LINK TYPE",
    resizable: true,
    field: "linktype",
    minWidth: 120,
  },
  { headerName: "AMOUNT", resizable: true, field: "amount", minWidth: 120 },
];

export const projectsResourceAllocationsTable = [
  // { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "RESOURCE", resizable: true, field: "RESOURCE", minWidth: 120 },
  { headerName: "CUSTOMER", resizable: true, field: "CUSTOMER", minWidth: 120 },
  { headerName: "PROJECT", resizable: true, field: "PROJECT", minWidth: 120 },
  {
    headerName: "START DATE",
    resizable: true,
    field: "START_DATE",
    minWidth: 120,
  },
  { headerName: "END DATE", resizable: true, field: "END_DATE", minWidth: 120 },
  {
    headerName: "NUMBER OF HOURS",
    resizable: true,
    field: "NUMBER_OF_HOURS",
    minWidth: 220,
  },
  {
    headerName: "PERCENTAGE OF TIME",
    resizable: true,
    field: "PERCENTAGE_OF_TIME",
    minWidth: 220,
  },
  {
    headerName: "ALLOCATE BY",
    resizable: true,
    field: "ALLOCATE_BY",
    minWidth: 140,
  },
  {
    headerName: "ALLOCATION TYPE",
    resizable: true,
    field: "ALLOCATION_TYPE",
    minWidth: 140,
  },
  {
    headerName: "REQUESTED BY",
    resizable: true,
    field: "REQUESTED_BY",
    minWidth: 140,
  },
];

export const projectsResourceDetailsTable = [
  { headerName: "NAME", resizable: true, field: "NAME", minWidth: 120 },
  { headerName: "EMAIL", resizable: true, field: "EMAIL", minWidth: 120 },
  { headerName: "ROLE", resizable: true, field: "ROLE", minWidth: 120 },
  {
    headerName: "DEFAULT COST",
    resizable: true,
    field: "DEFAULT_COST",
    minWidth: 120,
  },
  {
    headerName: "COST OVERRIDE",
    resizable: true,
    field: "COST_OVERRIDE",
    minWidth: 120,
  },
];

export const projectsBudgetTable = [
  { headerName: "CATEGORY", resizable: true, field: "", minWidth: 120 },
  { headerName: "PROJECT TOTAL", resizable: true, field: "", minWidth: 120 },
  { headerName: "AUG 2022", resizable: true, field: "", minWidth: 120 },
];

export const projectsPlTable = [
  { headerName: "COST CATEGORY", resizable: true, field: "", minWidth: 360 },
  { headerName: "REVENUE", resizable: true, field: "", minWidth: 120 },
  { headerName: "COST", resizable: true, field: "", minWidth: 120 },
  { headerName: "PROFIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "MARGIN", resizable: true, field: "", minWidth: 120 },
];

export const projectTasksMilestonesTable = [
  // { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "ID", resizable: true, field: "ID", minWidth: 120 },
  {
    headerName: "MILESTONE",
    resizable: true,
    field: "MILESTONE",
    minWidth: 120,
  },
  { headerName: "NAME", resizable: true, field: "NAME", minWidth: 120 },
  { headerName: "EXPAND ALL", resizable: true, field: "", minWidth: 120 },
  { headerName: "COLLAPSE ALL", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "PREDECESSORS",
    resizable: true,
    field: "PREDECESSORS",
    minWidth: 120,
  },
  {
    headerName: "START DATE",
    resizable: true,
    field: "START_DATE",
    minWidth: 120,
  },
  { headerName: "END DATE", resizable: true, field: "END_DATE", minWidth: 120 },
  {
    headerName: "ESTIMATED WORK",
    resizable: true,
    field: "ESTIMATED_WORK",
    minWidth: 150,
  },
  {
    headerName: "ESTIMATED COST",
    resizable: true,
    field: "ESTIMATED_COST",
    minWidth: 150,
  },
  {
    headerName: "COPY TASK",
    resizable: true,
    field: "COPY_TASK",
    minWidth: 120,
  },
];

export const projectsPercentCompleteOverrideTable = [
  {
    headerName: "ACCOUNTING PERIOD",
    resizable: true,
    field: "ACCOUNTING_PERIOD",
    minWidth: 170,
  },
  {
    headerName: "PERIOD STATUS",
    resizable: true,
    field: "PERIOD_STATUS",
    minWidth: 120,
  },
  {
    headerName: "CUMULATIVE PERCENT COMPLETE",
    resizable: true,
    field: "CUMULATIVE_PERCENT_COMPLETE",
    minWidth: 220,
  },
  {
    headerName: "CALCULATED PERCENT COMPLETE",
    resizable: true,
    field: "CALCULATED_PERCENT_COMPLETE",
    minWidth: 220,
  },
  {
    headerName: "REVENUE RECOGNITION PLANS",
    resizable: true,
    field: "REVENUE_RECOGNITION_PLANS",
    minWidth: 220,
  },
  { headerName: "COMMENTS", resizable: true, field: "COMMENTS", minWidth: 120 },
];

export const projectTaskAssignmentsTable = [
  { headerName: "SERVICE ITEM", resizable: true, field: "", minWidth: 120 },
  { headerName: "RESOURCE NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "UNIT COST", resizable: true, field: "", minWidth: 120 },
  { headerName: "UNIT PRICE", resizable: true, field: "", minWidth: 120 },
  { headerName: "ESTIMATED WORK", resizable: true, field: "", minWidth: 120 },
  { headerName: "ESTIMATED COST", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "ESTIMATED REVENUE",
    resizable: true,
    field: "",
    minWidth: 120,
  },
];

export const projectSubprojectsTable = [
  // { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "ID", resizable: true, field: "ID", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "NAME", minWidth: 120 },
  {
    headerName: "PROJECT TYPE",
    resizable: true,
    field: "PROJECT_TYPE",
    minWidth: 160,
  },
  {
    headerName: "PRIMARY CONTACT",
    resizable: true,
    field: "PRIMARY_CONTACT",
    minWidth: 160,
  },
  { headerName: "STATUS", resizable: true, field: "STATUS", minWidth: 120 },
  {
    headerName: "START DATE",
    resizable: true,
    field: "START_DATE",
    minWidth: 120,
  },
  {
    headerName: "ACTUAL END DATE",
    resizable: true,
    field: "ACTUAL_END_DATE",
    minWidth: 160,
  },
  {
    headerName: "PROJECT NOTES",
    resizable: true,
    field: "PROJECT_NOTES",
    minWidth: 140,
  },
  {
    headerName: "PROJECT MANAGER",
    resizable: true,
    field: "PROJECT_MANAGER",
    minWidth: 160,
  },
  {
    headerName: "SOLUTION TYPE",
    resizable: true,
    field: "SOLUTION_TYPE",
    minWidth: 140,
  },
  {
    headerName: "CRM QUOTE ID",
    resizable: true,
    field: "CRM_QUOTE_ID",
    minWidth: 120,
  },
  {
    headerName: "SERVICE TYPE",
    resizable: true,
    field: "SERVICE_TYPE",
    minWidth: 120,
  },
  {
    headerName: "PRODUCT TYPE - 1",
    resizable: true,
    field: "PRODUCT_TYPE-1",
    minWidth: 160,
  },
  {
    headerName: "EXPORT TO OPENAIR",
    resizable: true,
    field: "EXPORT_TO_OPENAIR",
    minWidth: 160,
  },
];

export const projectExpenseReportPoliciesTable = [
  { headerName: "EDIT", resizable: true, field: "EDIT", minWidth: 120 },
  { headerName: "NAME", resizable: true, field: "NAME", minWidth: 120 },
  { headerName: "STATUS", resizable: true, field: "STATUS", minWidth: 120 },
  {
    headerName: "START DATE",
    resizable: true,
    field: "START_DATE",
    minWidth: 120,
  },
  { headerName: "END DATE", resizable: true, field: "END_DATE", minWidth: 120 },
  {
    headerName: "EXPENSE CATEGORY",
    resizable: true,
    field: "EXPENSE_CATEGORY",
    minWidth: 180,
  },
  {
    headerName: "LIMIT TYPE",
    resizable: true,
    field: "LIMIT_TYPE",
    minWidth: 120,
  },
  { headerName: "ACTION", resizable: true, field: "ACTION", minWidth: 120 },
  {
    headerName: "MAXIMUM AMOUNT",
    resizable: true,
    field: "MAXIMUM_AMOUNT",
    minWidth: 180,
  },
];

export const projectCommunicationMessageTable = [
  { headerName: "#", resizable: true, field: "", minWidth: 80 },
  { headerName: "VIEW", resizable: true, field: "VIEW", minWidth: 120 },
  { headerName: "DATE", resizable: true, field: "DATE", minWidth: 90 },
  { headerName: "AUTHOR", resizable: true, field: "AUTHOR", minWidth: 120 },
  {
    headerName: "PRIMARY RECIPIENT",
    resizable: true,
    field: "PRIMARY_RECIPIENT",
    minWidth: 150,
  },
  { headerName: "SUBJECT", resizable: true, field: "SUBJECT", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "TYPE", minWidth: 120 },
  { headerName: "FILES", resizable: true, field: "FILES", minWidth: 120 },
  {
    headerName: "ATTACHMENTS",
    resizable: true,
    field: "ATTACHMENTS",
    minWidth: 320,
  },
  {
    headerName: "INTERNAL ONLY",
    resizable: true,
    field: "INTERNAL_ONLY",
    minWidth: 120,
  },
  {
    headerName: "REMOVE",
    resizable: true,
    field: "REMOVE",
    minWidth: 120,
  },
];

{
  /* custom pages tables*/
}
export const BgSummaryrecordTable = [
  {
    headerName: "EDIT",
    resizable: true,
    field: "date",
    minWidth: 90,
    headerClass: "justify-center",
    cellClass: " text-right",
  },
  { headerName: "NAME", resizable: true, field: "type", minWidth: 120 },
  {
    headerName: "DATE CREATED",
    resizable: true,
    field: "number",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "LAST MODIFIED", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "REMOVE",
    resizable: true,
    field: "amount",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];

export const BgIncomeTable = [
  {
    headerName: "EDIT",
    resizable: true,
    field: "date",
    minWidth: 90,
    headerClass: "justify-center",
    cellClass: " text-right",
  },
  { headerName: "ASSET NAME", resizable: true, field: "type", minWidth: 120 },
  {
    headerName: "NAME",
    resizable: true,
    field: "number",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "MEMO", resizable: true, field: "", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "REMOVE",
    resizable: true,
    field: "amount",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];

export const BgDeprecitionHistoryTable = [
  {
    headerName: "EDIT",
    resizable: true,
    field: "date",
    minWidth: 90,
    headerClass: "justify-center",
    cellClass: " text-right",
  },
  {
    headerName: "NAME",
    resizable: true,
    field: "number",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "ACCOUNTING BOOK",
    resizable: true,
    field: "type",
    minWidth: 120,
  },
  { headerName: "TRANSACTION TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "PERIOD", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "TRANSACTION AMOUNT",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "NET BOOK VALUE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "DEPRECIATION PSOTING REFERENCE",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "QUANTITY", resizable: true, field: "", minWidth: 120 },
  { headerName: "SCHEDULE", resizable: true, field: "", minWidth: 120 },
  { headerName: "SCHEDULED NBV", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "PARENT ASSET VALUE",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "PARENT YEAR NBV", resizable: true, field: "", minWidth: 120 },

  {
    headerName: "DEPRECIATION PERIOD",
    resizable: true,
    field: "",
    minWidth: 120,
  },

  {
    headerName: "REMOVE",
    resizable: true,
    field: "amount",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];

export const BgFAMAssetTable = [
  {
    headerName: "EDIT",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-center",
    cellClass: " text-right",
  },
  {
    headerName: "ID",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-center",
    cellClass: " text-right",
  },
  {
    headerName: "NAME",
    resizable: true,
    field: "name",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "ASSET DISCRIPTION",
    resizable: true,
    field: "type",
    minWidth: 120,
  },
  { headerName: "ASSET TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "ASSET ORIGINAL COST",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "ASSET CURRENT COST",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "DEPRECIATION METHOD",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "ASSET NAME", resizable: true, field: "", minWidth: 120 },
  { headerName: "ASSET STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "COMPONENT OF", resizable: true, field: "", minWidth: 120 },
  { headerName: "QUANTITY", resizable: true, field: "", minWidth: 120 },

  {
    headerName: "REMOVE",
    resizable: true,
    field: "amount",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];
/*charges */
export const INVChargesTable = [
  { headerName: "#", resizable: true, field: "", minWidth: 120 },
  { headerName: " CHARGE ID", resizable: true, field: "", minWidth: 120 },
  { headerName: "DATE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "CHARGE USE",
    resizable: true,
    field: "",
    minWidth: 140,
  },
  { headerName: "CHARGE TYPE", resizable: true, field: "", minWidth: 100 },
  {
    headerName: "CUSTOMER:PROJECT",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  {
    headerName: "BILL DATE",
    resizable: true,
    field: "",
    minWidth: 160,
  },
  {
    headerName: "ITEM",
    resizable: true,
    field: "",
    minWidth: 170,
  },
  { headerName: "QUANTITY", resizable: true, field: "", minWidth: 120 },
  { headerName: "RATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "CURRENCY",
    resizable: true,
    field: "",
    minWidth: 100,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "CHARGE STAGE", resizable: true, field: "", minWidth: 120 },
];
/*Eft Table */
export const EftBTITable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: " BATCH", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 120 },
];

export const JournalRevenueArrangementTable = [
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "NUMBER",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  { headerName: "LINK TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "AMOUNT",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];

// Check Expense table
export const CheckExpensesTable = [
  { headerName: "ACCOUNT", resizable: true, field: "account", minWidth: 300 },
  { headerName: "AMOUNT", resizable: true, field: "amount", minWidth: 120 },
  { headerName: "LOCATION", resizable: true, field: "location", minWidth: 120 },
  { headerName: "MEMO", resizable: true, field: "memo", minWidth: 120 },
  {
    headerName: "PC/PROJECT",
    resizable: true,
    field: "pc_project",
    minWidth: 120,
  },

  {
    headerName: "DEPARTMENT",
    resizable: true,
    field: "department",
    minWidth: 120,
  },
  {
    headerName: "SERVICE LINE",
    resizable: true,
    field: "service_line",
    minWidth: 120,
  },
  {
    headerName: "DIRECTOR",
    resizable: true,
    field: "director",
    minWidth: 120,
  },
  { headerName: "VP", resizable: true, field: "vp", minWidth: 120 },
  {
    headerName: "EVP",
    resizable: true,
    field: "evp",
    minWidth: 120,
  },
  // { headerName: "REF NO", resizable: true, field: "ref_no", minWidth: 120 },
  {
    headerName: "RELATED ASSET",
    resizable: true,
    field: "related_asset",
    minWidth: 120,
  },
  { headerName: "BILLABLE", resizable: true, field: "billable", minWidth: 120 },
  {
    headerName: "VAT CODE",
    resizable: true,
    field: "vat_code",
    minWidth: 120,
  },
  {
    headerName: "VAT BIN",
    resizable: true,
    field: "vat_bin",
    minWidth: 120,
  },

  { headerName: "HISTORY", resizable: true, field: "history", minWidth: 120 },
];

export const CheckItemsTable = [
  { headerName: "ITEM", resizable: true, field: "item", minWidth: 120 },
  {
    headerName: "VENDOR NAME",
    resizable: true,
    field: "vendor_name",
    minWidth: 120,
  },
  { headerName: "QUANTITY", resizable: true, field: "quantity", minWidth: 120 },
  { headerName: "UNITS", resizable: true, field: "units", minWidth: 180 },
  {
    headerName: "DESCRIPTION",
    resizable: true,
    field: "description",
    minWidth: 180,
  },
  { headerName: "RATE", resizable: true, field: "rate", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "amount", minWidth: 120 },
  { headerName: "TAX CODE", resizable: true, field: "tax_code", minWidth: 120 },
  { headerName: "TAX RATE", resizable: true, field: "tax_rate", minWidth: 120 },
  {
    headerName: "PC/PROJECT",
    resizable: true,
    field: "pc_project",
    minWidth: 120,
  },

  {
    headerName: "DEPARTMENT",
    resizable: true,
    field: "department",
    minWidth: 120,
  },
  {
    headerName: "SERVICE LINE",
    resizable: true,
    field: "service_line",
    minWidth: 120,
  },
  {
    headerName: "DIRECTOR",
    resizable: true,
    field: "director",
    minWidth: 120,
  },
  { headerName: "BILLABLE", resizable: true, field: "billable", minWidth: 120 },
  { headerName: "VP", resizable: true, field: "vp", minWidth: 120 },
  {
    headerName: "EVP",
    resizable: true,
    field: "evp",
    minWidth: 120,
  },
  {
    headerName: " LOCATION",
    resizable: true,
    field: "location",
    minWidth: 180,
  },
  { headerName: " OPTIONS", resizable: true, field: "options", minWidth: 180 },
  {
    headerName: "ASSET ACCOUNT",
    resizable: true,
    field: "asset_account",
    minWidth: 120,
  },
  {
    headerName: "EXPENSE ACCOUNT",
    resizable: true,
    field: "expense_account",
    minWidth: 120,
  },
  {
    headerName: "GOVT CLIN #",
    resizable: true,
    field: "govt_clin_number",
    minWidth: 120,
  },
  {
    headerName: "PRE-OWNED ITEM (2)",
    resizable: true,
    field: "pre_owned_item",
    minWidth: 120,
  },
  { headerName: "VAT CODE", resizable: true, field: "vat_code", minWidth: 120 },
  { headerName: "VAT BIN", resizable: true, field: "vat_bin", minWidth: 120 },
  { headerName: "HISTORY", resizable: true, field: "history", minWidth: 120 },
];

{
  /*VRA Table */
}
export const VRAExpensesTable = [
  { headerName: "ACCOUNT", resizable: true, field: "account", minWidth: 350 },
  { headerName: "AMOUNT", resizable: true, field: "amount", minWidth: 120 },
  { headerName: "LOCATION", resizable: true, field: "location", minWidth: 120 },
  { headerName: "MEMO", resizable: true, field: "memo", minWidth: 300 },
  {
    headerName: "PC/PROJECT",
    resizable: true,
    field: "pc_project",
    minWidth: 300,
  },
  {
    headerName: "CLIN #",
    resizable: true,
    field: "clin_number",
    minWidth: 120,
  },
  {
    headerName: "CUSTOMER ",
    field: "customer",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "BILLABLE", resizable: true, field: "billable", minWidth: 120 },
  {
    headerName: "AMORT.SCHEDULE",
    resizable: true,
    field: "amort_schedule",
    minWidth: 120,
  },
  {
    headerName: "AMORT.START",
    resizable: true,
    field: "amortstart",
    minWidth: 120,
  },
  {
    headerName: "AMORT.END",
    resizable: true,
    field: "amortend",
    minWidth: 120,
  },
  { headerName: "RESIDUAL", resizable: true, field: "residual", minWidth: 120 },
  {
    headerName: "RELATED ASSET",
    field: "related_asset",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "EXPENSE REPORT VENDOR",
    resizable: true,
    field: "expense_reoprt_vendor",
    minWidth: 120,
  },
  {
    headerName: "NEW VENDOR TEXT",
    resizable: true,
    field: "new_vendor_text",
    minWidth: 120,
  },

  {
    headerName: "VAT CODE",
    resizable: true,
    field: "vat_code",
    minWidth: 120,
  },
  {
    headerName: "VAT BIN",
    resizable: true,
    field: "vat_bin",
    minWidth: 120,
  },

  { headerName: "HISTORY", resizable: true, field: "history", minWidth: 120 },
];

export const VRAItemsTable = [
  { headerName: "ITEM", resizable: true, field: "Item", minWidth: 120 },
  {
    headerName: "VENDOR NAME",
    resizable: true,
    field: "vendor_name",
    minWidth: 120,
  },
  { headerName: "UNITS", resizable: true, field: "Units", minWidth: 120 },
  { headerName: "DESCRIPTION", resizable: true, field: "Memo", minWidth: 180 },
  { headerName: "QUANTITY", resizable: true, field: "Quantity", minWidth: 120 },
  // { headerName: "TAX AMOUNT PAYABLE TO VENDOR (IF NOT IN RATE)", resizable: true, field: "tax_amount_payable", minWidth: 180 },
  { headerName: "RATE", resizable: true, field: "Rate", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "Amount", minWidth: 120 },
  {
    headerName: "GOV CLIN #",
    resizable: true,
    field: "govt_clin_number",
    minWidth: 120,
  },
  { headerName: "BILLABLE", resizable: true, field: "billable", minWidth: 120 },
  {
    headerName: "PC/PROJECT",
    resizable: true,
    field: "pc_project",
    minWidth: 120,
  },
  {
    headerName: " LOCATION",
    resizable: true,
    field: "location",
    minWidth: 120,
  },
  { headerName: " OPTIONS", resizable: true, field: "options", minWidth: 120 },
  {
    headerName: "AMORT. SCHEDULE",
    resizable: true,
    field: "amort_schedule",
    minWidth: 120,
  },
  {
    headerName: "AMORT. START",
    resizable: true,
    field: "amort_start",
    minWidth: 120,
  },
  {
    headerName: "AMORT. END",
    resizable: true,
    field: "amort_end",
    minWidth: 120,
  },
  { headerName: "RESIDUAL", resizable: true, field: "residual", minWidth: 120 },
  { headerName: "CLOSED", resizable: true, field: "closed", minWidth: 180 },
  {
    headerName: "RELATED ASSET",
    field: "related_asset",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "DROP SHIPMENT",
    field: "drop_shipment",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "MANUFACTURER CATALOG NUMBER",
    field: "manufacturer_catalog_number",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "ASSET ACCOUNT",
    resizable: true,
    field: "asset_account",
    minWidth: 120,
  },
  {
    headerName: "EXPENSE ACCOUNT",
    resizable: true,
    field: "ExpenseAccount",
    minWidth: 120,
  },

  {
    headerName: "PRE-OWNED ITEM (2)",
    resizable: true,
    field: "pre_owned_item",
    minWidth: 120,
  },
  { headerName: "VAT CODE", resizable: true, field: "vat_code", minWidth: 120 },
  { headerName: "VAT BIN", resizable: true, field: "vat_bin", minWidth: 120 },
  { headerName: "HISTORY", resizable: true, field: "history", minWidth: 120 },
];
export const VRARelatedRecordsPayment = [
  {
    headerName: "DATE",
    resizable: true,
    field: "date",
    minWidth: 90,
  },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  {
    headerName: "NUMBER",
    resizable: true,
    field: "number",
    minWidth: 120,
  },
  {
    headerName: "STATUS",
    resizable: true,
    field: "status",
    minWidth: 120,
  },
  {
    headerName: "LINK TYPE",
    resizable: true,
    field: "link_type",
    minWidth: 120,
  },
  {
    headerName: "AMOUNT",
    resizable: true,
    field: "amount",
    minWidth: 120,
  },
];

export const VRARelatedRecordsTransformations = [
  { headerName: "DATE", resizable: true, field: "", minWidth: 120 },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  { headerName: "NUMBER", resizable: true, field: "", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "", minWidth: 120 },
];

export const ItemFulfillItemsTable = [
  { headerName: "ITEM", resizable: true, field: "item", minWidth: 250 },
  // { headerName: "VENDOR TEXT", resizable: true, field: "vendor_text", minWidth: 120 },
  // { headerName: "MFG. CATALOG NUMBER (NSC ITEM CODE)", resizable: true, field: "mfg_catalog_number", minWidth: 180 },
  {
    headerName: "DESCRIPTION",
    resizable: true,
    field: "description",
    minWidth: 180,
  },
  { headerName: "ON HAND", resizable: true, field: "onhand", minWidth: 120 },
  { headerName: "RATE", resizable: true, field: "rate", minWidth: 120 },
  { headerName: "QUANTITY", resizable: true, field: "quantity", minWidth: 120 },
  {
    headerName: "TOTAL AMT",
    resizable: true,
    field: "total_amount",
    minWidth: 120,
  },
  { headerName: "UNITS", resizable: true, field: "", minWidth: 120 },
  { headerName: "OPTIONS", resizable: true, field: "options", minWidth: 120 },
  // { headerName: "PC/PROJECT", resizable: true, field: "pc_project", minWidth: 120 },
  {
    headerName: "DROP SHIPMENT",
    resizable: true,
    field: "drop_shipment",
    minWidth: 120,
  },
  { headerName: "UDF1", resizable: true, field: "udf1", minWidth: 120 },
  { headerName: "UDF2", resizable: true, field: "udf2", minWidth: 120 },
  {
    headerName: "GOVT CLIN NUMBER",
    resizable: true,
    field: "gov_clin",
    minWidth: 250,
  },
  { headerName: "CURRENCY", resizable: true, field: "currency", minWidth: 120 },
];

export const itemFulFillPackageTable = [
  { headerName: "LBS", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "PACKAGE CONTENTS DESCRIPTION",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "PACKAGE TRACKING NUMBER",
    resizable: true,
    field: "",
    minWidth: 120,
  },
];

export const cashsaleItemsTable = [
  // { headerName: "PROJECT", field: "project", resizable: true, minWidth: 150, cellRenderer: renderProjectIdNavigator, },
  { headerName: "ITEM", field: "Item", resizable: true, minWidth: 150 },
  // { headerName: "ITEM NAME", field: "item_name", resizable: true, minWidth: 150 },
  {
    headerName: "BACK ORDERED",
    field: "backordered",
    resizable: true,
    minWidth: 150,
  },
  // {
  //   headerName: "REVENUE TYPE",
  //   field: "revenue_type",
  //   resizable: true,
  //   minWidth: 150,
  // },
  {
    headerName: "QUANTITY",
    field: "quantity",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Units",
    field: "units",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "DESCRIPTION",
    field: "description",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "PRICE LEVEL",
    field: "pricelevel",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "RATE", field: "Rate", resizable: true, minWidth: 150 },
  { headerName: "AMOUNT", field: "amount", resizable: true, minWidth: 150 },
  // { headerName: "JOB", field: "job", resizable: true, minWidth: 150 },
  // { headerName: "TOTAL", field: "amount", resizable: true, minWidth: 150 },
  { headerName: "TAX CODE", field: "tax_code", resizable: true, minWidth: 150 },
  { headerName: "TAX RATE", field: "tax_rate", resizable: true, minWidth: 150 },
  { headerName: "OPTIONS", field: "options", resizable: true, minWidth: 150 },
  {
    headerName: "DEPARTMENT",
    field: "department",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "SERVICE LINE",
    resizable: true,
    field: "serviceline",
    minWidth: 120,
  },
  {
    headerName: "EXCLUDE ITEM FROM RATE REQUEST",
    resizable: true,
    field: "exclude_itemfrom_raterequest",
    minWidth: 380,
  },
  {
    headerName: "CHARGE TYPE",
    field: "charge_type",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "CHARGES",
    field: "charge",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "DIRECTOR",
    resizable: true,
    field: "director",
    minWidth: 120,
  },
  { headerName: "VP", resizable: true, field: "vp", minWidth: 120 },
  {
    headerName: "EVP",
    resizable: true,
    field: "evp",
    minWidth: 120,
  },
  {
    headerName: "RELATED ASSET",
    field: "related_asset",
    resizable: true,
    minWidth: 150,
  },

  {
    headerName: "CHARGE DESCRIPTION",
    field: "charges_description",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "SHIP-TO ENTITY/USE CODE",
    field: "shiptousecode",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "ITEM NAME",
    field: "item_name",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "AVATAX AMOUNT",
    field: "tax_amount",
    resizable: true,
    minWidth: 150,
  },

  {
    headerName: "GOV CLIN #",
    field: "govt_clin#",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "HSN CODE", field: "hst_code", resizable: true, minWidth: 150 },
  {
    headerName: "CUSTOM DUTY RATE",
    field: "custom_duty_rate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "PRE-OWNED ITEM (2)",
    field: "pre_owned_item",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "VAT CODE", field: "vat_code", resizable: true, minWidth: 150 },
  {
    headerName: "TAX AMOUNT",
    field: "tax_amount",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "RENTAL AND LEASING TAX RATE",
    field: "rental_leasing_rate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "RENTAL AND LEASING TAX",
    field: "rental_leasing_tax",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "CUSTOMER INVOICE LINE ATTACHMENT",
    field: "customer_invoice_line_attachment_name",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "SHIP FROM VAT BIN",
    field: "ship_from_vat_bin",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "SHIP TO VAT BIN",
    field: "ship_to_vat_bin",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "BOTTLE TAX RATE",
    field: "bottle_tax_rate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "BOTTLE TAX",
    field: "bottle_tax",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "RECYCLING FEES RATE",
    field: "recycling_fees_rate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "RECYCLING FEES",
    field: "recycling_fees",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "HISTORY", field: "options", resizable: true, minWidth: 150 },
  {
    headerName: "SELECT TAX TYPE",
    field: "select_tax_type",
    resizable: true,
    minWidth: 150,
  },
];

export const CashSaleTransformationTable = [
  {
    headerName: "EDIT",
    resizable: true,
    field: "",
    minWidth: 140,
  },
  {
    headerName: "Document Number",
    resizable: true,
    field: "documentno",
    minWidth: 140,
  },
  {
    headerName: "DATE",
    resizable: true,
    field: "",
    minWidth: 90,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  { headerName: "TYPE", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "PC NUMBER",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "HEADER MEMO",
    resizable: true,
    field: "",
    minWidth: 140,
  },
  {
    headerName: "LINK DESCRIPTION",
    resizable: true,
    field: "",
    minWidth: 140,
  },
  {
    headerName: "GL ACCOUNT",
    resizable: true,
    field: "",
    minWidth: 140,
  },
  {
    headerName: "AMOUNT(DEBIT)",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "AMOUNT(CREDIT)",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];

export const invoiceSupportCasesTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "SUBJECT", resizable: true, field: "", minWidth: 120 },
  { headerName: "NUMBER", resizable: true, field: "", minWidth: 120 },
  { headerName: "STATUS", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "LAST MESSAGE DATE",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "PRIORITY", resizable: true, field: "", minWidth: 120 },
  { headerName: "ASSIGNED TO", resizable: true, field: "", minWidth: 120 },
  { headerName: "CONTACT", resizable: true, field: "", minWidth: 120 },
  {
    headerName: "ANTICIPATED PAYMENT DATE",
    resizable: true,
    field: "",
    minWidth: 200,
  },
  {
    headerName: "ANTICIPATED PAYMENT NOTES",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "PC/PROJECT", resizable: true, field: "", minWidth: 120 },
  { headerName: "REMOVE", resizable: true, field: "", minWidth: 140 },
];

export const ItemReceiptExpensetable = [
  { headerName: "ACCOUNT", resizable: true, field: "", minWidth: 120 },
  { headerName: "DESCRIPTION", resizable: true, field: "", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "", minWidth: 120 },
];
export const ItemReceiptItemsTable = [
  { headerName: "ITEM", resizable: true, field: "Item", minWidth: 300 },
  {
    headerName: "VENDOR NAME",
    resizable: true,
    field: "vendor_name",
    minWidth: 120,
  },
  // { headerName: "MFG. CATALOG NUMBER (NSC ITEM CODE)", resizable: true, field: "mfg_catalog_number", minWidth: 180 },
  {
    headerName: "DESCRIPTION",
    resizable: true,
    field: "description",
    minWidth: 180,
  },
  { headerName: "ON HAND", resizable: true, field: "on_hand", minWidth: 120 },
  { headerName: "QUANTITY", resizable: true, field: "quantity", minWidth: 120 },
  { headerName: "RATE", resizable: true, field: "rate", minWidth: 120 },
  { headerName: "CURRENCY", resizable: true, field: "currency", minWidth: 120 },
  {
    headerName: "TOTAL AMT",
    resizable: true,
    field: "totalamt",
    minWidth: 120,
  },
  { headerName: "UNITS", resizable: true, field: "units", minWidth: 120 },
  { headerName: "OPTIONS", resizable: true, field: "options", minWidth: 120 },
  {
    headerName: "MANUFACTURER CATALOG NUMBER",
    field: "mfg_catalog_number",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "GOVT CLIN #",
    resizable: true,
    field: "govt_clin",
    minWidth: 120,
  },
];

export const transactionTypeCustom = [
  {
    headerName: "View",
    resizable: true,
    field: "documentno",
    cellRenderer: renderNavigatorTranID,
    headerClass: "justify-center",
    cellClass: " text-center",
    maxWidth: 100,
  },
  {
    headerName: "Id",
    resizable: true,
    field: "id",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Payment Requesting Status",
    resizable: true,
    // sortable: true,
    field: "payment_request_status",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "Vendor",
    resizable: true,
    field: "vendor_name",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Amount",
    resizable: true,
    field: "amount",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Vendor Invoice No.",
    resizable: true,
    field: "vendor_invoice_number",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 100,
  },
  {
    headerName: "Pc/Project",
    resizable: true,
    field: "pc_project",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 150,
  },
  {
    headerName: "Request Date",
    resizable: true,
    field: "request_date",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 140,
  },
  {
    headerName: "Requested By",
    resizable: true,
    field: "requested_by",
    headerClass: "justify-center",
    cellClass: " text-center",
    minWidth: 140,
  },
  {
    headerName: "Stage 2 Approved By",
    resizable: true,
    field: "stage2_approved_by",
    minWidth: 240,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
];

export const quoteItemsTable = [
  { headerName: "ITEM", resizable: true, field: "Item", minWidth: 120 },

  { headerName: "QUANTITY", resizable: true, field: "quantity", minWidth: 120 },
  { headerName: "UNITS", resizable: true, field: "units", minWidth: 120 },
  {
    headerName: "DESCRIPTION",
    resizable: true,
    field: "description",
    minWidth: 250,
  },
  {
    headerName: "PRICE LEVEL",
    resizable: true,
    field: "pricelevel",
    minWidth: 120,
  },
  { headerName: "RATE", resizable: true, field: "item_rate", minWidth: 120 },
  { headerName: "TAX CODE", resizable: true, field: "tax_code", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "amount_exclude_tax", minWidth: 120 },
  { headerName: "JOB", resizable: true, field: "job", minWidth: 120 },
  { headerName: "TAX RATE", resizable: true, field: "tax_rate", minWidth: 120 },
  { headerName: "OPTIONS", resizable: true, field: "option", minWidth: 120 },
  {
    headerName: "PROJECT ITEM",
    resizable: true,
    field: "project_item",
    minWidth: 120,
  },

  {
    headerName: "BILLABLE ESTIMATE",
    field: "billable_estimate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "EXCLUDE ITEM FROM RATE REQUEST",
    resizable: true,
    field: "exclude_itemfrom_raterequest",
    minWidth: 380,
  },
  {
    headerName: "CHARGE TYPE",
    field: "charge_type",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "CHARGE TYPE",
    resizable: true,
    field: "charge_type",
    minWidth: 120,
  },
  {
    headerName: "DIRECTOR",
    resizable: true,
    field: "director",
    minWidth: 120,
  },

  { headerName: "VP", resizable: true, field: "vp", minWidth: 120 },
  {
    headerName: "EVP",
    resizable: true,
    field: "evp",
    minWidth: 120,
  },
  {
    headerName: "RELATED ASSET",
    field: "related_asset",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "CHARGE DESCRIPTION",
    resizable: true,
    field: "charges_description",
    minWidth: 120,
  },
  {
    headerName: "SHIP TO ENTITY/USE CODE",
    resizable: true,
    field: "shiptousecode",
    minWidth: 120,
  },

  {
    headerName: "ITEM NAME",
    resizable: true,
    field: "item_name",
    minWidth: 120,
  },
  {
    headerName: "AVATAX AMOUNT",
    field: "avatax_amount",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "GOV CLIN #",
    field: "giv_clin_#",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "HSN CODE", field: "hst_code", resizable: true, minWidth: 150 },
  {
    headerName: "CUSTOM DUTY RATE",
    field: "custom_duty_rate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "PRE-OWNED ITEM (2)",
    field: "pre_owned_item_2",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "VAT CODE", field: "vat_code", resizable: true, minWidth: 150 },
  {
    headerName: "TAX AMOUNT",
    field: "tax_amount",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "RENTAL AND LEASING TAX RATE",
    field: "rental_and_leasing_tax_rate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "RENTAL AND LEASING TAX",
    field: "rental_and_leasing_tax",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "CUSTOMER INVOICE LINE ATTACHMENT",
    field: "customer_invoice_line_attachment",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "SHIP FROM VAT BIN",
    field: "ship_from_vat_bin",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "SHIP TO VAT BIN",
    field: "ship_to_vat_bin",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "BOTTLE TAX RATE",
    field: "bottle_tax_rate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "BOTTLE TAX",
    field: "bottle_tax",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "RECYCLING FEES RATE",
    field: "recycling_fees_rate",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "RECYCLING FEES",
    field: "recycling_fees",
    resizable: true,
    minWidth: 150,
  },
  { headerName: "HISTORY", resizable: true, field: "history", minWidth: 120 },
  {
    headerName: "SELECTED TAX TYPE",
    resizable: true,
    field: "select_tax_type",
    minWidth: 120,
  },
];

export const QUOTESCEDULETable = [
  { headerName: "DATE", resizable: true, field: "date", minWidth: 120 },

  { headerName: "AMOUNT", resizable: true, field: "amount", minWidth: 120 },
];

export const invoiceExpenseReportTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "LINE ID", resizable: true, field: "", minWidth: 120 },
  { headerName: "DATE", resizable: true, field: "", minWidth: 120 },

  {
    headerName: "PERIOD",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "TYPE",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "DOCUMENT NUMBER",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "NAME",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "ACCOUNT", resizable: true, field: "", minWidth: 120 },
  { headerName: "MEMO", resizable: true, field: "", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "", minWidth: 120 },
];

export const invoiceRelatedExpenseReportTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "LINE ID", resizable: true, field: "", minWidth: 120 },
  { headerName: "DATE", resizable: true, field: "", minWidth: 120 },

  {
    headerName: "PERIOD",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "TYPE",
    resizable: true,
    field: "",
    minWidth: 120,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "DOCUMENT NUMBER",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  {
    headerName: "NAME",
    resizable: true,
    field: "",
    minWidth: 120,
  },
  { headerName: "ACCOUNT", resizable: true, field: "", minWidth: 120 },
  { headerName: "MEMO", resizable: true, field: "", minWidth: 120 },
  { headerName: "AMOUNT", resizable: true, field: "", minWidth: 120 },
];
export const invoiceRelatedExpenseReportAttachmentsTable = [
  { headerName: "EDIT", resizable: true, field: "", minWidth: 120 },
  { headerName: "ATTACHMENTS", resizable: true, field: "", minWidth: 120 },
];

export const GlobalSearchTable = [
  {
    headerName: "Doc No.",
    resizable: true,
    field: "tranid",
    minWidth: 220,
    cellRenderer: renderSearchNavigator,
  },

  {
    headerName: "Transaction Type",
    resizable: true,
    field: "transactiontype",
    minWidth: 100,
  },
];

export const CustomEmailMessageTable = [
  {
    headerName: "#",
    field: "count",
    resizable: true,
    minWidth: 80,
    cellRenderer: (params) => {
      return params.node.rowIndex + 1;
    },
  },
  {
    headerName: "View",
    resizable: true,
    field: "view",
    minWidth: 90,
    cellRenderer: renderViewNavigator,
    valueGetter: (params) => {
      return "View";
    },
  },
  {
    headerName: "DATE",
    resizable: true,
    field: "email_date",
    minWidth: 150,
    headerClass: "justify-right",
    cellClass: " text-right",
  },
  {
    headerName: "AUTHOR",
    resizable: true,
    field: "email_author",
    minWidth: 120,
  },
  {
    headerName: "PRIMARY RECIPIENT",
    resizable: true,
    field: "email_primary_receipient",
    minWidth: 150,
  },
  { headerName: "SUBJECT", resizable: true, field: "subject", minWidth: 400 },
  { headerName: "TYPE", resizable: true, field: "type", minWidth: 120 },
  { headerName: "FILES", resizable: true, field: "Files", minWidth: 120 },
  {
    headerName: "ATTACHMENTS",
    resizable: true,
    // field: "attachments",
    minWidth: 250,
    cellRenderer: renderTAbNavigator,
  },
  {
    headerName: "INTERNAL ONLY",
    resizable: true,
    field: "",
    cellRenderer: () => <p style={{ margin: 1 }}>Internal Only</p>,
    minWidth: 120,
  },
  {
    headerName: "REMOVE",
    resizable: true,
    field: "",
    cellRenderer: () => <p style={{ margin: 1 }}>Remove</p>,
    minWidth: 120,
  },
];

export const CustomMessageDialogAttachmentsTable = [
  {
    headerName: "ATTACHED FILES",
    resizable: true,
    field: "attachment_name",
    cellRenderer: renderTAbNavigator,
    minWidth: 220,
  },
  { headerName: "FOLDER", resizable: true, field: "Folder", minWidth: 230 },
  {
    headerName: "SIZE(KB)",
    resizable: true,
    field: "Size (KB)",
    minWidth: 100,
  },
  {
    headerName: "LAST MODIFIED",
    resizable: true,
    field: "Last Modified",
    minWidth: 150,
  },
  {
    headerName: "DOCUMENT TYPE",
    resizable: true,
    field: "Type",
    minWidth: 120,
  },
  {
    headerName: "REMOVE",
    resizable: true,
    field: "remove",
    minWidth: 120,
    cellRenderer: () => <p style={{ margin: 1 }}>Remove</p>,
  },
  {
    headerName: "EDIT",
    resizable: true,
    field: "",
    minWidth: 120,
    cellRenderer: () => <p style={{ margin: 1 }}>Edit</p>,
  },
  {
    headerName: "DOWNLOAD",
    cellRenderer: () => (
      <Button sx={{ margin: 1, color: "#0066b2" }}>
        {" "}
        <DownloadIcon />
      </Button>
    ),
    resizable: true,
    field: "file_attachment_id",
    maxWidth: 120,
  },
  // { headerName: "DOWNLOAD", resizable: true, field: "", minWidth: 120 },
];
